// This file is auto-generated by CreateTranslations.ps1. Texts are edited in the TermManager.

export default {
    'ca-ES': {
        Add_alternative: 'Afegeix una alternativa',
        Add_question: 'Afegeix una pregunta',
        Add_question_x: 'Afegeix una pregunta {0}',
        Add_statement: 'Afegeix una declaració',
        Agreement: 'Acord',
        Agreement_Agree: 'D’acord',
        Agreement_Disagree: 'En desacord',
        Agreement_Neither_Agree_Nor_Disagree: 'Ni d\'acord ni en desacord',
        Agreement_Strongly_Agree: 'Totalment d\'acord',
        Agreement_Strongly_Disagree: 'Totalment en desacord',
        Allow_respondents_to_select_more_than_one_alternative: 'Permet als estudiants seleccionar més d\'una alternativa',
        Alternative_x: 'Alternativa {0}',
        Alternatives: 'Alternatives',
        Alternatives_columns: 'Alternatives (columnes)',
        Anonymous: 'Anònima',
        Anonymous_responses: 'Anònima',
        Answer_type: 'Tipus de resposta',
        Answer_was_cleared: 'La resposta s’ha aclarit',
        Ask_our_AI_info_message: 'Demana al nostre robot d’intel·ligència artificial (IA) que et generi l’enquesta. Per defecte obtindràs una introducció i preguntes d’opció múltiple. Pots revisar i editar l’enquesta un cop generada. Consulta els consells següents per obtenir-ne més informació.',
        Autoloading: 'Càrrega automàtica',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Torna al llistat de preguntes',
        Back_to_responses: 'Torna a les respostes',
        Back_to_survey_details: 'Torna als detalls de l\'enquesta',
        Cancel: 'Cancel·la',
        Clear_answer: 'Esborra la resposta',
        Close: 'Tanca',
        Continue_survey: 'Continua l\'enquesta',
        Copy_public_link: 'Copia l\'enllaç públic',
        Copy_QR_code: 'Copia el codi QR',
        Create_survey: 'Crea una enquesta',
        Create_survey_with_AI: 'Crea una enquesta amb IA',
        Custom: 'Personalitza',
        DateFormat_just_now: 'Ara mateix',
        DateFormat_one_hour_ago: 'Fa 1 hora',
        DateFormat_one_minute_ago: 'Fa 1 minut',
        DateFormat_weekday_x_at_y: '{0}, a les {1}',
        DateFormat_x_days_ago: 'fa {0} dies',
        DateFormat_x_hours_ago: 'Fa {0} hores',
        DateFormat_x_minutes_ago: 'Fa {0} minuts',
        DateFormat_yesterday_at_x: 'Ahir a les {0}',
        Deadline_has_passed_message: 'La data d’entrega s’ha superat i ja no pots enviar cap resposta. Pots continuar més tard si s\'amplia la data d’entrega.',
        Delete: 'Elimina',
        Delete_questions_modal_title: 'Vols eliminar les preguntes seleccionades?',
        Delete_responses: 'Vols suprimir les respostes?',
        Download_responses: 'Descarrega les respostes (Excel)',
        Edit_question: 'Edita la pregunta',
        Edit_question_x_of_y: 'Edita la pregunta {0} de {1}',
        Edit_settings_info: 'No es pot editar la configuració anònima després que algú hagi iniciat l\'enquesta.',
        Edit_survey: 'Edita l\'enquesta',
        Element_has_been_moved_to_position_x_of_y: 'L\'element s\'ha desplaçat a la posició {0} de {1}',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'Encara no hi ha respostes',
        Empty_state_no_responses_text: 'Les respostes apareixeran aquí un cop algú comenci a fer l\'enquesta.',
        Empty_survey_input_message: 'Has d’escriure de què tracta l’enquesta.',
        Evaluation_of_the_teaching: 'avaluació dels mètodes docents a classe de ciències',
        Exit_preview: 'Surt de la vista prèvia',
        Exit_survey: 'Vols sortir de l’enquesta?',
        Exit_survey_button: 'Surt de l’enquesta',
        External_and_anonymous: 'Externes i anònimes. Qualsevol persona que tingui un enllaç pot contestar-la.',
        External_survey: 'Externa: qualsevol persona amb l\'enllaç pot contestar-la',
        Frequency: 'Freqüència',
        Frequency_Always: 'Sempre',
        Frequency_Never: 'Mai',
        Frequency_Often: 'Sovint',
        Frequency_Rarely: 'Rarament',
        Frequency_Sometimes: 'De vegades',
        Friday: 'Divendres',
        Generate_survey: 'Genera l’enquesta',
        Grid_no_questions_heading: 'No hi ha preguntes',
        Grid_no_questions_text: 'Encara no has creat cap pregunta.',
        Homework_habits: 'hàbits sobre deures a casa',
        How_does_this_work: 'Com funciona això?',
        How_does_this_work_info_part1: 'La teva aportació s’utilitza com a part de la sol·licitud que enviem per processar-la. A partir de la resposta, generem una enquesta amb una introducció i preguntes d’opció múltiple amb 5 respostes alternatives (de «totalment d’acord» a «totalment en desacord»). Podràs editar i ajustar tot el contingut abans de distribuir l’enquesta.',
        How_does_this_work_info_part2: 'itslearning no es fa responsable del contingut de l’enquesta generada. No moderem la resposta del servei d’IA, que pot produir informació inexacta sobre persones, llocs o fets. El servei al qual ens connectem el proporciona OpenAI, mitjançant la versió de xat GPT-3.5-turbo.',
        Importance: 'Importància',
        Importance_Extremely_Important: 'Extremadament important',
        Importance_Moderately_Important: 'Moderadament important',
        Importance_Not_At_All_Important: 'Gens important',
        Importance_Slightly_Important: 'Lleugerament important',
        Importance_Very_Important: 'Molt important',
        Imported_rich_text_edit_warning: 'Aquest text s\'ha importat de l\'antiga eina d\'enquesta. Quan ho desis, se suprimirà tot el contingut de format i text enriquit (per exemple, imatges).',
        Introduction: 'Introducció',
        Link_copied_to_clipboard: 'Enllaç copiat al porta-retalls',
        Link_to_survey: 'Enllaç a l\'enquesta',
        Matrix_question: 'Pregunta de matriu',
        Monday: 'Dilluns',
        Move_element_instructions: 'Per moure aquest element, prem espai i utilitza la fletxa amunt o avall. Torna a prémer espai per completar-lo.',
        Moving_element_to_position_x_of_y: 'S’està movent l’element a la posició {0} de {1}',
        Multiple_choice_question: 'Pregunta d\'opció múltiple',
        Next: 'Següent',
        No: 'No',
        No_respondents: 'No hi ha enquestats',
        Not_anonymous: 'No anònima',
        Not_possible_to_edit_questions_message: 'Ja no pots afegir, editar ni suprimir preguntes perquè algú ha començat a contestar aquesta enquesta.',
        Note: 'Nota',
        Number_of_questions: 'Nombre de preguntes',
        Number_of_respondents_x: 'Nombre d\'enquestats: {0}',
        Number_responded_x: 'Número de resposta: {0}',
        Numbers: 'Números',
        Ok: 'D\'acord',
        Open_answer_heading: 'Resposta',
        Open_question: 'Pregunta oberta',
        Personal_data_warning: 'No introdueixis cap informació personal o amb drets d’autor. La teva aportació l’envia itslearning fora de la UE per al seu tractament. Consulta «Com funciona això» per obtenir-ne més informació.',
        Preview_survey: 'Visualització prèvia de l\'enquesta',
        Previous: 'Anterior',
        Print: 'Imprimeix',
        QR_code: 'Codi QR',
        QR_code_copied_to_clipboard: 'Imatge de codi QR copiada al porta-retalls',
        Quality: 'Qualitat',
        Quality_Excellent: 'Excel·lent',
        Quality_Fair: 'Suficient',
        Quality_Good: 'Bé',
        Quality_Poor: 'Deficient',
        Quality_Very_Poor: 'Molt deficient',
        Question: 'Pregunta',
        Question_has_been_saved: 'S\'ha desat la pregunta',
        Question_type: 'Tipus de pregunta',
        Question_type_short: 'Tipus',
        Question_x: 'Pregunta {0}',
        Question_x_of_y: 'Pregunta {0} de {1}',
        Questions: 'Preguntes',
        QuestionType_MultipleChoice_short: 'Opció múltiple',
        QuestionType_YesNo_short: 'Sí/No',
        Remember_visible: 'Recorda que l’enquesta ha de ser visible per a les persones enquestades.',
        Remember_visible_and_deadline: 'Recorda que l’enquesta ha de ser visible per a les persones enquestades i el termini ha de ser en el futur.',
        Remove_alternative_x: 'Elimina l\'alternativa {0}',
        Remove_statement_x: 'Suprimeix la declaració {0}',
        Respondent: 'Enquestat',
        Responses: 'Resposta',
        Responses_summary: 'Resum',
        Responses_x: 'Respostes: {0}',
        Satisfaction: 'Satisfacció',
        Satisfaction_Completely_Satisfied: 'Completament satisfet',
        Satisfaction_Moderately_Satisfied: 'Moderadament satisfet',
        Satisfaction_Not_At_All_Satisfied: 'Gens satisfet',
        Satisfaction_Slightly_Satisfied: 'Lleugerament satisfet',
        Satisfaction_Very_Satisfied: 'Molt satisfet',
        Saturday: 'Dissabte',
        Save: 'Desa',
        Save_and_new: 'Desa i vés a una nova',
        Search: 'Cerca',
        Search_for_respondents: 'Cerca enquestats',
        Select_a_response_to_delete: 'Selecciona una resposta per eliminar-la',
        Select_all_questions: 'Selecciona totes les preguntes',
        Select_at_least_one_question_to_delete: 'Selecciona almenys una pregunta per suprimir',
        Select_question_x: 'Selecciona la pregunta {0}',
        Share: 'Comparteix',
        Share_survey: 'Comparteix l\'enquesta',
        Show_more: 'Mostra\'n més',
        Show_response: 'Mostra la teva resposta',
        Showing_x_responses_of_total_y_responses: 'S’estan mostrant {0} respostes d’un total de {1}',
        Start_moving_element_x: 'Comença a moure l\'element: {0}',
        Started: 'Iniciats',
        Statement_x: 'Declaració {0}',
        Statements_rows: 'Declaracions (files)',
        Student_satisfaction_cafeteria: 'satisfacció dels estudiants amb les opcions de menú a la cafeteria',
        Submit_answer: 'Envia la resposta',
        Submitted: 'S’ha enviat',
        Submitted_after_deadline: 'Enviat després de la data límit',
        Sunday: 'Diumenge',
        Survey: 'Enquesta',
        Survey_inactive_message: 'Aquesta enquesta ja no està disponible. Pots continuar més tard si torna a estar disponible.',
        Survey_start_page: 'Pàgina d\'inici de l\'enquesta',
        Survey_title: 'Enquesta',
        Survey_type: 'Tipus d\'enquesta',
        Take_survey: 'Respon a l’enquesta',
        Thanks_for_taking_the_survey: 'Gràcies per fer l\'enquesta!',
        The_survey_is_about: 'L’enquesta tracta sobre',
        Thursday: 'Dijous',
        Tips_and_examples: 'Consells i exemples',
        Tips_and_examples_info: 'Per obtenir un resultat útil del servei d’IA, fes que l’aportació sigui breu i concisa. No escriguis «Aquesta és una enquesta sobre...» ja que això ja està inclòs en el text que enviem. Exemples d’aportació podrien ser:',
        Tuesday: 'Dimarts',
        Unknown_error: 'Alguna cosa ha anat malament. Els possibles motius poden ser problemes amb el nostre servei, que algú estigui editant l\'enquesta o que la teva xarxa sigui inestable. Si la teva connexió és correcta i continues veient aquest missatge, posa’t en contacte amb l\'administrador.',
        View_question_x_of_y: 'Mostra la pregunta {0} de {1}',
        Wednesday: 'Dimecres',
        Yes: 'Sí',
        Yes_no_question: 'Pregunta directa',
        Your_response_will_not_be_saved: 'La teva resposta no es guardarà.',
    },
    'co-FR': {
        Add_alternative: 'Aghjunghje una alternativa',
        Add_question: 'Aghjunghje una quistione',
        Add_question_x: 'Aghjunghje quistione {0}',
        Add_statement: 'Aghjunghje una furmulazione',
        Agreement: 'Accunsentu',
        Agreement_Agree: 'Accunsentu',
        Agreement_Disagree: 'Disaccordu',
        Agreement_Neither_Agree_Nor_Disagree: 'Nè accunsentu nè disaccordu',
        Agreement_Strongly_Agree: 'Accunsentu forte',
        Agreement_Strongly_Disagree: 'Disaccordu forte',
        Allow_respondents_to_select_more_than_one_alternative: 'Permette à quelli chì rispondenu di selezziunà più d\'una alternativa',
        Alternative_x: 'Alternativa {0}',
        Alternatives: 'Alternative',
        Alternatives_columns: 'Alternative (culonne)',
        Anonymous: 'Anonimu',
        Anonymous_responses: 'Anonimu',
        Answer_type: 'Risposta mudellu',
        Answer_was_cleared: 'A risposta hè stata sguassata',
        Ask_our_AI_info_message: 'Dumandate à u nostru autumatu d’ intelligenza artificiale (AI) di pruduce u sundagiu per voi. In mancanza di megliu, vi buscherete un introitu è quistione à scelte plurale. Pudite riesaminà è mudificà u sundagiu una volta ch’ellu hè statu pruduttu. Vede i cunsiglii custì sottu per più detagli.',
        Autoloading: 'Autocaricamentu',
        Avatar: 'Avataru',
        Back_to_list_of_questions: 'Vultà à lista di questione',
        Back_to_responses: 'Vultà à e risposte',
        Back_to_survey_details: 'Vultà à detagli di u sundagiu',
        Cancel: 'Annullà',
        Clear_answer: 'squassà a risposta',
        Close: 'Chjode',
        Continue_survey: 'Cuntinuà u sundagiu',
        Copy_public_link: 'Cupià u ligame publicu',
        Copy_QR_code: 'Cupià u codice QR',
        Create_survey: 'Creà un sundagiu',
        Create_survey_with_AI: 'Creà un sundagiu cù AI',
        Custom: 'Parsunalizà',
        DateFormat_just_now: 'Propiu avà',
        DateFormat_one_hour_ago: '1 ora fà',
        DateFormat_one_minute_ago: '1 minutu fà',
        DateFormat_weekday_x_at_y: '{0} à {1}',
        DateFormat_x_days_ago: '{0} ghjorni fà',
        DateFormat_x_hours_ago: '{0} ore fà',
        DateFormat_x_minutes_ago: '{0} minuti fà',
        DateFormat_yesterday_at_x: 'Arimane à {0}',
        Deadline_has_passed_message: 'A data limitativa hè trapassata, è ùn avite più u permessu di rende a vostra risposta. Puderete cuntinuà più tardi s\'è a data limitative hè prulungata.',
        Delete: 'Distrughje',
        Delete_questions_modal_title: 'Distrughje e quistione selezziunate?',
        Delete_responses: 'Distrughje risposte?',
        Download_responses: 'Caricà e risposte (Excel)',
        Edit_question: 'Mudificà a quistione',
        Edit_question_x_of_y: 'Mudificà a quistione {0} di {1}',
        Edit_settings_info: 'Ùn hè pussibule di mudificà i parametri anonimi dopu chì qualchissia abbia principiatu u sundagiu.',
        Edit_survey: 'Mudificà u sundagiu',
        Element_has_been_moved_to_position_x_of_y: 'L\'elemente hè statu tramutatu in a pusizione {0} di {1}',
        Emojis: 'Faccette',
        Empty_state_no_responses_heading: 'Nisuna risposta per avà',
        Empty_state_no_responses_text: 'E risposte si videranu quì tempu chì qualchissia principia à risponde à u sundagiu.',
        Empty_survey_input_message: 'Vi ci vole à scrive u sughjettu di u sundagiu.',
        Evaluation_of_the_teaching: 'valutazione di i modi d\'insignamentu in a classe di scienze',
        Exit_preview: 'Andassine da vista capunanzu',
        Exit_survey: 'Andassine da u sundagiu?',
        Exit_survey_button: 'Andassine da u sundagiu',
        External_and_anonymous: 'Esternu è anonimu. Qualvogliasia cù un ligame pò risponde.',
        External_survey: 'Esternu - qualvogliasia cù un ligame pò risponde',
        Frequency: 'Frequenza',
        Frequency_Always: 'Sempre',
        Frequency_Never: 'Mai',
        Frequency_Often: 'Spessu',
        Frequency_Rarely: 'Di radu',
        Frequency_Sometimes: 'Qualchi volta',
        Friday: 'Vennari',
        Generate_survey: 'Pruduce un sundagiu',
        Grid_no_questions_heading: 'Nisuna quistione',
        Grid_no_questions_text: 'Ùn avete creatu nisuna quistione per avà.',
        Homework_habits: 'abitudine di travagliu in casa',
        How_does_this_work: 'Cumu funziona questu ?',
        How_does_this_work_info_part1: 'I vostri dati da trattà sò aduprati cum\'è parte di a guida chè no mandemu per u trattamentu. Centratu nantu à a risposta, pruducimu un sundagiu cù un introitu è quistione a scelte plurale  cù 5 alternative di risposta (da "in accunsentu forte" à "in cuntrastu forte"). Puderete mudificà è accuncià tuttu u cuntenutu prima di distribuisce u sundagiu.',
        How_does_this_work_info_part2: 'itslearning ùn hè micca rispunsevule di u cuntenutu di u sundagiu pruduttu. Ùn avemu micca affrinatu a risposta da u serviziu AI, chì pò pruduce infurmazione disadatte nantu à a ghjente, i lochi o i fatti. U serviziu chè no cunnettemu hè furnitu da OpenAI, aduprentu u mudellu di chat GPT-3.5-turbo.',
        Importance: 'Impurtanza',
        Importance_Extremely_Important: 'Più chè più impurtante',
        Importance_Moderately_Important: 'Impurtante ma cù misuru',
        Importance_Not_At_All_Important: 'Mancu appena impurtante',
        Importance_Slightly_Important: 'Appinuccia impurtante',
        Importance_Very_Important: 'Impurtante assai',
        Imported_rich_text_edit_warning: 'Stu testu hè statu impurtatu da u vechju arnese di sundagiu. Quand\'è vo registrate, ogni cuntenutu assestatu è inricchitu di testu (maghjine per indettu) sarà cacciatu.',
        Introduction: 'Introitu',
        Link_copied_to_clipboard: 'Ligame cupiatu in u fermacarta',
        Link_to_survey: 'Ligame cù u sundagiu',
        Matrix_question: 'Quistione matriziale',
        Monday: 'Luni',
        Move_element_instructions: 'Per tramutà quessu l\'elemente, appughjàu tastu spaziu è aduprà a frezza versu l\'insù o quella versu l\'inghjò. Appughjà torna u tastu spaziu per compie.',
        Moving_element_to_position_x_of_y: 'In traccia di tramutà l\'elemente in pusizione {0} di {1}',
        Multiple_choice_question: 'Quistione à scelte plurale',
        Next: 'Prossimu',
        No: 'Nò',
        No_respondents: 'Nimu ùn  hà rispostu',
        Not_anonymous: 'Micca anonimu',
        Not_possible_to_edit_questions_message: 'Ùn pudite più nè aghjunghje, nè mudificà o distrughje quistione perchè qualchissia hà principiatu à risponde à u sundagiu.',
        Note: 'Nota',
        Number_of_questions: 'Numeru di quistione',
        Number_of_respondents_x: 'Numeru di quelli chì anu rispostu: {0}',
        Number_responded_x: 'Numeru risposti: {0}',
        Numbers: 'Numeri',
        Ok: 'Iè',
        Open_answer_heading: 'Risposta',
        Open_question: 'Quistione aparta',
        Personal_data_warning: 'Ùn mintuvate micca infurmazione persunale o sottu à copyright. I vostri dati da trattà sò mandati da itslearning fora di l\'UE per trattamentu. Vede "Cumu funziona questu" per più detagli.',
        Preview_survey: 'Vista capunanzu di u sundagiu',
        Previous: 'Prima',
        Print: 'Stampà',
        QR_code: 'Codice QR',
        QR_code_copied_to_clipboard: 'A maghjina di u codice QR hè stata cupiata in u fermacarta',
        Quality: 'Qualità',
        Quality_Excellent: 'Bunissimu',
        Quality_Fair: 'Ghjustu',
        Quality_Good: 'Bonu',
        Quality_Poor: 'Debbule',
        Quality_Very_Poor: 'Debbule debbule',
        Question: 'Quistione',
        Question_has_been_saved: 'A quistione hè stata registrata.',
        Question_number_header: 'Numeru di quistione',
        Question_type: 'generu di quistione',
        Question_type_short: 'Mudellu',
        Question_x: 'Quistione {0}',
        Question_x_of_y: 'Quistione {0} di {1}',
        Questions: 'Quistione',
        QuestionType_MultipleChoice_short: 'Scelte numerose',
        QuestionType_YesNo_short: 'Iè/Nò',
        Remember_visible: 'Ricurdatevi chì u sundagiu deve esse visibile da i rispunditori.',
        Remember_visible_and_deadline: 'Ricurdatevi chì u sundagiu deve esse visibile da i rispunditori è chì a so scadenza deve esse in u futuru.',
        Remove_alternative_x: 'Caccià l\'alternativa {0}',
        Remove_statement_x: 'Caccià l\'osservazione {0}',
        Respondent: 'Parsona intarrugata',
        Responses: 'Risposte',
        Responses_summary: 'Riassuntu',
        Responses_x: 'Risposte: {0}',
        Satisfaction: 'Suddisfazione',
        Satisfaction_Completely_Satisfied: 'Suddesfu affattu',
        Satisfaction_Moderately_Satisfied: 'Suddesfu ma cù misuru',
        Satisfaction_Not_At_All_Satisfied: 'Mancu appena suddesfu',
        Satisfaction_Slightly_Satisfied: 'Appinuccia suddesfu',
        Satisfaction_Very_Satisfied: 'Suddesfu assai',
        Saturday: 'Sabatu',
        Save: 'Cautà',
        Save_and_new: 'Arrigistrà è una altra',
        Search: 'Ricercà',
        Search_for_respondents: 'Ricercà quelli chì rispondenu',
        Select_a_response_to_delete: 'Selezziunà a risposta da distrughje',
        Select_all_questions: 'Selezziunà tutte e questione',
        Select_at_least_one_question_to_delete: 'Selezziunà omancu una quistione da distrughje.',
        Select_question_x: 'Selezziunà a quistione {0}',
        Share: 'Sparte',
        Share_survey: 'Sparte u sundagiu',
        Show_more: 'Fà vede di più',
        Show_response: 'Mustrà a vostra risposta',
        Showing_x_responses_of_total_y_responses: 'Mustrendu {0} risposte di a somma di {1} risposte',
        Start_moving_element_x: 'Principià à tramutà l\'elemente: {0}',
        Started: 'Iniziatu',
        Statement_x: 'Osservazione {0}',
        Statements_rows: 'Osservazione (ranghi)',
        Student_satisfaction_cafeteria: 'suddisfazione di i studienti cù l\'ozzione di u listinu à a cafeteria',
        Submit_answer: 'Prupone risposte',
        Submitted: 'Rimessu',
        Submitted_after_deadline: 'Rimessu à termine scadutu',
        Sunday: 'Dumenica',
        Survey: 'Sundagiu',
        Survey_inactive_message: 'Stu sundagiu ùn hè più dispunibule. Puderete cuntinuà più tardi s\'ellu diventa torna dispunibule.',
        Survey_start_page: 'Pagina di principiu di u sundagiu',
        Survey_title: 'Sundagiu',
        Survey_type: 'Sundagiu mudellu',
        Take_survey: 'Rispondite à u sundagiu',
        Thanks_for_taking_the_survey: 'À ringraziavvi d\'avè rispostu à u sundagiu!',
        The_survey_is_about: 'U sundagiu riguarda à',
        Thursday: 'Ghjovi',
        Tips_and_examples: 'Cunsiglii è esempii',
        Tips_and_examples_info: 'Per uttene una pruduzione ghjuvativa da u serviziu AI, tenite contu di dati da trattà chì sianu brevi è cuncisi. Ùn scrivite micca "Questu hè un sundagiu nantu à ..." perchè hè digià inclusu in u testu chì no mandemu. Esempii di dati da trattà ponu esse :',
        Tuesday: 'Marti',
        Unknown_error: 'Qualcosa hà giratu male. Pussibuli mutivi ponu esse prublemi in lea cù u nostru serviziu, o chì qualchissia abbia mudificatu u sundagiu o chì u vostru retale sia pocu stabule. S\'è a vosta cunnessione hè bona è s\'è vo ricevite sempre stu missaghju, per piacè cuntattate u vostru amministradore.',
        View_question_x_of_y: 'Vede a quistione {0} di {1}',
        Wednesday: 'Marcuri',
        Yes: 'Iè',
        Yes_no_question: 'Quistione Iè/Nò',
        Your_response_will_not_be_saved: 'A vostra risposta ùn sarà registrata.',
    },
    'da-DK': {
        Add_alternative: 'Tilføj alternativ',
        Add_question: 'Tilføj spørgsmål',
        Add_question_x: 'Tilføj spørgsmål {0}',
        Add_statement: 'Tilføj udsagn',
        Agreement: 'Aftale',
        Agreement_Agree: 'Enig',
        Agreement_Disagree: 'Uenig',
        Agreement_Neither_Agree_Nor_Disagree: 'Hverken enig eller uenig',
        Agreement_Strongly_Agree: 'Meget enig',
        Agreement_Strongly_Disagree: 'Meget uenig',
        Allow_respondents_to_select_more_than_one_alternative: 'Tillad svarende at vælge mere end ét alternativ',
        Alternative_x: 'Alternativ {0}',
        Alternatives: 'Alternativer',
        Alternatives_columns: 'Alternativer (kolonner)',
        Anonymous: 'Anonym',
        Anonymous_responses: 'Anonym',
        Answer_type: 'Svartype',
        Answer_was_cleared: 'Svaret blev ryddet',
        Ask_our_AI_info_message: 'Bed vores robot for kunstig intelligens (AI) om at generere undersøgelsen for dig. Som standard får du en introduktion og spørgsmål med flere svarmuligheder. Du kan gennemse og redigere undersøgelsen, når den er genereret. Se tips nedenfor for at få flere detaljer.',
        Autoloading: 'Automatisk indlæsning',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Tilbage til listen med spørgsmål',
        Back_to_responses: 'Tilbage til svar',
        Back_to_survey_details: 'Tilbage til undersøgelsesdetaljer',
        Cancel: 'Annullér',
        Clear_answer: 'Ryd svar',
        Close: 'Luk',
        Continue_survey: 'Fortsæt undersøgelse',
        Copy_public_link: 'Kopiér offentligt link',
        Copy_QR_code: 'Kopiér QR-kode',
        Create_survey: 'Opret undersøgelse',
        Create_survey_with_AI: 'Opret undersøgelse med AI',
        Custom: 'Brugerdefineret',
        DateFormat_just_now: 'Lige nu',
        DateFormat_one_hour_ago: 'For 1 time siden',
        DateFormat_one_minute_ago: 'For 1 minut siden',
        DateFormat_weekday_x_at_y: '{0} kl. {1}',
        DateFormat_x_days_ago: '{0} dage siden',
        DateFormat_x_hours_ago: '{0} timer siden',
        DateFormat_x_minutes_ago: '{0} minutter siden',
        DateFormat_yesterday_at_x: 'I går kl. {0}',
        Deadline_has_passed_message: 'Deadline er overskredet, og du må ikke længere indsende et svar. Du kan fortsætte senere, hvis deadline forlænges.',
        Delete: 'Slet',
        Delete_questions_modal_title: 'Slet de markerede spørgsmål?',
        Delete_responses: 'Slet svar?',
        Download_responses: 'Download svar (Excel)',
        Edit_question: 'Rediger spørgsmål',
        Edit_question_x_of_y: 'Rediger spørgsmål {0} af {1}',
        Edit_settings_info: 'Det er ikke muligt at redigere de anonyme indstillinger, når nogen har startet undersøgelsen.',
        Edit_survey: 'Rediger undersøgelse',
        Element_has_been_moved_to_position_x_of_y: 'Element er blevet flyttet til position {0} af {1}',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'Endnu ingen svar',
        Empty_state_no_responses_text: 'Svar vises her, når nogen begynder at deltage i undersøgelsen.',
        Empty_survey_input_message: 'Du skal skrive, hvad undersøgelsen handler om.',
        Evaluation_of_the_teaching: 'evaluering af undervisningsmetoder i naturfagsklassen',
        Exit_preview: 'Afslut visning',
        Exit_survey: 'Afslut undersøgelse?',
        Exit_survey_button: 'Afslut undersøgelse',
        External_and_anonymous: 'Ekstern og anonym. Alle med et link kan svare.',
        External_survey: 'Ekstern – alle med linket kan svare',
        Frequency: 'Frekvens',
        Frequency_Always: 'Altid',
        Frequency_Never: 'Aldrig',
        Frequency_Often: 'Ofte',
        Frequency_Rarely: 'Sjældent',
        Frequency_Sometimes: 'Undertiden',
        Friday: 'Fredag',
        Generate_survey: 'Generer undersøgelse',
        Grid_no_questions_heading: 'Ingen spørgsmål',
        Grid_no_questions_text: 'Du har endnu ikke oprettet spørgsmål.',
        Homework_habits: 'lektievaner',
        How_does_this_work: 'Hvordan fungerer det?',
        How_does_this_work_info_part1: 'Dit input bruges som en del af det, vi sender til behandling. På baggrund af svaret genererer vi en undersøgelse med en introduktion og spørgsmål med 5 svarmuligheder (fra "meget enig" til "meget uenig"). Du kan redigere og justere alt indhold, før du udsender undersøgelsen.',
        How_does_this_work_info_part2: 'itslearning er ikke ansvarlig for indholdet i den genererede undersøgelse. Vi modererer ikke svaret fra AI-tjenesten, hvilket kan give unøjagtige oplysninger om personer, steder eller fakta. Den tjeneste, vi opretter forbindelse til, leveres af OpenAI ved hjælp af chatmodellen GPT-3.5-turbo.',
        Importance: 'Vigtighed',
        Importance_Extremely_Important: 'Ekstremt vigtigt',
        Importance_Moderately_Important: 'Moderat vigtigt',
        Importance_Not_At_All_Important: 'Slet ikke vigtigt',
        Importance_Slightly_Important: 'Lidt vigtigt',
        Importance_Very_Important: 'Meget vigtigt',
        Imported_rich_text_edit_warning: 'Denne tekst blev importeret fra det gamle undersøgelsesværktøj. Når du gemmer, fjernes al formatering og formateret indhold (f.eks. billeder).',
        Introduction: 'Introduktion',
        Link_copied_to_clipboard: 'Link kopieret til udklipsholder',
        Link_to_survey: 'Link til undersøgelse',
        Matrix_question: 'Matrixspørgsmål',
        Monday: 'Mandag',
        Move_element_instructions: 'For at flytte dette element skal du trykke på mellemrum og bruge pil op eller pil ned. Tryk på mellemrum igen for at fuldføre.',
        Moving_element_to_position_x_of_y: 'Flytning af element til position {0} af {1}',
        Multiple_choice_question: 'Spørgsmål med flere svarmuligheder',
        Next: 'Næste',
        No: 'Nej',
        No_respondents: 'Ingen svarende',
        Not_anonymous: 'Ikke anonym',
        Not_possible_to_edit_questions_message: 'Du kan ikke længere tilføje, redigere eller slette spørgsmål, fordi nogen er begyndt at deltage i denne undersøgelse.',
        Note: 'Notat',
        Number_of_questions: 'Antal spørgsmål',
        Number_of_respondents_x: 'Antal svarende: {0}',
        Number_responded_x: 'Antal svarende: {0}',
        Numbers: 'Tal',
        Ok: 'OK',
        Open_answer_heading: 'Svar',
        Open_question: 'Åbent spørgsmål',
        Personal_data_warning: 'Indtast ikke personlige eller ophavsretligt beskyttede oplysninger. Dit input sendes fra itslearning uden for EU til behandling. Se "Sådan fungerer det" for at få flere oplysninger.',
        Preview_survey: 'Vis undersøgelse',
        Previous: 'Forrige',
        Print: 'Udskriv',
        QR_code: 'QR-kode',
        QR_code_copied_to_clipboard: 'QR-kodebillede blev kopieret til Udklipsholder',
        Quality: 'Kvalitet',
        Quality_Excellent: 'Fortrinlig',
        Quality_Fair: 'Rimelig',
        Quality_Good: 'God',
        Quality_Poor: 'Dårlig',
        Quality_Very_Poor: 'Meget dårlig',
        Question: 'Spørgsmål',
        Question_has_been_saved: 'Spørgsmålet er blevet gemt.',
        Question_number_header: 'Spørgsmålsnummer',
        Question_type: 'Spørgsmålstype',
        Question_type_short: 'Type',
        Question_x: 'Spørgsmål {0}',
        Question_x_of_y: 'Spørgsmål {0} af {1}',
        Questions: 'Spørgsmål',
        QuestionType_MultipleChoice_short: 'Flere svarmuligheder',
        QuestionType_YesNo_short: 'Ja/nej',
        Remember_visible: 'Husk, at undersøgelsen skal være synlig for dem, der svarer.',
        Remember_visible_and_deadline: 'Husk, at undersøgelsen skal være synlig for dem, der svarer, og at fristen skal ligge i fremtiden.',
        Remove_alternative_x: 'Fjern alternativ {0}',
        Remove_statement_x: 'Fjern udsagn {0}',
        Respondent: 'Svarperson',
        Responses: 'Svar',
        Responses_summary: 'Resumé',
        Responses_x: 'Svar: {0}',
        Satisfaction: 'Tilfredshed',
        Satisfaction_Completely_Satisfied: 'Helt tilfreds',
        Satisfaction_Moderately_Satisfied: 'Moderat tilfreds',
        Satisfaction_Not_At_All_Satisfied: 'Slet ikke tilfreds',
        Satisfaction_Slightly_Satisfied: 'Lidt tilfreds',
        Satisfaction_Very_Satisfied: 'Meget tilfreds',
        Saturday: 'Lørdag',
        Save: 'Gem',
        Save_and_new: 'Gem og opret nyt',
        Search: 'Søg',
        Search_for_respondents: 'Søg efter svarende',
        Select_a_response_to_delete: 'Vælg et svar, der skal slettes',
        Select_all_questions: 'Vælg alle spørgsmål',
        Select_at_least_one_question_to_delete: 'Vælg mindst ét spørgsmål, der skal slettes',
        Select_question_x: 'Vælg spørgsmål {0}',
        Share: 'Del',
        Share_survey: 'Del undersøgelse',
        Show_more: 'Vis flere',
        Show_response: 'Vis dit svar',
        Showing_x_responses_of_total_y_responses: 'Viser {0} svar ud af i alt {1} svar',
        Start_moving_element_x: 'Start bevægeligt element: {0}',
        Started: 'Startet',
        Statement_x: 'Udsagn {0}',
        Statements_rows: 'Udsagn (rækker)',
        Student_satisfaction_cafeteria: 'elevernes tilfredshed med udvalget af mad i kantinen',
        Submit_answer: 'Send svar',
        Submitted: 'Afleveret',
        Submitted_after_deadline: 'Sendt efter deadline',
        Sunday: 'Søndag',
        Survey: 'Undersøgelse',
        Survey_inactive_message: 'Denne undersøgelse er ikke længere tilgængelig. Du kan fortsætte senere, hvis den bliver tilgængelig igen.',
        Survey_start_page: 'Undersøgelsens startside',
        Survey_title: 'Undersøgelse',
        Survey_type: 'Undersøgelsestype',
        Take_survey: 'Deltag i undersøgelsen',
        Thanks_for_taking_the_survey: 'Tak, fordi du deltog i undersøgelsen!',
        The_survey_is_about: 'Undersøgelsen handler om',
        Thursday: 'Torsdag',
        Tips_and_examples: 'Tips og eksempler',
        Tips_and_examples_info: 'For at få et brugbart resultat fra AI-tjenesten skal du gøre det indtastede kort og præcist. Skriv ikke "Dette er en undersøgelse om...", da det allerede er inkluderet i den tekst, vi sender. Eksempler på input kunne være:',
        Tuesday: 'Tirsdag',
        Unknown_error: 'Noget gik galt. Mulige årsager kan være problemer med vores tjeneste, at nogen redigerer undersøgelsen, eller at dit netværk er ustabilt. Hvis din forbindelse er OK, og du stadig får vist denne meddelelse, skal du kontakte din administrator.',
        View_question_x_of_y: 'Se spørgsmål {0} af {1}',
        Wednesday: 'Onsdag',
        Yes: 'Ja',
        Yes_no_question: 'Ja/Nej-spørgsmål',
        Your_response_will_not_be_saved: 'Dit svar gemmes ikke.',
    },
    'de-DE': {
        Add_alternative: 'Alternative hinzufügen',
        Add_question: 'Frage hinzufügen',
        Add_question_x: 'Frage {0} hinzufügen',
        Add_statement: 'Erklärung hinzufügen',
        Agreement: 'Vereinbarung',
        Agreement_Agree: 'Stimme zu',
        Agreement_Disagree: 'Stimme nicht zu',
        Agreement_Neither_Agree_Nor_Disagree: 'Weder Zustimmung noch Widerspruch',
        Agreement_Strongly_Agree: 'Stimme voll und ganz zu',
        Agreement_Strongly_Disagree: 'Stimme überhaupt nicht zu',
        Allow_respondents_to_select_more_than_one_alternative: 'Erlauben Sie den Befragten, mehrere Alternativen auszuwählen',
        Alternative_x: 'Alternative {0}',
        Alternatives: 'Alternativen',
        Alternatives_columns: 'Alternativen (Spalten)',
        Anonymous: 'Anonym',
        Anonymous_responses: 'Anonym',
        Answer_type: 'Antworttyp',
        Answer_was_cleared: 'Die Antwort wurde gelöscht',
        Ask_our_AI_info_message: 'Lassen Sie Ihre Umfrage von unserem Roboter mit künstlicher Intelligenz (KI) erstellen. Standardmäßig werden Ihnen eine Einführung und Multiple-Choice-Fragen bereitgestellt. Nach der Erstellung können Sie die Umfrage überprüfen und bearbeiten. Weitere Informationen finden Sie in den Tipps unten.',
        Autoloading: 'Automatisches Laden',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Zurück zum Fragenkatalog',
        Back_to_responses: 'Zurück zu den Antworten',
        Back_to_survey_details: 'Zurück zu den Umfragedetails',
        Cancel: 'Abbrechen',
        Clear_answer: 'Antwort löschen',
        Close: 'Schließen',
        Continue_survey: 'Umfrage fortsetzen',
        Copy_public_link: 'Öffentlichen Link kopieren',
        Copy_QR_code: 'QR-Code kopieren',
        Create_survey: 'Umfrage erstellen',
        Create_survey_with_AI: 'Umfrage mit KI erstellen',
        Custom: 'Benutzerdefiniert',
        DateFormat_just_now: 'Gerade eben',
        DateFormat_one_hour_ago: 'Vor 1 Stunde',
        DateFormat_one_minute_ago: 'Vor 1 Minute',
        DateFormat_weekday_x_at_y: '{0} um {1}',
        DateFormat_x_days_ago: 'Vor {0} Tagen',
        DateFormat_x_hours_ago: 'Vor {0} Stunden',
        DateFormat_x_minutes_ago: 'Vor {0} Minuten',
        DateFormat_yesterday_at_x: 'Gestern um {0}',
        Deadline_has_passed_message: 'Die Frist ist abgelaufen und es lässt sich keine Antwort mehr einreichen. Man kann später fortfahren, falls die Frist verlängert wird.',
        Delete: 'Löschen',
        Delete_questions_modal_title: 'Ausgewählte Fragen löschen?',
        Delete_responses: 'Antworten löschen?',
        Download_responses: 'Antworten herunterladen (Excel)',
        Edit_question: 'Frage bearbeiten',
        Edit_question_x_of_y: 'Frage {0} von {1} bearbeiten',
        Edit_settings_info: 'Es ist nicht möglich, die Einstellungen zu bearbeiten, nachdem jemand mit der Umfrage begonnen hat.',
        Edit_survey: 'Umfrage bearbeiten',
        Element_has_been_moved_to_position_x_of_y: 'Das Element wurde an die Position {0} von {1} verschoben',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'Noch keine Antworten',
        Empty_state_no_responses_text: 'Die Antworten werden hier angezeigt, sobald jemand mit der Teilnahme an der Umfrage beginnt.',
        Empty_survey_input_message: 'Bitte beschreiben Sie, worum es in der Umfrage geht.',
        Evaluation_of_the_teaching: 'Evaluation der Lehrmethoden im naturwissenschaftlichen Unterricht',
        Exit_preview: 'Vorschau beenden',
        Exit_survey: 'Umfrage verlassen?',
        Exit_survey_button: 'Umfrage verlassen',
        External_and_anonymous: 'Extern und anonym. Jede Person, die über den Link verfügt, kann antworten.',
        External_survey: 'Extern – jede Person, die über den Link verfügt, kann antworten',
        Frequency: 'Frequenz',
        Frequency_Always: 'Immer',
        Frequency_Never: 'Nie',
        Frequency_Often: 'Oft',
        Frequency_Rarely: 'Selten',
        Frequency_Sometimes: 'Manchmal',
        Friday: 'Freitag',
        Generate_survey: 'Umfrage generieren',
        Grid_no_questions_heading: 'Keine Fragen',
        Grid_no_questions_text: 'Sie haben noch keine Fragen erstellt.',
        Homework_habits: 'Hausaufgaben-Gewohnheiten',
        How_does_this_work: 'Wie geht das?',
        How_does_this_work_info_part1: 'Ihre Eingaben werden als Teil der Eingabeaufforderung verwendet, die wir zur Verarbeitung senden. Ausgehend von der Antwort generieren wir eine Umfrage mit einer Einleitung und Multiple-Choice-Fragen mit 5 Antwortalternativen (von „Stimme voll und ganz zu“ bis „Stimme überhaupt nicht zu“). Sie können alle Inhalte bearbeiten und anpassen, bevor Sie die Umfrage versenden.',
        How_does_this_work_info_part2: 'itslearning ist für den Inhalt der generierten Umfrage nicht verantwortlich. Wir moderieren die Ergebnisse des KI-Dienstes nicht, der möglicherweise ungenaue Informationen über Personen, Orte oder Fakten liefert. Der Dienst, mit dem wir uns verbinden, wird von OpenAI unter Verwendung des GPT-3.5-Turbo-Chat-Modells bereitgestellt.',
        Importance: 'Wichtigkeit',
        Importance_Extremely_Important: 'Äußerst wichtig',
        Importance_Moderately_Important: 'Mittelmäßig wichtig',
        Importance_Not_At_All_Important: 'Gar nicht wichtig',
        Importance_Slightly_Important: 'Etwas wichtig',
        Importance_Very_Important: 'Sehr wichtig',
        Imported_rich_text_edit_warning: 'Dieser Text wurde aus dem alten Umfrage-Tool importiert. Beim Speichern werden alle Formatierungen und Rich-Text-Inhalte (zum Beispiel Bilder) entfernt.',
        Introduction: 'Einleitung',
        Link_copied_to_clipboard: 'Link in die Zwischenablage kopiert',
        Link_to_survey: 'Link zur Umfrage',
        Matrix_question: 'Matrixfrage',
        Monday: 'Montag',
        Move_element_instructions: 'Zum Verschieben dieses Elements die Leertaste drücken und den Aufwärts- oder Abwärtspfeil verwenden. Bitte die Leertaste erneut drücken, um den Vorgang abzuschließen.',
        Moving_element_to_position_x_of_y: 'Verschieben des Elements in die richtige Position {0} von {1}',
        Multiple_choice_question: 'Multiple-Choice-Frage',
        Next: 'Weiter',
        No: 'Nein',
        No_respondents: 'Keine Befragten',
        Not_anonymous: 'Nicht anonym',
        Not_possible_to_edit_questions_message: 'Sie können keine Fragen mehr hinzufügen, bearbeiten oder löschen, weil jemand begonnen hat, an dieser Umfrage teilzunehmen.',
        Note: 'Hinweis',
        Number_of_questions: 'Anzahl der Fragen',
        Number_of_respondents_x: 'Anzahl der Befragten: {0}',
        Number_responded_x: 'Anzahl der Antworten: {0}',
        Numbers: 'Nummer',
        Ok: 'OK',
        Open_answer_heading: 'Antwort',
        Open_question: 'Offene Frage',
        Personal_data_warning: 'Bitte geben Sie keine persönlichen oder urheberrechtlich geschützten Informationen ein. itslearning sendet Ihre Eingaben zur Bearbeitung in Länder außerhalb der EU. Weitere Informationen finden Sie unter „Wie geht das?“.',
        Preview_survey: 'Vorschau der Umfrage',
        Previous: 'Zurück',
        Print: 'Drucken',
        QR_code: 'QR-Code',
        QR_code_copied_to_clipboard: 'QR-Code-Bild wurde in die Zwischenablage kopiert',
        Quality: 'Qualität',
        Quality_Excellent: 'Ausgezeichnet',
        Quality_Fair: 'Mittelmäßig',
        Quality_Good: 'Gut',
        Quality_Poor: 'Schlecht',
        Quality_Very_Poor: 'Sehr schlecht',
        Question: 'Frage',
        Question_has_been_saved: 'Die Antwort wurde gespeichert.',
        Question_number_header: 'Nummer der Frage',
        Question_type: 'Fragetyp',
        Question_type_short: 'Typ',
        Question_x: 'Frage {0}',
        Question_x_of_y: 'Frage {0} von {1}',
        Questions: 'Fragen',
        QuestionType_MultipleChoice_short: 'Multiple Choice',
        QuestionType_YesNo_short: 'Ja/Nein',
        Remember_visible: 'Denken Sie daran, dass die Umfrage für die Befragten sichtbar sein muss.',
        Remember_visible_and_deadline: 'Denken Sie daran, dass die Umfrage für die Befragten sichtbar sein und die Frist in der Zukunft liegen muss.',
        Remove_alternative_x: 'Alternative {0} entfernen',
        Remove_statement_x: 'Erklärung {0} entfernen',
        Respondent: 'Beantworter*in',
        Responses: 'Antworten',
        Responses_summary: 'Zusammenfassung',
        Responses_x: 'Befragte: {0}',
        Satisfaction: 'Zufriedenheit',
        Satisfaction_Completely_Satisfied: 'Rundum zufrieden',
        Satisfaction_Moderately_Satisfied: 'Mittelmäßig zufrieden',
        Satisfaction_Not_At_All_Satisfied: 'Überhaupt nicht zufrieden',
        Satisfaction_Slightly_Satisfied: 'Etwas zufrieden',
        Satisfaction_Very_Satisfied: 'Sehr zufrieden',
        Saturday: 'Samstag',
        Save: 'Speichern',
        Save_and_new: 'Speichern und neu',
        Search: 'Suche',
        Search_for_respondents: 'Suche nach Befragten',
        Select_a_response_to_delete: 'Wählen Sie eine Antwort aus, die gelöscht werden soll',
        Select_all_questions: 'Alle Fragen auswählen',
        Select_at_least_one_question_to_delete: 'Mindestens eine zu löschende Frage auswählen',
        Select_question_x: 'Frage {0} auswählen',
        Share: 'Teilen',
        Share_survey: 'Umfrage teilen',
        Show_more: 'Mehr anzeigen',
        Show_response: 'Meine Antwort anzeigen',
        Showing_x_responses_of_total_y_responses: 'Es werden {0} Antworten von insgesamt {1} Antworten angezeigt.',
        Start_moving_element_x: 'Mit dem Verschieben des Elements starten: {0}',
        Started: 'Begonnen',
        Statement_x: 'Erklärung {0}',
        Statements_rows: 'Erklärungen (Zeilen)',
        Student_satisfaction_cafeteria: 'Zufriedenheit der Schüler*innen mit der Menüauswahl in der Mensa',
        Submit_answer: 'Antwort abschicken',
        Submitted: 'Übermittelt',
        Submitted_after_deadline: 'Nach Ablauf der Frist eingereicht',
        Sunday: 'Sonntag',
        Survey: 'Umfrage',
        Survey_inactive_message: 'Diese Umfrage ist nicht mehr verfügbar. Man kann später fortfahren, wenn sie wieder verfügbar ist.',
        Survey_start_page: 'Startseite der Umfrage',
        Survey_title: 'Umfrage',
        Survey_type: 'Umfragenart',
        Take_survey: 'An Umfrage teilnehmen',
        Thanks_for_taking_the_survey: 'Vielen Dank für die Teilnahme an dieser Umfrage!',
        The_survey_is_about: 'In der Umfrage geht es um',
        Thursday: 'Donnerstag',
        Tips_and_examples: 'Tipps und Beispiele',
        Tips_and_examples_info: 'Um verwendbare Ergebnisse von der KI-Anwendung zu erhalten, halten Sie Ihre Eingabe kurz und prägnant. Bitte schreiben Sie nicht „Bei dieser Umfrage geht es um...“. Dies ist bereits in dem Text enthalten, den wir senden. Beispiele für Eingaben sind:',
        Tuesday: 'Dienstag',
        Unknown_error: 'Irgendetwas ist schiefgelaufen. Mögliche Gründe können Probleme mit unserem Service sein, oder jemand hat die Umfrage bearbeitet, oder Ihr Netzwerk ist instabil. Wenn Ihre Verbindung in Ordnung ist und diese Meldung weiterhin angezeigt wird, wenden Sie sich bitte an Ihren Administrator.',
        View_question_x_of_y: 'Frage {0} von {1} anzeigen',
        Wednesday: 'Mittwoch',
        Yes: 'Ja',
        Yes_no_question: 'Ja/Nein-Frage',
        Your_response_will_not_be_saved: 'Die Antwort wird nicht gespeichert.',
    },
    'en-GB': {
        Add_alternative: 'Add alternative',
        Add_question: 'Add question',
        Add_question_x: 'Add question {0}',
        Add_statement: 'Add statement',
        Agreement: 'Agreement',
        Agreement_Agree: 'Agree',
        Agreement_Disagree: 'Disagree',
        Agreement_Neither_Agree_Nor_Disagree: 'Neither agree nor disagree',
        Agreement_Strongly_Agree: 'Strongly agree',
        Agreement_Strongly_Disagree: 'Strongly disagree',
        Allow_respondents_to_select_more_than_one_alternative: 'Allow respondents to select more than one alternative',
        Alternative_x: 'Alternative {0}',
        Alternatives: 'Alternatives',
        Alternatives_columns: 'Alternatives (columns)',
        Anonymous: 'Anonymous',
        Anonymous_responses: 'Anonymous',
        Answer_type: 'Answer type',
        Answer_was_cleared: 'Answer was cleared',
        Ask_our_AI_info_message: 'Ask our artificial intelligence (AI) robot to generate the survey for you. By default you will get an introduction and multiple choice questions. You can review and edit the survey once it is generated. See tips below for more details.',
        Autoloading: 'Autoloading',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Back to list of questions',
        Back_to_responses: 'Back to responses',
        Back_to_survey_details: 'Back to survey details',
        Cancel: 'Cancel',
        Clear_answer: 'Clear answer',
        Close: 'Close',
        Continue_survey: 'Continue survey',
        Copy_public_link: 'Copy public link',
        Copy_QR_code: 'Copy QR code',
        Create_survey: 'Create survey',
        Create_survey_with_AI: 'Create survey with AI',
        Custom: 'Custom',
        DateFormat_just_now: 'Just now',
        DateFormat_one_hour_ago: '1 hour ago',
        DateFormat_one_minute_ago: '1 minute ago',
        DateFormat_weekday_x_at_y: '{0} at {1}',
        DateFormat_x_days_ago: '{0} days ago',
        DateFormat_x_hours_ago: '{0} hours ago',
        DateFormat_x_minutes_ago: '{0} minutes ago',
        DateFormat_yesterday_at_x: 'Yesterday at {0}',
        Deadline_has_passed_message: 'The deadline has passed, and you are no longer allowed to submit a response. You can continue later if the deadline is extended.',
        Delete: 'Delete',
        Delete_questions_modal_title: 'Delete selected questions?',
        Delete_responses: 'Delete responses?',
        Download_responses: 'Download responses (Excel)',
        Edit_question: 'Edit question',
        Edit_question_x_of_y: 'Edit question {0} of {1}',
        Edit_settings_info: 'It\'s not possible to edit the anonymous settings after someone has started the survey.',
        Edit_survey: 'Edit survey',
        Element_has_been_moved_to_position_x_of_y: 'Element has been moved to position {0} of {1}',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'No responses yet',
        Empty_state_no_responses_text: 'Responses will appear here once someone starts taking the survey.',
        Empty_survey_input_message: 'You need to write what the survey is about.',
        Evaluation_of_the_teaching: 'evaluation of the teaching methods in science class',
        Exit_preview: 'Exit preview',
        Exit_survey: 'Exit survey?',
        Exit_survey_button: 'Exit survey',
        External_and_anonymous: 'External and anonymous. Anyone with a link can respond.',
        External_survey: 'External - anyone with the link can respond',
        Frequency: 'Frequency',
        Frequency_Always: 'Always',
        Frequency_Never: 'Never',
        Frequency_Often: 'Often',
        Frequency_Rarely: 'Rarely',
        Frequency_Sometimes: 'Sometimes',
        Friday: 'Friday',
        Generate_survey: 'Generate survey',
        Grid_no_questions_heading: 'No questions',
        Grid_no_questions_text: 'You haven’t created any questions yet.',
        Homework_habits: 'homework habits',
        How_does_this_work: 'How does this work?',
        How_does_this_work_info_part1: 'Your input is used as part of the prompt we send for processing. Based on the response, we generate a survey with an introduction and multiple choice questions with 5 answer alternatives (from \'strongly agree\' to \'strongly disagree\'). You will be able to edit and adjust all content before you distribute the survey.',
        How_does_this_work_info_part2: 'itslearning is not responsible for the content of the generated survey. We do not moderate the response from the AI service, which may produce inaccurate information about people, places or facts. The service we connect to is provided by OpenAI, using the GPT-3.5-turbo chat model.',
        Importance: 'Importance',
        Importance_Extremely_Important: 'Extremely important',
        Importance_Moderately_Important: 'Moderately important',
        Importance_Not_At_All_Important: 'Not at all important',
        Importance_Slightly_Important: 'Slightly important',
        Importance_Very_Important: 'Very important',
        Imported_rich_text_edit_warning: 'This text was imported from the old survey tool. When you save, all formatting and rich-text content (for example images) will be removed.',
        Introduction: 'Introduction',
        Link_copied_to_clipboard: 'Link copied to clipboard',
        Link_to_survey: 'Link to survey',
        Matrix_question: 'Matrix question',
        Monday: 'Monday',
        Move_element_instructions: 'To move this element, press space and use up or down arrow. Press space again to complete.',
        Moving_element_to_position_x_of_y: 'Moving element to position {0} of {1}',
        Multiple_choice_question: 'Multiple-choice question',
        Next: 'Next',
        No: 'No',
        No_respondents: 'No respondents',
        Not_anonymous: 'Not anonymous',
        Not_possible_to_edit_questions_message: 'You can no longer add, edit or delete questions because someone has started taking this survey.',
        Note: 'Note',
        Number_of_questions: 'Number of questions',
        Number_of_respondents_x: 'Number of respondents: {0}',
        Number_responded_x: 'Number responded: {0}',
        Numbers: 'Numbers',
        Ok: 'Ok',
        Open_answer_heading: 'Answer',
        Open_question: 'Open question',
        Personal_data_warning: 'Do not enter any personal or copyrighted information. Your input is sent from itslearning outside the EU for processing. See "How does this work" for more details.',
        Preview_survey: 'Preview survey',
        Previous: 'Previous',
        Print: 'Print',
        QR_code: 'QR code',
        QR_code_copied_to_clipboard: 'QR code image copied to clipboard',
        Quality: 'Quality',
        Quality_Excellent: 'Excellent',
        Quality_Fair: 'Fair',
        Quality_Good: 'Good',
        Quality_Poor: 'Poor',
        Quality_Very_Poor: 'Very poor',
        Question: 'Question',
        Question_has_been_saved: 'Question has been saved.',
        Question_number_header: 'Question number',
        Question_type: 'Question type',
        Question_type_short: 'Type',
        Question_x: 'Question {0}',
        Question_x_of_y: 'Question {0} of {1}',
        Questions: 'Questions',
        QuestionType_MultipleChoice_short: 'Multiple choice',
        QuestionType_YesNo_short: 'Yes/no',
        Remember_visible: 'Remember that the survey must be visible to respondents.',
        Remember_visible_and_deadline: 'Remember that the survey must be visible to respondents and the deadline must be in the future.',
        Remove_alternative_x: 'Remove alternative {0}',
        Remove_statement_x: 'Remove statement {0}',
        Respondent: 'Respondent',
        Responses: 'Responses',
        Responses_summary: 'Summary',
        Responses_x: 'Responses: {0}',
        Satisfaction: 'Satisfaction',
        Satisfaction_Completely_Satisfied: 'Completely satisfied',
        Satisfaction_Moderately_Satisfied: 'Moderately satisfied',
        Satisfaction_Not_At_All_Satisfied: 'Not at all satisfied',
        Satisfaction_Slightly_Satisfied: 'Slightly satisfied',
        Satisfaction_Very_Satisfied: 'Very satisfied',
        Saturday: 'Saturday',
        Save: 'Save',
        Save_and_new: 'Save and new',
        Search: 'Search',
        Search_for_respondents: 'Search for respondents',
        Select_a_response_to_delete: 'Select a response to delete',
        Select_all_questions: 'Select all questions',
        Select_at_least_one_question_to_delete: 'Select at least one question to delete',
        Select_question_x: 'Select question {0}',
        Share: 'Share',
        Share_survey: 'Share survey',
        Show_more: 'Show more',
        Show_response: 'Show your response',
        Showing_x_responses_of_total_y_responses: 'Showing {0} responses of total {1} responses',
        Start_moving_element_x: 'Start moving element: {0}',
        Started: 'Started',
        Statement_x: 'Statement {0}',
        Statements_rows: 'Statements (rows)',
        Student_satisfaction_cafeteria: 'student satisfaction with the menu options in the cafeteria',
        Submit_answer: 'Submit answer',
        Submitted: 'Submitted',
        Submitted_after_deadline: 'Submitted after deadline',
        Sunday: 'Sunday',
        Survey: 'Survey',
        Survey_inactive_message: 'This survey is no longer available. You can continue later if it becomes available again.',
        Survey_start_page: 'Survey start page',
        Survey_title: 'Survey',
        Survey_type: 'Survey type',
        Take_survey: 'Take survey',
        Thanks_for_taking_the_survey: 'Thanks for taking the survey!',
        The_survey_is_about: 'The survey is about',
        Thursday: 'Thursday',
        Tips_and_examples: 'Tips and examples',
        Tips_and_examples_info: 'To get useful output from the AI service, keep the input short and concise. Do not write "This is a survey about..." as that is already included in the text we send. Examples of input could be:',
        Tuesday: 'Tuesday',
        Unknown_error: 'Something went wrong. Possible reasons may be issues with our service, that someone is editing the survey or that your network is unstable. If your connection is OK and you keep seeing this message, please contact your administrator.',
        View_question_x_of_y: 'View question {0} of {1}',
        Wednesday: 'Wednesday',
        Yes: 'Yes',
        Yes_no_question: 'Yes/No question',
        Your_response_will_not_be_saved: 'Your response will not be saved.',
    },
    'en-US': {
        Add_alternative: 'Add alternative',
        Add_question: 'Add question',
        Add_question_x: 'Add question {0}',
        Add_statement: 'Add statement',
        Agreement: 'Agreement',
        Agreement_Agree: 'Agree',
        Agreement_Disagree: 'Disagree',
        Agreement_Neither_Agree_Nor_Disagree: 'Neither agree nor disagree',
        Agreement_Strongly_Agree: 'Strongly agree',
        Agreement_Strongly_Disagree: 'Strongly disagree',
        Allow_respondents_to_select_more_than_one_alternative: 'Allow respondents to select more than one alternative',
        Alternative_x: 'Alternative {0}',
        Alternatives: 'Alternatives',
        Alternatives_columns: 'Alternatives (columns)',
        Anonymous: 'Anonymous',
        Anonymous_responses: 'Anonymous',
        Answer_type: 'Answer type',
        Answer_was_cleared: 'Answer was cleared',
        Ask_our_AI_info_message: 'Ask our artificial intelligence (AI) robot to generate the survey for you. By default you will get an introduction and multiple choice questions. You can review and edit the survey once it is generated. See tips below for more details.',
        Autoloading: 'Autoloading',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Back to the list of questions',
        Back_to_responses: 'Back to responses',
        Back_to_survey_details: 'Back to survey details',
        Cancel: 'Cancel',
        Clear_answer: 'Clear answer',
        Close: 'Close',
        Continue_survey: 'Continue survey',
        Copy_public_link: 'Copy public link',
        Copy_QR_code: 'Copy QR code',
        Create_survey: 'Create survey',
        Create_survey_with_AI: 'Create survey with AI',
        Custom: 'Custom',
        DateFormat_just_now: 'Just now',
        DateFormat_one_hour_ago: '1 hour ago',
        DateFormat_one_minute_ago: '1 minute ago',
        DateFormat_weekday_x_at_y: '{0} at {1}',
        DateFormat_x_days_ago: '{0} days ago',
        DateFormat_x_hours_ago: '{0} hours ago',
        DateFormat_x_minutes_ago: '{0} minutes ago',
        DateFormat_yesterday_at_x: 'Yesterday at {0}',
        Deadline_has_passed_message: 'The deadline has passed, and you are no longer allowed to submit a response. You can continue later if the deadline is extended.',
        Delete: 'Delete',
        Delete_questions_modal_title: 'Delete selected questions?',
        Delete_responses: 'Delete responses?',
        Download_responses: 'Download responses (Excel)',
        Edit_question: 'Edit question',
        Edit_question_x_of_y: 'Edit question {0} of {1}',
        Edit_settings_info: 'It\'s not possible to edit the anonymous settings after someone has started the survey.',
        Edit_survey: 'Edit survey',
        Element_has_been_moved_to_position_x_of_y: 'Element has been moved to position {0} of {1}',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'No responses yet',
        Empty_state_no_responses_text: 'Responses will appear here once someone starts taking the survey.',
        Empty_survey_input_message: 'You need to write what the survey is about.',
        Evaluation_of_the_teaching: 'evaluation of the teaching methods in science class',
        Exit_preview: 'Exit preview',
        Exit_survey: 'Exit survey?',
        Exit_survey_button: 'Exit survey',
        External_and_anonymous: 'External and anonymous. Anyone with a link can respond.',
        External_survey: 'External - anyone with the link can respond',
        Frequency: 'Frequency',
        Frequency_Always: 'Always',
        Frequency_Never: 'Never',
        Frequency_Often: 'Often',
        Frequency_Rarely: 'Rarely',
        Frequency_Sometimes: 'Sometimes',
        Friday: 'Friday',
        Generate_survey: 'Generate survey',
        Grid_no_questions_heading: 'No questions',
        Grid_no_questions_text: 'You haven’t created any questions yet.',
        Homework_habits: 'homework habits',
        How_does_this_work: 'How does this work?',
        How_does_this_work_info_part1: 'Your input is used as part of the prompt we send for processing. Based on the response, we generate a survey with an introduction and multiple choice questions with 5 answer alternatives (from \'strongly agree\' to \'strongly disagree\'). You will be able to edit and adjust all content before you distribute the survey.',
        How_does_this_work_info_part2: 'itslearning is not responsible for the content of the generated survey. We do not moderate the response from the AI service, which may produce inaccurate information about people, places or facts. The service we connect to is provided by OpenAI, using the GPT-3.5-turbo chat model.',
        Importance: 'Importance',
        Importance_Extremely_Important: 'Extremely important',
        Importance_Moderately_Important: 'Moderately important',
        Importance_Not_At_All_Important: 'Not at all important',
        Importance_Slightly_Important: 'Slightly important',
        Importance_Very_Important: 'Very important',
        Imported_rich_text_edit_warning: 'This text was imported from the old survey tool. When you save, all formatting and rich-text content (for example images) will be removed.',
        Introduction: 'Introduction',
        Link_copied_to_clipboard: 'Link copied to clipboard',
        Link_to_survey: 'Link to survey',
        Matrix_question: 'Matrix question',
        Monday: 'Monday',
        Move_element_instructions: 'To move this element, press space and use up or down arrow. Press space again to complete.',
        Moving_element_to_position_x_of_y: 'Moving element to position {0} of {1}',
        Multiple_choice_question: 'Multiple choice question',
        Next: 'Next',
        No: 'No',
        No_respondents: 'No respondents',
        Not_anonymous: 'Not anonymous',
        Not_possible_to_edit_questions_message: 'You can no longer add, edit or delete questions - because someone has started taking this survey.',
        Note: 'Note',
        Number_of_questions: 'Number of questions',
        Number_of_respondents_x: 'Number of respondents: {0}',
        Number_responded_x: 'Number responded: {0}',
        Numbers: 'Numbers',
        Ok: 'OK',
        Open_answer_heading: 'Answer',
        Open_question: 'Open question',
        Personal_data_warning: 'Do not enter any personal or copyrighted information. Your input is sent from itslearning outside the EU for processing. See "How does this work" for more details.',
        Preview_survey: 'Preview survey',
        Previous: 'Previous',
        Print: 'Print',
        QR_code: 'QR code',
        QR_code_copied_to_clipboard: 'QR code image copied to clipboard',
        Quality: 'Quality',
        Quality_Excellent: 'Excellent',
        Quality_Fair: 'Fair',
        Quality_Good: 'Good',
        Quality_Poor: 'Poor',
        Quality_Very_Poor: 'Very poor',
        Question: 'Question',
        Question_has_been_saved: 'Question has been saved.',
        Question_number_header: 'Question number',
        Question_type: 'Question type',
        Question_type_short: 'Type',
        Question_x: 'Question {0}',
        Question_x_of_y: 'Question {0} of {1}',
        Questions: 'Questions',
        QuestionType_MultipleChoice_short: 'Multiple choice',
        QuestionType_YesNo_short: 'Yes/no',
        Remember_visible: 'Remember that the survey must be visible to respondents.',
        Remember_visible_and_deadline: 'Remember that the survey must be visible to respondents and the deadline must be in the future.',
        Remove_alternative_x: 'Remove alternative {0}',
        Remove_statement_x: 'Remove statement {0}',
        Respondent: 'Respondent',
        Responses: 'Responses',
        Responses_summary: 'Summary',
        Responses_x: 'Responses: {0}',
        Satisfaction: 'Satisfaction',
        Satisfaction_Completely_Satisfied: 'Completely satisfied',
        Satisfaction_Moderately_Satisfied: 'Moderately satisfied',
        Satisfaction_Not_At_All_Satisfied: 'Not at all satisfied',
        Satisfaction_Slightly_Satisfied: 'Slightly satisfied',
        Satisfaction_Very_Satisfied: 'Very satisfied',
        Saturday: 'Saturday',
        Save: 'Save',
        Save_and_new: 'Save and new',
        Search: 'Search',
        Search_for_respondents: 'Search for respondents',
        Select_a_response_to_delete: 'Select a response to delete',
        Select_all_questions: 'Select all questions',
        Select_at_least_one_question_to_delete: 'Select at least one question to delete',
        Select_question_x: 'Select question {0}',
        Share: 'Share',
        Share_survey: 'Share survey',
        Show_more: 'Show more',
        Show_response: 'Display your response',
        Showing_x_responses_of_total_y_responses: 'Displaying {0} responses of total {1} responses',
        Start_moving_element_x: 'Start moving element: {0}',
        Started: 'Started',
        Statement_x: 'Statement {0}',
        Statements_rows: 'Statements (rows)',
        Student_satisfaction_cafeteria: 'student satisfaction with the menu options in the cafeteria',
        Submit_answer: 'Submit answer',
        Submitted: 'Submitted',
        Submitted_after_deadline: 'Submitted after deadline',
        Sunday: 'Sunday',
        Survey: 'Survey',
        Survey_inactive_message: 'This survey is no longer available. You can continue later if it becomes available again.',
        Survey_start_page: 'Survey start page',
        Survey_title: 'Survey',
        Survey_type: 'Survey type',
        Take_survey: 'Take survey',
        Thanks_for_taking_the_survey: 'Thanks for taking the survey!',
        The_survey_is_about: 'The survey is about',
        Thursday: 'Thursday',
        Tips_and_examples: 'Tips and examples',
        Tips_and_examples_info: 'To get useful output from the AI service, keep the input short and concise. Do not write "This is a survey about..." as that is already included in the text we send. Examples of input could be:',
        Tuesday: 'Tuesday',
        Unknown_error: 'Something went wrong. Possible reasons may be issues with our service, that someone is editing the survey or that your network is unstable. If your connection is OK and you keep seeing this message, please contact your administrator.',
        View_question_x_of_y: 'View question {0} of {1}',
        Wednesday: 'Wednesday',
        Yes: 'Yes',
        Yes_no_question: 'Yes/No question',
        Your_response_will_not_be_saved: 'Your response will not be saved.',
    },
    'es-ES': {
        Add_alternative: 'Agregar alternativa',
        Add_question: 'Agregar pregunta',
        Add_question_x: 'Agregar pregunta {0}',
        Add_statement: 'Agregar declaración',
        Agreement: 'Acuerdo',
        Agreement_Agree: 'De acuerdo',
        Agreement_Disagree: 'En desacuerdo',
        Agreement_Neither_Agree_Nor_Disagree: 'Ni de acuerdo ni en desacuerdo',
        Agreement_Strongly_Agree: 'Totalmente de acuerdo',
        Agreement_Strongly_Disagree: 'Totalmente en desacuerdo',
        Allow_respondents_to_select_more_than_one_alternative: 'Permitir a los encuestados elegir más de una alternativa',
        Alternative_x: 'Alternativa {0}',
        Alternatives: 'Alternativas',
        Alternatives_columns: 'Alternativas (columnas)',
        Anonymous: 'Anónima',
        Anonymous_responses: 'Anónimo',
        Answer_type: 'Tipo de respuesta',
        Answer_was_cleared: 'La respuesta se ha borrado',
        Ask_our_AI_info_message: 'Pídale a nuestro robot de inteligencia artificial (IA) que genere la encuesta por usted. De forma predeterminada, obtendrá una introducción y preguntas de opciones múltiples. Puede revisar y editar la encuesta una vez que se haya generado. Para obtener más información, consulte los consejos que aparecen a continuación.',
        Autoloading: 'Carga automática',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Volver a la lista de preguntas',
        Back_to_responses: 'Volver a las respuestas',
        Back_to_survey_details: 'Volver a los detalles de la encuesta',
        Cancel: 'Cancelar',
        Clear_answer: 'Borrar respuesta',
        Close: 'Cerrar',
        Continue_survey: 'Continuar encuesta',
        Copy_public_link: 'Copiar vínculo público',
        Copy_QR_code: 'Copiar código QR',
        Create_survey: 'Crear encuesta',
        Create_survey_with_AI: 'Crear encuesta con IA',
        Custom: 'Personalizado',
        DateFormat_just_now: 'Justo ahora',
        DateFormat_one_hour_ago: 'Hace 1 hora',
        DateFormat_one_minute_ago: 'Hace 1 minuto',
        DateFormat_weekday_x_at_y: 'El {0} a las {1}',
        DateFormat_x_days_ago: 'Hace {0} días',
        DateFormat_x_hours_ago: 'Hace {0} horas',
        DateFormat_x_minutes_ago: 'Hace {0} minutos',
        DateFormat_yesterday_at_x: 'Ayer a las {0}',
        Deadline_has_passed_message: 'La fecha límite ha pasado y ya no se le permite enviar una respuesta. Puede continuar más tarde si se amplía la fecha límite.',
        Delete: 'Eliminar',
        Delete_questions_modal_title: '¿Eliminar preguntas seleccionadas?',
        Delete_responses: '¿Eliminar respuestas?',
        Download_responses: 'Descargar respuestas (Excel)',
        Edit_question: 'Editar pregunta',
        Edit_question_x_of_y: 'Editar pregunta {0} de {1}',
        Edit_settings_info: 'No es posible editar la configuración anónima después de que alguien haya iniciado la encuesta.',
        Edit_survey: 'Editar encuesta',
        Element_has_been_moved_to_position_x_of_y: 'El elemento se ha movido a la posición {0} de {1}',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'Aún no hay respuestas',
        Empty_state_no_responses_text: 'Las respuestas aparecerán aquí una vez que alguien comience a realizar la encuesta.',
        Empty_survey_input_message: 'Debe escribir de qué se trata la encuesta.',
        Evaluation_of_the_teaching: 'evaluación de los métodos de enseñanza en la clase de ciencias',
        Exit_preview: 'Salir de la vista previa',
        Exit_survey: '¿Salir de la encuesta?',
        Exit_survey_button: 'Salir de la encuesta',
        External_and_anonymous: 'Externa y anónima. Cualquier persona con un enlace puede responder.',
        External_survey: 'Externa: cualquier persona con el enlace puede responder',
        Frequency: 'Frecuencia',
        Frequency_Always: 'Siempre',
        Frequency_Never: 'Nunca',
        Frequency_Often: 'A menudo',
        Frequency_Rarely: 'Rara vez',
        Frequency_Sometimes: 'A veces',
        Friday: 'Viernes',
        Generate_survey: 'Generar encuesta',
        Grid_no_questions_heading: 'Ninguna pregunta',
        Grid_no_questions_text: 'Aún no ha creado ninguna pregunta.',
        Homework_habits: 'hábitos en relación con los deberes',
        How_does_this_work: '¿Cómo funciona?',
        How_does_this_work_info_part1: 'La información que introduce se utiliza como parte del mensaje que enviamos para su procesamiento. A partir de la respuesta, generamos una encuesta con una introducción y preguntas de opciones múltiples con 5 opciones de respuesta (de "totalmente de acuerdo" a "totalmente en desacuerdo"). Podrá editar y ajustar todo el contenido antes de distribuir la encuesta.',
        How_does_this_work_info_part2: 'itslearning no se hace responsable del contenido de la encuesta generada. No moderamos la respuesta del servicio de IA, que puede producir información inexacta sobre personas, lugares o hechos. El servicio al que nos conectamos lo proporciona OpenAI, utilizando el modelo de chat GPT-3.5-turbo.',
        Importance: 'Importancia',
        Importance_Extremely_Important: 'Extremadamente importante',
        Importance_Moderately_Important: 'Moderadamente importante',
        Importance_Not_At_All_Important: 'Nada importante',
        Importance_Slightly_Important: 'Ligeramente importante',
        Importance_Very_Important: 'Muy importante',
        Imported_rich_text_edit_warning: 'Este texto se importó de la antigua herramienta de encuesta. Al guardar, se eliminará todo el formato y el contenido de texto enriquecido (por ejemplo, imágenes).',
        Introduction: 'Introducción',
        Link_copied_to_clipboard: 'Vínculo copiado al portapapeles',
        Link_to_survey: 'Vínculo a la encuesta',
        Matrix_question: 'Pregunta de matriz',
        Monday: 'Lunes',
        Move_element_instructions: 'Para mover este elemento, pulse la barra espaciadora y utilice las flechas arriba o abajo. Pulse la barra espaciadora nuevamente para completar.',
        Moving_element_to_position_x_of_y: 'Mover el elemento a la posición {0} de {1}',
        Multiple_choice_question: 'Pregunta con opciones múltiples',
        Next: 'Siguiente',
        No: 'No',
        No_respondents: 'No hay encuestados',
        Not_anonymous: 'No anónima',
        Not_possible_to_edit_questions_message: 'Ya no puede agregar, editar ni eliminar preguntas porque alguien ha comenzado a realizar esta encuesta.',
        Note: 'Nota',
        Number_of_questions: 'Número de preguntas',
        Number_of_respondents_x: 'Número de usuarios que han respondido: {0}',
        Number_responded_x: 'Cantidad de respuestas: {0}',
        Numbers: 'Números',
        Ok: 'Aceptar',
        Open_answer_heading: 'Respuesta',
        Open_question: 'Pregunta de respuesta libre',
        Personal_data_warning: 'No introduzca datos personales ni información con derechos de autor. El texto que introduce se envía desde itslearning fuera de la UE para su procesamiento. Para obtener más información, consulte "Cómo funciona".',
        Preview_survey: 'Vista previa de la encuesta',
        Previous: 'Anterior',
        Print: 'Imprimir',
        QR_code: 'Código QR',
        QR_code_copied_to_clipboard: 'Imagen de código QR copiada al portapapeles',
        Quality: 'Calidad',
        Quality_Excellent: 'Excelente',
        Quality_Fair: 'Aceptable',
        Quality_Good: 'Bueno',
        Quality_Poor: 'Deficiente',
        Quality_Very_Poor: 'Muy deficiente',
        Question: 'Pregunta',
        Question_has_been_saved: 'Se ha guardado la pregunta.',
        Question_number_header: 'Número de pregunta',
        Question_type: 'Tipo de pregunta',
        Question_type_short: 'Tipo',
        Question_x: 'Pregunta {0}',
        Question_x_of_y: 'Pregunta {0} de {1}',
        Questions: 'Preguntas',
        QuestionType_MultipleChoice_short: 'Opciones múltiples',
        QuestionType_YesNo_short: 'Sí/no',
        Remember_visible: 'Recuerde que la encuesta debe ser visible para los encuestados.',
        Remember_visible_and_deadline: 'Recuerde que la encuesta debe ser visible para los encuestados y la fecha límite debe ser en el futuro.',
        Remove_alternative_x: 'Eliminar alternativa {0}',
        Remove_statement_x: 'Eliminar declaración {0}',
        Respondent: 'Encuestado',
        Responses: 'Respuestas',
        Responses_summary: 'Resumen',
        Responses_x: 'Respuestas: {0}',
        Satisfaction: 'Satisfacción',
        Satisfaction_Completely_Satisfied: 'Completamente satisfecho',
        Satisfaction_Moderately_Satisfied: 'Moderadamente satisfecho',
        Satisfaction_Not_At_All_Satisfied: 'Nada satisfecho',
        Satisfaction_Slightly_Satisfied: 'Ligeramente satisfecho',
        Satisfaction_Very_Satisfied: 'Muy satisfecho',
        Saturday: 'Sábado',
        Save: 'Guardar',
        Save_and_new: 'Guardar y nueva',
        Search: 'Buscar',
        Search_for_respondents: 'Buscar encuestados',
        Select_a_response_to_delete: 'Seleccione una respuesta para eliminar',
        Select_all_questions: 'Seleccionar todas las preguntas',
        Select_at_least_one_question_to_delete: 'Seleccione al menos una pregunta que eliminar',
        Select_question_x: 'Seleccionar la pregunta {0}',
        Share: 'Compartir',
        Share_survey: 'Compartir encuesta',
        Show_more: 'Mostrar más',
        Show_response: 'Mostrar su respuesta',
        Showing_x_responses_of_total_y_responses: 'Mostrando {0} respuestas de un total de {1} respuestas',
        Start_moving_element_x: 'Comience a mover el elemento: {0}',
        Started: 'Iniciado',
        Statement_x: 'Declaración {0}',
        Statements_rows: 'Instrucciones (filas)',
        Student_satisfaction_cafeteria: 'satisfacción del estudiante con las opciones de menú de la cafetería',
        Submit_answer: 'Enviar respuesta',
        Submitted: 'Enviada',
        Submitted_after_deadline: 'Envío posterior a fecha límite',
        Sunday: 'Domingo',
        Survey: 'Encuesta',
        Survey_inactive_message: 'Esta encuesta ya no está disponible. Puede continuar más tarde si vuelve a estar disponible.',
        Survey_start_page: 'Página de inicio de la encuesta',
        Survey_title: 'Encuesta',
        Survey_type: 'Tipo de encuesta',
        Take_survey: 'Responder a la encuesta',
        Thanks_for_taking_the_survey: '¡Gracias por responder la encuesta!',
        The_survey_is_about: 'La encuesta trata sobre',
        Thursday: 'Jueves',
        Tips_and_examples: 'Consejos y ejemplos',
        Tips_and_examples_info: 'Para obtener resultados útiles del servicio de IA, escriba información breve y concisa. No escriba "Esta es una encuesta sobre...", dado que ya está incluido en el texto que enviamos. Algunos ejemplos podrían ser:',
        Tuesday: 'Martes',
        Unknown_error: 'Algo ha salido mal. Las posibles razones pueden ser problemas con nuestro servicio, que alguien esté editando la encuesta o que su red sea inestable. Si su conexión es correcta y sigue viendo este mensaje, póngase en contacto con su administrador.',
        View_question_x_of_y: 'Ver pregunta {0} de {1}',
        Wednesday: 'Miércoles',
        Yes: 'Sí',
        Yes_no_question: 'Pregunta Sí/No',
        Your_response_will_not_be_saved: 'Su respuesta no se guardará.',
    },
    'fi-FI': {
        Add_alternative: 'Lisää vaihtoehto',
        Add_question: 'Lisää kysymys',
        Add_question_x: 'Lisää kysymys {0}',
        Add_statement: 'Lisää väittämä',
        Agreement: 'Yksimielisyys',
        Agreement_Agree: 'Samaa mieltä',
        Agreement_Disagree: 'Eri mieltä',
        Agreement_Neither_Agree_Nor_Disagree: 'En samaa enkä eri mieltä',
        Agreement_Strongly_Agree: 'Olen vahvasti samaa mieltä',
        Agreement_Strongly_Disagree: 'Olen täysin eri mieltä',
        Allow_respondents_to_select_more_than_one_alternative: 'Salli vastaajien valita useita vaihtoehtoja',
        Alternative_x: 'Vaihtoehto {0}',
        Alternatives: 'Vaihtoehdot',
        Alternatives_columns: 'Vaihtoehdot (sarakkeet)',
        Anonymous: 'Anonyymi',
        Anonymous_responses: 'Anonyymi',
        Answer_type: 'Vastauksen tyyppi',
        Answer_was_cleared: 'Vastaus tyhjennettiin',
        Ask_our_AI_info_message: 'Pyydä tekoälyrobottiamme luomaan kysely puolestasi. Oletuksena saat johdannon ja monivalintakysymyksiä. Voit tarkastella ja muokata kyselyä sen luomisen jälkeen. Katso lisätietoja alla olevista vinkeistä.',
        Autoloading: 'Lataa automaattisesti',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Takaisin kysymysluetteloon',
        Back_to_responses: 'Takaisin vastauksiin',
        Back_to_survey_details: 'Takaisin kyselyn tietoihin',
        Cancel: 'Peruuta',
        Clear_answer: 'Tyhjennä vastaus',
        Close: 'Sulje',
        Continue_survey: 'Jatka kyselyä',
        Copy_public_link: 'Kopioi julkinen linkki',
        Copy_QR_code: 'Kopioi QR-koodi',
        Create_survey: 'Luo kysely',
        Create_survey_with_AI: 'Luo kysely tekoälyn avulla',
        Custom: 'Mukautettu',
        DateFormat_just_now: 'Juuri nyt',
        DateFormat_one_hour_ago: '1 tunti sitten',
        DateFormat_one_minute_ago: '1 minuutti sitten',
        DateFormat_weekday_x_at_y: '{0} kello {1}',
        DateFormat_x_days_ago: '{0} päivää sitten',
        DateFormat_x_hours_ago: '{0} tuntia sitten',
        DateFormat_x_minutes_ago: '{0} minuuttia sitten',
        DateFormat_yesterday_at_x: 'Eilen kello {0}',
        Deadline_has_passed_message: 'Määräaika on umpeutunut, etkä voi enää antaa vastausta. Voit jatkaa myöhemmin, jos määräaikaa pidennetään.',
        Delete: 'Poista',
        Delete_questions_modal_title: 'Poistetaanko valitut kysymykset?',
        Delete_responses: 'Poistetaanko vastaukset?',
        Download_responses: 'Lataa vastaukset (Excel)',
        Edit_question: 'Muokkaa kysymystä',
        Edit_question_x_of_y: 'Muokkaa kysymystä {0} / {1}',
        Edit_settings_info: 'Anonyymejä asetuksia ei voi muokata sen jälkeen, kun joku on aloittanut kyselyn.',
        Edit_survey: 'Muokkaa kyselyä',
        Element_has_been_moved_to_position_x_of_y: 'Elementti on siirretty sijaintiin {0} / {1}',
        Emojis: 'Emojit',
        Empty_state_no_responses_heading: 'Vastauksia ei vielä ole',
        Empty_state_no_responses_text: 'Vastaukset näkyvät täällä, kun joku aloittaa kyselyyn vastaamisen.',
        Empty_survey_input_message: 'Sinun on kirjoitettava, mikä on kyselyssä aihe.',
        Evaluation_of_the_teaching: 'opetusmenetelmien arviointi luonnontieteiden luokassa',
        Exit_preview: 'Poistu esikatselusta',
        Exit_survey: 'Poistutko kyselystä?',
        Exit_survey_button: 'Poistut kyselystä',
        External_and_anonymous: 'Ulkoinen ja anonyymi. Kuka tahansa, jolla on linkki, voi vastata.',
        External_survey: 'Ulkoinen - kuka tahansa, jolla on linkki, voi vastata',
        Frequency: 'Toistuminen',
        Frequency_Always: 'Aina',
        Frequency_Never: 'Ei koskaan',
        Frequency_Often: 'Usein',
        Frequency_Rarely: 'Harvoin',
        Frequency_Sometimes: 'Joskus',
        Friday: 'perjantai',
        Generate_survey: 'Luo kysely',
        Grid_no_questions_heading: 'Ei kysymyksiä',
        Grid_no_questions_text: 'Et ole vielä luonut yhtään kysymystä.',
        Homework_habits: 'kotitehtävien tottumukset',
        How_does_this_work: 'Miten tämä toimii?',
        How_does_this_work_info_part1: 'Kirjoittamaasi käytetään osana kehotetta, jonka lähetämme käsiteltäväksi. Vastauksen perusteella luomme kyselyn, joka sisältää johdannon ja monivalintakysymyksiä, joissa on 5 vastausvaihtoehtoa (”täysin samaa mieltä” - ”täysin eri mieltä”). Voit editoida ja muokata kaikkea sisältöä ennen kyselyn jakamista.',
        How_does_this_work_info_part2: 'itslearning ei ole vastuussa luodun kyselyn sisällöstä. Emme moderoi tekoälypalvelun vastausta, joka voi tuottaa epätarkkoja tietoja ihmisistä, paikoista tai faktoista. Palvelu, johon olemme yhteydessä, on OpenAI:n tarjoama GPT-3.5-turbo-chat-mallilla.',
        Importance: 'Tärkeys',
        Importance_Extremely_Important: 'Erittäin tärkeä',
        Importance_Moderately_Important: 'Kohtalaisen tärkeä',
        Importance_Not_At_All_Important: 'Ei ollenkaan tärkeä',
        Importance_Slightly_Important: 'Hieman tärkeä',
        Importance_Very_Important: 'Todella tärkeä',
        Imported_rich_text_edit_warning: 'Tämä teksti on tuotu vanhasta kyselytyökalusta. Kun tallennat, kaikki muotoilu ja RTF-sisältö (esimerkiksi kuvat) poistetaan.',
        Introduction: 'Johdanto',
        Link_copied_to_clipboard: 'Linkki kopioitu leikepöydälle',
        Link_to_survey: 'Linkki kyselyyn',
        Matrix_question: 'Matriisikysymys',
        Monday: 'maanantai',
        Move_element_instructions: 'Voit siirtää tätä elementtiä painamalla välilyöntinäppäintä ja nuolinäppäintä ylös tai alas. Viimeistele painamalla välilyöntiä uudelleen.',
        Moving_element_to_position_x_of_y: 'Elementin siirtäminen sijaintiin {0} / {1}',
        Multiple_choice_question: 'Monivalintakysymys',
        Next: 'Seuraava',
        No: 'Ei',
        No_respondents: 'Ei vastaajia',
        Not_anonymous: 'Ei anonyymi',
        Not_possible_to_edit_questions_message: 'Et voi enää lisätä, muokata tai poistaa kysymyksiä, koska joku on aloittanut kyselyyn vastaamisen.',
        Note: 'Muistiinpano',
        Number_of_questions: 'Kysymysten lukumäärä',
        Number_of_respondents_x: 'Vastaajien lukumäärä: {0}',
        Number_responded_x: 'Vastanneiden määrä: {0}',
        Numbers: 'Numerot',
        Ok: 'Ok',
        Open_answer_heading: 'Vastaus',
        Open_question: 'Avoin kysymys',
        Personal_data_warning: 'Älä kirjoita henkilökohtaisia tai tekijänoikeudella suojattuja tietoja. Kirjoittamasi teksti lähetetään itslearningistä EU:n ulkopuolelle käsiteltäväksi. Katso lisätietoja kohdasta ”Miten tämä toimii”.',
        Preview_survey: 'Kyselyn esikatselu',
        Previous: 'Edellinen',
        Print: 'Tulosta',
        QR_code: 'QR-koodi',
        QR_code_copied_to_clipboard: 'QR-koodin kuva kopioitu leikepöydälle',
        Quality: 'Laatu',
        Quality_Excellent: 'Erinomainen',
        Quality_Fair: 'Kohtalainen',
        Quality_Good: 'Hyvä',
        Quality_Poor: 'Heikko',
        Quality_Very_Poor: 'Erittäin heikko',
        Question: 'Kysymys',
        Question_has_been_saved: 'Kysymys tallennettu.',
        Question_number_header: 'Kysymyksen numero',
        Question_type: 'Kysymyksen tyyppi',
        Question_type_short: 'Tyyppi',
        Question_x: 'Kysymys {0}',
        Question_x_of_y: 'Kysymys {0} / {1}',
        Questions: 'Kysymykset',
        QuestionType_MultipleChoice_short: 'Monivalinta',
        QuestionType_YesNo_short: 'Kyllä/ei',
        Remember_visible: 'Muista, että kyselyn tulee olla vastaajien nähtävillä.',
        Remember_visible_and_deadline: 'Muista, että kyselyn tulee olla vastaajien nähtävillä ja määräajan tulee olla tulevaisuudessa.',
        Remove_alternative_x: 'Poista vaihtoehto {0}',
        Remove_statement_x: 'Poista väittämä {0}',
        Respondent: 'Vastaaja',
        Responses: 'Vastaukset',
        Responses_summary: 'Yhteenveto',
        Responses_x: 'Vastaukset: {0}',
        Satisfaction: 'Tyytyväisyys',
        Satisfaction_Completely_Satisfied: 'Täysin tyytyväinen',
        Satisfaction_Moderately_Satisfied: 'Kohtalaisen tyytyväinen',
        Satisfaction_Not_At_All_Satisfied: 'Ei lainkaan tyytyväinen',
        Satisfaction_Slightly_Satisfied: 'Hieman tyytyväinen',
        Satisfaction_Very_Satisfied: 'Erittäin tyytyväinen',
        Saturday: 'lauantai',
        Save: 'Tallenna',
        Save_and_new: 'Tallenna ja lisää uusi',
        Search: 'Hae',
        Search_for_respondents: 'Vastaajien hakeminen',
        Select_a_response_to_delete: 'Valitse poistettava vastaus',
        Select_all_questions: 'Valitse kaikki kysymykset',
        Select_at_least_one_question_to_delete: 'Valitse vähintään yksi poistettava kysymys',
        Select_question_x: 'Valitse kysymys {0}',
        Share: 'Jaa',
        Share_survey: 'Jaa kysely',
        Show_more: 'Näytä enemmän',
        Show_response: 'Näytä vastauksesi',
        Showing_x_responses_of_total_y_responses: 'Näyttää {0} vastausta yhteensä {1} vastauksesta',
        Start_moving_element_x: 'Käynnistä liikkuva elementti: {0}',
        Started: 'Aloitetut',
        Statement_x: 'Väittämä {0}',
        Statements_rows: 'Väittämät (rivit)',
        Student_satisfaction_cafeteria: 'opiskelijatyytyväisyys kahvilan ruokalistavaihtoehtoihin',
        Submit_answer: 'Lähetä vastaus',
        Submitted: 'Lähetetty',
        Submitted_after_deadline: 'Lähetetty määräajan jälkeen',
        Sunday: 'sunnuntai',
        Survey: 'Kysely',
        Survey_inactive_message: 'Tämä kysely ei ole enää käytettävissä. Voit jatkaa myöhemmin, jos se tulee jälleen saataville.',
        Survey_start_page: 'Kyselyn aloitussivu',
        Survey_title: 'Kysely',
        Survey_type: 'Kyselyn tyyppi',
        Take_survey: 'Tee kysely',
        Thanks_for_taking_the_survey: 'Kiitos kyselyyn vastaamisesta!',
        The_survey_is_about: 'Kyselyn aiheena on',
        Thursday: 'torstai',
        Tips_and_examples: 'Vinkkejä ja esimerkkejä',
        Tips_and_examples_info: 'Kirjoita lyhyesti ja ytimekkäästi saadaksesi hyödyllisiä tuloksia AI-palvelusta. Älä kirjoita ”Tämä on kysely aiheesta...”, koska se sisältyy jo lähettämäämme tekstiin. Esimerkkejä voivat olla:',
        Tuesday: 'tiistai',
        Unknown_error: 'Jokin meni pieleen. Mahdollisia syitä voivat olla ongelmat palvelussamme, että joku muokkaa kyselyä tai että verkkosi on epävakaa. Jos yhteytesi on kunnossa ja näet tämän viestin toistuvasti, ota yhteyttä järjestelmänvalvojaan.',
        View_question_x_of_y: 'Näytä kysymys {0} / {1}',
        Wednesday: 'keskiviikko',
        Yes: 'Kyllä',
        Yes_no_question: 'Kyllä/ei-kysymys',
        Your_response_will_not_be_saved: 'Vastaustasi ei tallenneta.',
    },
    'fr-FR': {
        Add_alternative: 'Ajouter une réponse possible',
        Add_question: 'Ajouter une question',
        Add_question_x: 'Ajouter une question {0}',
        Add_statement: 'Ajouter une déclaration',
        Agreement: 'Accord',
        Agreement_Agree: 'D’accord',
        Agreement_Disagree: 'Pas d’accord',
        Agreement_Neither_Agree_Nor_Disagree: 'Ni d’accord ni en désaccord',
        Agreement_Strongly_Agree: 'Tout à fait d’accord',
        Agreement_Strongly_Disagree: 'Pas du tout d’accord',
        Allow_respondents_to_select_more_than_one_alternative: 'Autoriser les personnes interrogées à sélectionner plusieurs réponses',
        Alternative_x: 'Choix de réponse {0}',
        Alternatives: 'Choix de réponses',
        Alternatives_columns: 'Alternatives (colonnes)',
        Anonymous: 'Anonyme',
        Anonymous_responses: 'Anonyme',
        Answer_type: 'Type de réponse',
        Answer_was_cleared: 'La réponse a été effacée',
        Ask_our_AI_info_message: 'Demandez à notre robot d’intelligence artificielle (IA) de générer le questionnaire pour vous. Par défaut, vous obtiendrez une introduction et des questions à choix multiples. Vous pouvez revoir et modifier le questionnaire après sa génération. Consultez les conseils ci-dessous pour plus de détails.',
        Autoloading: 'Chargement automatique',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Retour à la liste des questions',
        Back_to_responses: 'Retour aux réponses',
        Back_to_survey_details: 'Retour aux détails du questionnaire',
        Cancel: 'Annuler',
        Clear_answer: 'Effacer la réponse',
        Close: 'Zoom avant',
        Continue_survey: 'Poursuivre le questionnaire',
        Copy_public_link: 'Copier le lien public',
        Copy_QR_code: 'Copier le QR code',
        Create_survey: 'Créer un questionnaire',
        Create_survey_with_AI: 'Créer un questionnaire avec l’IA',
        Custom: 'Personnalisé',
        DateFormat_just_now: 'Maintenant',
        DateFormat_one_hour_ago: 'Il y a une heure',
        DateFormat_one_minute_ago: 'Il y a une minute',
        DateFormat_weekday_x_at_y: '{0} à {1}',
        DateFormat_x_days_ago: 'Il y a {0} jours',
        DateFormat_x_hours_ago: 'Il y a {0} heure(s)',
        DateFormat_x_minutes_ago: 'Il y a {0} minute(s)',
        DateFormat_yesterday_at_x: 'Hier à {0}',
        Deadline_has_passed_message: 'La date limite est dépassée et vous n’êtes plus autorisé à soumettre une réponse. Vous pourrez continuer plus tard si le délai est prolongé.',
        Delete: 'Supprimer',
        Delete_questions_modal_title: 'Supprimer les questions sélectionnées ?',
        Delete_responses: 'Supprimer des réponses ?',
        Download_responses: 'Télécharger les réponses (Excel)',
        Edit_question: 'Modifier une question',
        Edit_question_x_of_y: 'Modifier la question {0} de {1}',
        Edit_settings_info: 'Il n’est pas possible de modifier les paramètres d’anonymat une fois que quelqu’un a commencé le questionnaire.',
        Edit_survey: 'Modifier le questionnaire',
        Element_has_been_moved_to_position_x_of_y: 'L’élément a été déplacé en position {0} de {1}',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'Aucune réponse pour l’instant',
        Empty_state_no_responses_text: 'Les réponses apparaîtront ici dès que quelqu’un commencera à répondre au questionnaire.',
        Empty_survey_input_message: 'Vous devez indiquer le sujet sur lequel porte le questionnaire.',
        Evaluation_of_the_teaching: 'l’évaluation des méthodes d’enseignement dans les cours de sciences',
        Exit_preview: 'Quitter l’aperçu',
        Exit_survey: 'Quitter le questionnaire ?',
        Exit_survey_button: 'Quitter le questionnaire',
        External_and_anonymous: 'Externe et anonyme. Toute personne disposant d’un lien peut répondre.',
        External_survey: 'Externe - toute personne disposant du lien peut répondre',
        Frequency: 'Fréquence',
        Frequency_Always: 'Toujours',
        Frequency_Never: 'Jamais',
        Frequency_Often: 'Souvent',
        Frequency_Rarely: 'Rarement',
        Frequency_Sometimes: 'Parfois',
        Friday: 'Vendredi',
        Generate_survey: 'Générer un questionnaire',
        Grid_no_questions_heading: 'Nombre de questions',
        Grid_no_questions_text: 'Vous n’avez pas encore créé de questions.',
        Homework_habits: 'les habitudes concernant les devoirs',
        How_does_this_work: 'Comment cela fonctionne-t-il ?',
        How_does_this_work_info_part1: 'Vos données d’alimentation sont utilisées dans le cadre de l’invite que nous envoyons pour traitement. En fonction de la réponse, nous générons un questionnaire comportant une introduction et des questions à choix multiples avec 5 possibilités de réponse (de « tout à fait d’accord » à « pas du tout d’accord »). Vous pourrez modifier et ajuster tout le contenu avant de distribuer le questionnaire.',
        How_does_this_work_info_part2: 'itslearning n’est pas responsable du contenu du questionnaire généré. Nous ne modérons pas la réponse du service d’IA, qui peut produire des informations inexactes sur les personnes, les lieux ou les faits. Le service auquel nous nous connectons est assuré par OpenAI, avec le modèle de chat GPT-3.5-turbo.',
        Importance: 'Importance',
        Importance_Extremely_Important: 'Extrêmement important',
        Importance_Moderately_Important: 'Modérément important',
        Importance_Not_At_All_Important: 'Pas du tout important',
        Importance_Slightly_Important: 'Peu important',
        Importance_Very_Important: 'Très important',
        Imported_rich_text_edit_warning: 'Ce texte a été importé de l’ancien outil du questionnaire. Lorsque vous l’enregistrez, toutes les mises en forme et le contenu en texte enrichi (par exemple les images) sont enlevés.',
        Introduction: 'Introduction',
        Link_copied_to_clipboard: 'Lien copié dans le presse-papiers',
        Link_to_survey: 'Lien vers le questionnaire',
        Matrix_question: 'Question matricielle',
        Monday: 'Lundi',
        Move_element_instructions: 'Pour déplacer cet élément, appuyez sur espace et utilisez la flèche vers le haut ou vers le bas. Appuyez à nouveau sur la touche espace pour terminer.',
        Moving_element_to_position_x_of_y: 'Déplacement de l’élément à la position {0} de {1}',
        Multiple_choice_question: 'Question à choix multiples',
        Next: 'Suivant',
        No: 'Non',
        No_respondents: 'Aucune réponse',
        Not_anonymous: 'Pas anonyme',
        Not_possible_to_edit_questions_message: 'Vous ne pouvez plus ajouter, éditer ou supprimer des questions car quelqu’un a commencé à répondre à ce questionnaire.',
        Note: 'Remarque',
        Number_of_questions: 'Nombre de questions',
        Number_of_respondents_x: 'Nombre de personnes interrogées : {0}',
        Number_responded_x: 'Nombre de réponses : {0}',
        Numbers: 'Nombres',
        Ok: 'OK',
        Open_answer_heading: 'Réponse',
        Open_question: 'Question ouverte',
        Personal_data_warning: 'Ne saisissez pas d’informations personnelles ou protégées par droit d’auteur. Vos données sont envoyées par itslearning en dehors de l’UE pour être traitées. Voir « Comment cela fonctionne » pour plus de détails.',
        Preview_survey: 'Prévisualiser le questionnaire',
        Previous: 'Précédent',
        Print: 'Imprimer',
        QR_code: 'QR code',
        QR_code_copied_to_clipboard: 'Image du QR code copiée dans le presse-papiers',
        Quality: 'Qualité',
        Quality_Excellent: 'Excellent',
        Quality_Fair: 'Suffisant',
        Quality_Good: 'Bien',
        Quality_Poor: 'Mauvais',
        Quality_Very_Poor: 'Très mauvais',
        Question: 'Question',
        Question_has_been_saved: 'La question a été enregistrée.',
        Question_number_header: 'Numéro de question',
        Question_type: 'Type de question',
        Question_type_short: 'Type',
        Question_x: 'Question {0}',
        Question_x_of_y: 'Question {0} de {1}',
        Questions: 'Questions',
        QuestionType_MultipleChoice_short: 'Choix multiples',
        QuestionType_YesNo_short: 'Oui/Non',
        Remember_visible: 'N’oubliez pas que le questionnaire doit être visible pour les personnes qui y répondront.',
        Remember_visible_and_deadline: 'N’oubliez pas que le questionnaire doit être visible pour les personnes qui y répondront et que la date limite doit être ultérieure à aujourd’hui.',
        Remove_alternative_x: 'Enlever une réponse possible {0}',
        Remove_statement_x: 'Enlever la déclaration {0}',
        Respondent: 'Personne interrogée',
        Responses: 'Réponses',
        Responses_summary: 'Récapitulatif',
        Responses_x: 'Réponses : {0}',
        Satisfaction: 'Satisfaction',
        Satisfaction_Completely_Satisfied: 'Totalement satisfait',
        Satisfaction_Moderately_Satisfied: 'Modérément satisfait',
        Satisfaction_Not_At_All_Satisfied: 'Pas du tout satisfait',
        Satisfaction_Slightly_Satisfied: 'Peu satisfait',
        Satisfaction_Very_Satisfied: 'Très satisfait',
        Saturday: 'Samedi',
        Save: 'Enregistrer',
        Save_and_new: 'Enregistrer et ajouter une nouvelle question du même type',
        Search: 'Rechercher',
        Search_for_respondents: 'Recherche de personnes interrogées',
        Select_a_response_to_delete: 'Sélectionner une réponse à supprimer',
        Select_all_questions: 'Sélectionner toutes les questions',
        Select_at_least_one_question_to_delete: 'Sélectionnez au moins une question à supprimer',
        Select_question_x: 'Sélectionner une question {0}',
        Share: 'Partager',
        Share_survey: 'Partager le questionnaire',
        Show_more: 'Afficher plus',
        Show_response: 'Afficher votre réponse',
        Showing_x_responses_of_total_y_responses: 'Afficher {0} réponses sur un total de {1} réponses',
        Start_moving_element_x: 'Commencer à déplacer l’élément : {0}',
        Started: 'Commencé',
        Statement_x: 'Déclaration {0}',
        Statements_rows: 'Instructions (lignes)',
        Student_satisfaction_cafeteria: 'la satisfaction des élèves à l’égard des menus proposés à la cafétéria',
        Submit_answer: 'Répondre',
        Submitted: 'Rendu',
        Submitted_after_deadline: 'Rendu après la date limite',
        Sunday: 'Dimanche',
        Survey: 'Questionnaire',
        Survey_inactive_message: 'Ce questionnaire n’est plus disponible. Vous pourrez continuer plus tard si ce dernier est à nouveau disponible.',
        Survey_start_page: 'Page de démarrage du questionnaire',
        Survey_title: 'Questionnaire',
        Survey_type: 'Type de questionnaire',
        Take_survey: 'Répondre au questionnaire',
        Thanks_for_taking_the_survey: 'Merci d’avoir répondu au questionnaire !',
        The_survey_is_about: 'Le questionnaire porte sur',
        Thursday: 'Jeudi',
        Tips_and_examples: 'Conseils et exemples',
        Tips_and_examples_info: 'Pour obtenir des résultats utiles du service d’IA, veillez à ce que les données d’alimentation soient courtes et concises. N’écrivez pas « Ceci est un questionnaire sur… », car cela est déjà inclus dans le texte que nous envoyons. Voici quelques exemples de données :',
        Tuesday: 'Mardi',
        Unknown_error: 'Quelque chose n’a pas fonctionné. Il peut s’agir d’un problème avec notre service, d’une personne qui modifie le questionnaire ou d’une instabilité de votre réseau. Si votre connexion est bonne et que vous continuez à voir ce message, veuillez contacter votre administrateur.',
        View_question_x_of_y: 'Voir la question {0} de {1}',
        Wednesday: 'Mercredi',
        Yes: 'Oui',
        Yes_no_question: 'Question de type Oui/Non',
        Your_response_will_not_be_saved: 'Votre réponse ne sera pas enregistrée.',
    },
    'it-IT': {
        Add_alternative: 'Aggiungi alternativa',
        Add_question: 'Aggiungi domanda',
        Add_question_x: 'Aggiungi la domanda {0}',
        Add_statement: 'Aggiungi affermazione',
        Agreement: 'Accordo',
        Agreement_Agree: 'Concordo',
        Agreement_Disagree: 'Non concordo',
        Agreement_Neither_Agree_Nor_Disagree: 'Né concordo né non concordo',
        Agreement_Strongly_Agree: 'Concordo fortemente',
        Agreement_Strongly_Disagree: 'Non concordo in assoluto',
        Allow_respondents_to_select_more_than_one_alternative: 'Consenti agli intervistati di selezionare più di un’alternativa',
        Alternative_x: 'Alternativa {0}',
        Alternatives: 'Alternative',
        Alternatives_columns: 'Alternative (colonne)',
        Anonymous: 'Anonimo',
        Anonymous_responses: 'Anonimo',
        Answer_type: 'Tipo di risposta',
        Answer_was_cleared: 'La risposta è stata cancellata',
        Ask_our_AI_info_message: 'Chiedi al nostro robot di intelligenza artificiale (IA) di generare il sondaggio al tuo posto. In modo predefinito otterrai un\'introduzione e domande a scelta multipla. Puoi controllare e modificare il sondaggio dopo averlo generato. Consulta i suggerimenti riportati di seguito per maggiori informazioni.',
        Autoloading: 'Caricamento automatico',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Torna all\'elenco delle domande',
        Back_to_responses: 'Torna alle risposte',
        Back_to_survey_details: 'Torna ai dettagli del sondaggio',
        Cancel: 'Annulla',
        Clear_answer: 'Cancella risposta',
        Close: 'Chiudi',
        Continue_survey: 'Continua il sondaggio',
        Copy_public_link: 'Copia link pubblico',
        Copy_QR_code: 'Copia codice QR',
        Create_survey: 'Crea sondaggio',
        Create_survey_with_AI: 'Crea un sondaggio con la IA',
        Custom: 'Personalizzato',
        DateFormat_just_now: 'In questo momento',
        DateFormat_one_hour_ago: '1 ora fa',
        DateFormat_one_minute_ago: '1 minuto fa',
        DateFormat_weekday_x_at_y: '{0} alle {1}',
        DateFormat_x_days_ago: '{0} giorni fa',
        DateFormat_x_hours_ago: '{0} ore fa',
        DateFormat_x_minutes_ago: '{0} minuti fa',
        DateFormat_yesterday_at_x: 'Ieri alle {0}',
        Deadline_has_passed_message: 'La scadenza è stata superata e non puoi più inviare risposte. Puoi proseguire in un altro momento se la scadenza viene prorogata.',
        Delete: 'Elimina',
        Delete_questions_modal_title: 'Vuoi eliminare le domande selezionate?',
        Delete_responses: 'Eliminare le risposte?',
        Download_responses: 'Scarica le risposte (Excel)',
        Edit_question: 'Modifica domanda',
        Edit_question_x_of_y: 'Modifica la domanda {0} di {1}',
        Edit_settings_info: 'Non è possibile modificare le impostazioni anonime dopo che qualcuno ha iniziato il sondaggio.',
        Edit_survey: 'Modifica sondaggio',
        Element_has_been_moved_to_position_x_of_y: 'L\'elemento è stato spostato in posizione {0} di {1}',
        Emojis: 'Emoji',
        Empty_state_no_responses_heading: 'Non c’è ancora nessuna risposta',
        Empty_state_no_responses_text: 'Le risposte verranno visualizzate qui quando qualcuno inizia a partecipare al sondaggio.',
        Empty_survey_input_message: 'Devi scrivere l’argomento del sondaggio.',
        Evaluation_of_the_teaching: 'valutazione dei metodi didattici nella lezione di scienze',
        Exit_preview: 'Esci dall’anteprima',
        Exit_survey: 'Uscire dal sondaggio?',
        Exit_survey_button: 'Esci dal sondaggio',
        External_and_anonymous: 'Esterno e anonimo. Può rispondere chiunque disponga del link.',
        External_survey: 'Esterno - può rispondere chiunque disponga del link',
        Frequency: 'Frequenza',
        Frequency_Always: 'Sempre',
        Frequency_Never: 'Mai',
        Frequency_Often: 'Spesso',
        Frequency_Rarely: 'Raramente',
        Frequency_Sometimes: 'A volte',
        Friday: 'Venerdì',
        Generate_survey: 'Genera sondaggio',
        Grid_no_questions_heading: 'Nessuna domanda',
        Grid_no_questions_text: 'Non hai ancora creato nessuna domanda.',
        Homework_habits: 'abitudini dei compiti per casa',
        How_does_this_work: 'Come funziona?',
        How_does_this_work_info_part1: 'L’input viene utilizzato come parte del prompt che inviamo per l\'elaborazione. In base alla risposta, generiamo un sondaggio con un\'introduzione e domande a scelta multipla con 5 alternative di risposta (da "Concordo fortemente" a "Non concordo in assoluto"). Potrai modificare e adattare tutti i contenuti prima di distribuire il sondaggio.',
        How_does_this_work_info_part2: 'itslearning non è responsabile del contenuto del sondaggio generato. Non moderiamo la risposta del servizio della IA, che potrebbe produrre informazioni non corrette su persone, luoghi o fatti. Il servizio a cui ci colleghiamo è fornito da OpenAI, utilizzando il modello di chat GPT-3.5-turbo.',
        Importance: 'Importanza',
        Importance_Extremely_Important: 'Estremamente importante',
        Importance_Moderately_Important: 'Moderatamente importante',
        Importance_Not_At_All_Important: 'Per niente importante',
        Importance_Slightly_Important: 'Leggermente importante',
        Importance_Very_Important: 'Molto importante',
        Imported_rich_text_edit_warning: 'Questo testo è stato importato dal vecchio strumento dei sondaggi. Quando salvi, tutta la formattazione e il contenuto RTF (ad esempio le immagini) vengono rimossi.',
        Introduction: 'Introduzione',
        Link_copied_to_clipboard: 'Link copiato negli appunti',
        Link_to_survey: 'Link al sondaggio',
        Matrix_question: 'Domanda Matrice',
        Monday: 'Lunedì',
        Move_element_instructions: 'Per spostare questo elemento, premere lo spazio e utilizzare la freccia verso l’alto o la freccia verso il basso. Premere nuovamente lo spazio per terminare.',
        Moving_element_to_position_x_of_y: 'Spostamento dell\'elemento in posizione {0} di {1}',
        Multiple_choice_question: 'Domanda a scelta multipla',
        Next: 'Successivo',
        No: 'No',
        No_respondents: 'Nessun intervistato',
        Not_anonymous: 'Non anonimo',
        Not_possible_to_edit_questions_message: 'Non puoi più aggiungere, modificare o eliminare domande perché qualcuno ha iniziato a partecipare a questo sondaggio.',
        Note: 'Nota',
        Number_of_questions: 'Numero di domande',
        Number_of_respondents_x: 'Numero di intervistati: {0}',
        Number_responded_x: 'Numero di risposte: {0}',
        Numbers: 'Numeri',
        Ok: 'OK',
        Open_answer_heading: 'Risposta',
        Open_question: 'Domanda aperta',
        Personal_data_warning: 'Non inserire informazioni personali o protette da copyright. Il tuo contributo viene inviato da itslearning fuori dell\'UE per l\'elaborazione. Consulta la sezione "Come funziona" per maggiori informazioni.',
        Preview_survey: 'Anteprima del sondaggio',
        Previous: 'Precedente',
        Print: 'Stampa',
        QR_code: 'Codice QR',
        QR_code_copied_to_clipboard: 'Immagine del codice QR copiata negli appunti',
        Quality: 'Qualità',
        Quality_Excellent: 'Eccellente',
        Quality_Fair: 'Discreta',
        Quality_Good: 'Buona',
        Quality_Poor: 'Scarsa',
        Quality_Very_Poor: 'Molto scarsa',
        Question: 'Domanda',
        Question_has_been_saved: 'La domanda è stata salvata.',
        Question_number_header: 'Numero domanda',
        Question_type: 'Tipo di domanda',
        Question_type_short: 'Tipo',
        Question_x: 'Domanda {0}',
        Question_x_of_y: 'Domanda {0} di {1}',
        Questions: 'Domande',
        QuestionType_MultipleChoice_short: 'Scelta multipla',
        QuestionType_YesNo_short: 'Sì/No',
        Remember_visible: 'Ricorda che il sondaggio deve essere visibile agli intervistati.',
        Remember_visible_and_deadline: 'Ricorda che il sondaggio deve essere visibile agli intervistati e la scadenza deve essere futura.',
        Remove_alternative_x: 'Rimuovi alternativa {0}',
        Remove_statement_x: 'Rimuovi affermazione {0}',
        Respondent: 'Interpellato',
        Responses: 'Risposte',
        Responses_summary: 'Riepilogo',
        Responses_x: 'Risposte: {0}',
        Satisfaction: 'Soddisfazione',
        Satisfaction_Completely_Satisfied: 'Completamente soddisfatto',
        Satisfaction_Moderately_Satisfied: 'Moderatamente soddisfatto',
        Satisfaction_Not_At_All_Satisfied: 'Per niente soddisfatto',
        Satisfaction_Slightly_Satisfied: 'Leggermente soddisfatto',
        Satisfaction_Very_Satisfied: 'Molto soddisfatto',
        Saturday: 'Sabato',
        Save: 'Salva',
        Save_and_new: 'Salva e crea nuovo',
        Search: 'Cerca',
        Search_for_respondents: 'Ricerca di intervistati',
        Select_a_response_to_delete: 'Seleziona una risposta da eliminare',
        Select_all_questions: 'Seleziona tutte le domande',
        Select_at_least_one_question_to_delete: 'Seleziona almeno una domanda da eliminare',
        Select_question_x: 'Seleziona la domanda {0}',
        Share: 'Condividi',
        Share_survey: 'Condividi sondaggio',
        Show_more: 'Mostra altro',
        Show_response: 'Mostra la tua risposta',
        Showing_x_responses_of_total_y_responses: 'Mostra {0} risposte del totale di {1} risposte',
        Start_moving_element_x: 'Inizia lo spostamento dell’elemento: {0}',
        Started: 'Avviati',
        Statement_x: 'Affermazione {0}',
        Statements_rows: 'Affermazioni (righe)',
        Student_satisfaction_cafeteria: 'soddisfazione dello studente rispetto alle opzioni del menu del bar',
        Submit_answer: 'Invia risposta',
        Submitted: 'Inviato',
        Submitted_after_deadline: 'Inviato dopo la scadenza',
        Sunday: 'Domenica',
        Survey: 'Sondaggio',
        Survey_inactive_message: 'Questo sondaggio non è più disponibile. Puoi proseguire in un altro momento se sarà nuovamente disponibile.',
        Survey_start_page: 'Pagina di inizio del sondaggio',
        Survey_title: 'Sondaggio',
        Survey_type: 'Tipo di sondaggio',
        Take_survey: 'Partecipa al sondaggio',
        Thanks_for_taking_the_survey: 'Grazie per aver partecipato al sondaggio!',
        The_survey_is_about: 'Il sondaggio riguarda',
        Thursday: 'Giovedì',
        Tips_and_examples: 'Suggerimenti ed esempi',
        Tips_and_examples_info: 'Per ottenere risultati utili dalla IA, offri input brevi e concisi. Non scrivere "È un sondaggio su…" poiché è già incluso nel testo che inviamo. Possibili esempi di input sono:',
        Tuesday: 'Martedì',
        Unknown_error: 'Si è verificato un problema. I possibili motivi potrebbero essere problemi attinenti al nostro servizio, che qualcuno sta modificando il sondaggio o che la tua rete non è stabile. Se la connessione è OK e continui a visualizzare questo messaggio, contatta l\'amministratore.',
        View_question_x_of_y: 'Visualizza la domanda {0} di {1}',
        Wednesday: 'Mercoledì',
        Yes: 'Sì',
        Yes_no_question: 'Domanda sì/no',
        Your_response_will_not_be_saved: 'La tua risposta non verrà salvata.',
    },
    'lt-LT': {
        Add_alternative: 'Pridėti alternatyvą',
        Add_question: 'Pridėti klausimą',
        Add_question_x: 'Pridėti {0} klausimą',
        Add_statement: 'Pridėti teiginį',
        Agreement: 'Sutikimas',
        Agreement_Agree: 'Sutinku',
        Agreement_Disagree: 'Nesutinku',
        Agreement_Neither_Agree_Nor_Disagree: 'Nei sutinku, nei nesutinku',
        Agreement_Strongly_Agree: 'Visiškai sutinku',
        Agreement_Strongly_Disagree: 'Griežtai nesutinku',
        Allow_respondents_to_select_more_than_one_alternative: 'Leisti respondentams pasirinkti daugiau nei vieną alternatyvą',
        Alternative_x: '{0} alternatyva',
        Alternatives: 'Alternatyvos',
        Alternatives_columns: 'Alternatyvos (stulpeliai)',
        Anonymous: 'Anonimiškai',
        Anonymous_responses: 'Anonimiškai',
        Answer_type: 'Atsakymo tipas',
        Answer_was_cleared: 'Atsakymas buvo ištrintas',
        Ask_our_AI_info_message: 'Paprašykite mūsų dirbtinio intelekto (DI) roboto sugeneruoti apklausą už jus. Pagal numatytąsias nuostatas gausite įvadą ir klausimus su keliais atsakymų variantais. Galite peržiūrėti ir redaguoti apklausą, kai ji bus sugeneruota. Norėdami gauti daugiau informacijos, žiūrėkite toliau pateiktus patarimus.',
        Autoloading: 'Automatinis įkėlimas',
        Avatar: 'Avataras',
        Back_to_list_of_questions: 'Grįžti į klausimų sąrašą',
        Back_to_responses: 'Grįžti į atsakymus',
        Back_to_survey_details: 'Grįžti į apklausos informaciją',
        Cancel: 'Atšaukti',
        Clear_answer: 'Išvalyti atsakymą',
        Close: 'Užverti',
        Continue_survey: 'Tęsti apklausą',
        Copy_public_link: 'Kopijuoti viešąją nuorodą',
        Copy_QR_code: 'Kopijuoti QR kodą',
        Create_survey: 'Apklausos kūrimas',
        Create_survey_with_AI: 'Apklausos kūrimas naudojant DI',
        Custom: 'Pasirenkamasis',
        DateFormat_just_now: 'Ką tik',
        DateFormat_one_hour_ago: 'Prieš 1 val.',
        DateFormat_one_minute_ago: 'Prieš 1 min.',
        DateFormat_weekday_x_at_y: '{0}, {1}',
        DateFormat_x_days_ago: 'Prieš {0} d.',
        DateFormat_x_hours_ago: 'Prieš {0} val.',
        DateFormat_x_minutes_ago: 'Prieš {0} min.',
        DateFormat_yesterday_at_x: 'Vakar {0}',
        Deadline_has_passed_message: 'Terminas baigėsi ir jums nebeleidžiama pateikti atsakymo. Galėsite tęsti vėliau, jei terminas bus pratęstas.',
        Delete: 'Ištrinti',
        Delete_questions_modal_title: 'Ištrinti pasirinktus klausimus?',
        Delete_responses: 'Ištrinti atsakymus?',
        Download_responses: 'Atsisiųsti atsakymus („Excel“)',
        Edit_question: 'Redaguoti klausimą',
        Edit_question_x_of_y: 'Redaguoti {0} klausimą iš {1}',
        Edit_settings_info: 'Neįmanoma redaguoti anonimiškumo parametrų, kai kas nors pradeda pildyti apklausą.',
        Edit_survey: 'Redaguoti apklausą',
        Element_has_been_moved_to_position_x_of_y: 'Elementas perkeltas į {0} padėtį iš {1}',
        Emojis: 'Jaustukai',
        Empty_state_no_responses_heading: 'Atsakymų dar nėra',
        Empty_state_no_responses_text: 'Atsakymai bus rodomi čia, kai kas nors pradės pildyti apklausą.',
        Empty_survey_input_message: 'Turite parašyti, apie ką yra apklausa.',
        Evaluation_of_the_teaching: 'Mokymo metodų vertinimas gamtos mokslų pamokoje',
        Exit_preview: 'Išeiti iš peržiūros',
        Exit_survey: 'Išeiti iš apklausos?',
        Exit_survey_button: 'Išeiti iš apklausos',
        External_and_anonymous: 'Išorinis ir anoniminis. Kiekvienas, turintis nuorodą, gali atsakyti.',
        External_survey: 'Išorinis – kiekvienas, turintis nuorodą, gali pildyti',
        Frequency: 'Dažnis',
        Frequency_Always: 'Visada',
        Frequency_Never: 'Niekada',
        Frequency_Often: 'Dažnai',
        Frequency_Rarely: 'Retai',
        Frequency_Sometimes: 'Kartais',
        Friday: 'Penktadienis',
        Generate_survey: 'Generuoti apklausą',
        Grid_no_questions_heading: 'Klausimų nėra',
        Grid_no_questions_text: 'Dar nesukūrėte jokių klausimų.',
        Homework_habits: 'Namų darbų įpročiai',
        How_does_this_work: 'Kaip tai veikia?',
        How_does_this_work_info_part1: 'Jūsų įvestis naudojama kaip raginimo, kurį siunčiame apdoroti, dalis. Remdamiesi atsakymu, sugeneruojame apklausą su įvadu ir klausimais su pasirenkamais 5 atsakymų variantais (nuo „visiškai sutinku“ iki „visiškai nesutinku“). Prieš platindami apklausą galėsite redaguoti ir koreguoti visą turinį.',
        How_does_this_work_info_part2: '„itslearning“ neatsako už sugeneruotos apklausos turinį. Mes nemoderuojame DI tarnybos atsakymo, jis gali pateikti netikslią informaciją apie žmones, vietas ar faktus. Paslaugą, prie kurios jungiamės, teikia „OpenAI“, naudodama „GPT-3.5-turbo“ pokalbių modelį.',
        Importance: 'Svarba',
        Importance_Extremely_Important: 'Labai svarbu',
        Importance_Moderately_Important: 'Vidutiniškai svarbu',
        Importance_Not_At_All_Important: 'Visai nesvarbu',
        Importance_Slightly_Important: 'Šiek tiek svarbu',
        Importance_Very_Important: 'Svarbu',
        Imported_rich_text_edit_warning: 'Šis tekstas buvo importuotas iš senojo apklausos įrankio. Kai išsaugosite, visas formatavimas ir raiškiojo teksto turinys (pvz., vaizdai) bus pašalinti.',
        Introduction: 'Įvadas',
        Link_copied_to_clipboard: 'Nuoroda nukopijuota į iškarpinę',
        Link_to_survey: 'Nuoroda į apklausą',
        Matrix_question: 'Matricos klausimas',
        Monday: 'Pirmadienis',
        Move_element_instructions: 'Norėdami perkelti šį elementą, paspauskite tarpo klavišą ir naudokite rodykles aukštyn arba žemyn. Dar kartą paspauskite tarpo klavišą, kad užbaigtumėte.',
        Moving_element_to_position_x_of_y: 'Elemento perkėlimas į {0} padėtį iš {1}',
        Multiple_choice_question: 'Klausimas su keliais galimais atsakymais',
        Next: 'Kitas',
        No: 'Ne',
        No_respondents: 'Respondentų nėra',
        Not_anonymous: 'Neanonimiškai',
        Not_possible_to_edit_questions_message: 'Nebegalite pridėti, redaguoti ar ištrinti klausimų, nes kažkas pradėjo pildyti šią apklausą.',
        Note: 'Pastaba',
        Number_of_questions: 'Klausimų skaičius',
        Number_of_respondents_x: 'Respondentų skaičius: {0}',
        Number_responded_x: 'Atsakiusiųjų skaičius: {0}',
        Numbers: 'Skaičiai',
        Ok: 'Gerai',
        Open_answer_heading: 'Atsakymas',
        Open_question: 'Atviras klausimas',
        Personal_data_warning: 'Neįveskite jokios asmeninės ar autorių teisių saugomos informacijos. Jūsų informacija siunčiama iš „itslearning“ už ES ribų, kad ji būtų apdorota. Daugiau informacijos rasite skyriuje „Kaip tai veikia“.',
        Preview_survey: 'Peržiūrėti apklausą',
        Previous: 'Ankstesnis',
        Print: 'Spausdinti',
        QR_code: 'QR kodas',
        QR_code_copied_to_clipboard: 'QR kodo atvaizdas nukopijuotas į iškarpinę',
        Quality: 'Kokybė',
        Quality_Excellent: 'Puikus',
        Quality_Fair: 'Vidutinis',
        Quality_Good: 'Geras',
        Quality_Poor: 'Prastas',
        Quality_Very_Poor: 'Labai prastas',
        Question: 'Klausimas',
        Question_has_been_saved: 'Klausimas buvo išsaugotas.',
        Question_number_header: 'Klausimo numeris',
        Question_type: 'Klausimo tipas',
        Question_type_short: 'Tipas',
        Question_x: 'Klausimas {0}',
        Question_x_of_y: 'Klausimas {0} iš {1}',
        Questions: 'Klausimai',
        QuestionType_MultipleChoice_short: 'Keli pasirinkimai',
        QuestionType_YesNo_short: 'Taip / ne',
        Remember_visible: 'Atminkite, kad apklausa turi būti matoma respondentams.',
        Remember_visible_and_deadline: 'Atminkite, kad apklausa turi būti matoma respondentams, o galutinis terminas turi būti ateityje.',
        Remove_alternative_x: 'Pašalinti {0} alternatyvą',
        Remove_statement_x: 'Pašalinti {0} teiginį',
        Respondent: 'Respondentas',
        Responses: 'Atsakymai',
        Responses_summary: 'Santrauka',
        Responses_x: 'Atsakymai: {0}',
        Satisfaction: 'Pasitenkinimas',
        Satisfaction_Completely_Satisfied: 'Visiškai patenkintas (-a)',
        Satisfaction_Moderately_Satisfied: 'Vidutiniškai patenkintas (-a)',
        Satisfaction_Not_At_All_Satisfied: 'Visiškai nepatenkintas (-a)',
        Satisfaction_Slightly_Satisfied: 'Šiek tiek patenkintas (-a)',
        Satisfaction_Very_Satisfied: 'Labai patenkintas (-a)',
        Saturday: 'Šeštadienis',
        Save: 'Įrašyti',
        Save_and_new: 'Įrašyti ir pridėti naują',
        Search: 'Paieška',
        Search_for_respondents: 'Ieškoti respondentų',
        Select_a_response_to_delete: 'Pasirinkite norimą ištrinti atsakymą',
        Select_all_questions: 'Pasirinkti visus klausimus',
        Select_at_least_one_question_to_delete: 'Pasirinkite bent vieną klausimą, kurį norite ištrinti',
        Select_question_x: 'Pasirinkti {0} klausimą',
        Share: 'Bendrinti',
        Share_survey: 'Dalytis apklausa',
        Show_more: 'Rodyti daugiau',
        Show_response: 'Rodyti jūsų atsakymą',
        Showing_x_responses_of_total_y_responses: 'Rodoma {0} iš {1} atsakymų',
        Start_moving_element_x: 'Perkelkite elementą: {0}',
        Started: 'Pradėta',
        Statement_x: '{0} teiginys',
        Statements_rows: 'Teiginiai (eilutės)',
        Student_satisfaction_cafeteria: 'Studentų pasitenkinimas meniu pasirinkimais kavinėje',
        Submit_answer: 'Pateikti atsakymą',
        Submitted: 'Pateikta',
        Submitted_after_deadline: 'Pateikta praėjus terminui',
        Sunday: 'Sekmadienis',
        Survey: 'Apklausa',
        Survey_inactive_message: 'Ši apklausa nebepasiekiama. Galite tęsti vėliau, jei ji vėl bus pasiekiama.',
        Survey_start_page: 'Apklausos pradžios puslapis',
        Survey_title: 'Apklausa',
        Survey_type: 'Apklausos tipas',
        Take_survey: 'Pildyti apklausą',
        Thanks_for_taking_the_survey: 'Dėkojame, kad dalyvavote apklausoje!',
        The_survey_is_about: 'Apklausa yra apie',
        Thursday: 'Ketvirtadienis',
        Tips_and_examples: 'Patarimai ir pavyzdžiai',
        Tips_and_examples_info: 'Norint gauti naudingą DI paslaugos išvestį, įvestis turi būti trumpa ir glausta. Nerašykite „Tai apklausa apie...“, nes tai jau įtraukta į mūsų siunčiamą tekstą. Įvesties pavyzdžiai galėtų būti:',
        Tuesday: 'Antradienis',
        Unknown_error: 'Kažkas nepavyko. Galimos priežastys – problemos su mūsų paslauga, kažkas redaguoja apklausą arba jūsų tinklas yra nestabilus. Jei jūsų ryšys yra tinkamas ir toliau matote šį pranešimą, kreipkitės į administratorių.',
        View_question_x_of_y: 'Peržiūrėti {0} klausimą iš {1}',
        Wednesday: 'Trečiadienis',
        Yes: 'Taip',
        Yes_no_question: '„Taip / ne“ klausimas',
        Your_response_will_not_be_saved: 'Jūsų atsakymas nebus išsaugotas.',
    },
    'nb-NO': {
        Add_alternative: 'Legg til alternativ',
        Add_question: 'Legg til spørsmål',
        Add_question_x: 'Legg til spørsmål {0}',
        Add_statement: 'Legg til utsagn',
        Agreement: 'Enighet',
        Agreement_Agree: 'Enig',
        Agreement_Disagree: 'Uenig',
        Agreement_Neither_Agree_Nor_Disagree: 'Verken enig eller uenig',
        Agreement_Strongly_Agree: 'Helt enig',
        Agreement_Strongly_Disagree: 'Sterkt uenig',
        Allow_respondents_to_select_more_than_one_alternative: 'Tillat at respondentene velger flere enn ett alternativ',
        Alternative_x: 'Alternativ {0}',
        Alternatives: 'Alternativer',
        Alternatives_columns: 'Alternativer (kolonner)',
        Anonymous: 'Anonym',
        Anonymous_responses: 'Anonym',
        Answer_type: 'Svartype',
        Answer_was_cleared: 'Svaret ble fjernet',
        Ask_our_AI_info_message: 'Her kan du bruke kunstig intelligens (KI) til å lage undersøkelsen for deg. Som standard vil du få en introduksjon og flervalgsoppgaver. Du kan se gjennom og redigere undersøkelsen når den er opprettet. Se tipsene nedenfor om du trenger mer informasjon.',
        Autoloading: 'Autolasting',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Tilbake til spørsmålslisten',
        Back_to_responses: 'Tilbake til svarene',
        Back_to_survey_details: 'Tilbake til detaljer om undersøkelsen',
        Cancel: 'Avbryt',
        Clear_answer: 'Fjern besvarelse',
        Close: 'Lukk',
        Continue_survey: 'Fortsett undersøkelsen',
        Copy_public_link: 'Kopier offentlig lenke',
        Copy_QR_code: 'Kopier QR-kode',
        Create_survey: 'Opprett undersøkelse',
        Create_survey_with_AI: 'Opprett undersøkelse med KI',
        Custom: 'Egendefinert',
        DateFormat_just_now: 'Akkurat nå',
        DateFormat_one_hour_ago: '1 time siden',
        DateFormat_one_minute_ago: '1 minutt siden',
        DateFormat_weekday_x_at_y: '{0} kl. {1}',
        DateFormat_x_days_ago: 'For {0} dager siden',
        DateFormat_x_hours_ago: '{0} timer siden',
        DateFormat_x_minutes_ago: '{0} minutter siden',
        DateFormat_yesterday_at_x: 'I går kl. {0}',
        Deadline_has_passed_message: 'Fristen er utløpt, og du har ikke lenger lov til å sende inn svar. Du kan fortsette senere hvis fristen forlenges.',
        Delete: 'Slett',
        Delete_questions_modal_title: 'Slette valgte spørsmål?',
        Delete_responses: 'Slette svar?',
        Download_responses: 'Last ned svar (Excel)',
        Edit_question: 'Rediger spørsmål',
        Edit_question_x_of_y: 'Rediger spørsmål {0} av {1}',
        Edit_settings_info: 'Det er ikke mulig å endre type undersøkelse etter at noen har startet undersøkelsen.',
        Edit_survey: 'Rediger undersøkelse',
        Element_has_been_moved_to_position_x_of_y: 'Element er flyttet til posisjon {0} av {1}',
        Emojis: 'Emojier',
        Empty_state_no_responses_heading: 'Ingen svar ennå',
        Empty_state_no_responses_text: 'Svarene vises her når noen begynner å ta undersøkelsen.',
        Empty_survey_input_message: 'Du må skrive hva undersøkelsen handler om.',
        Evaluation_of_the_teaching: 'evaluering av undervisningsmetoder i naturfagsklassen',
        Exit_preview: 'Avslutt forhåndsvisning',
        Exit_survey: 'Avslutte undersøkelse?',
        Exit_survey_button: 'Avslutt undersøkelse',
        External_and_anonymous: 'Ekstern og anonym. Alle med en lenke kan svare.',
        External_survey: 'Ekstern – alle med lenken kan svare',
        Frequency: 'Frekvens',
        Frequency_Always: 'Alltid',
        Frequency_Never: 'Aldri',
        Frequency_Often: 'Ofte',
        Frequency_Rarely: 'Sjelden',
        Frequency_Sometimes: 'Noen ganger',
        Friday: 'Fredag',
        Generate_survey: 'Generer undersøkelse',
        Grid_no_questions_heading: 'Ingen spørsmål',
        Grid_no_questions_text: 'Du har ikke opprettet noen spørsmål ennå',
        Homework_habits: 'leksevaner',
        How_does_this_work: 'Hvordan fungerer dette?',
        How_does_this_work_info_part1: 'Dine inndata brukes som en del av meldingen vi sender til behandling. Basert på svaret genererer vi en undersøkelse med en introduksjon og flervalgsoppgaver med 5 svaralternativer (fra «helt enig» til «helt uenig»). Du vil kunne redigere og justere alt innhold før du distribuerer undersøkelsen.',
        How_does_this_work_info_part2: 'itslearning er ikke ansvarlig for innholdet i den genererte undersøkelsen. Vi modererer ikke responsen fra KI-tjenesten, som kan gi unøyaktig informasjon om mennesker, steder eller fakta. Tjenesten vi kobler til leveres av OpenAI, via GPT-3.5-turbo chat-modellen.',
        Importance: 'Betydning',
        Importance_Extremely_Important: 'Ekstremt viktig',
        Importance_Moderately_Important: 'Middels viktig',
        Importance_Not_At_All_Important: 'Slett ikke viktig',
        Importance_Slightly_Important: 'Litt viktig',
        Importance_Very_Important: 'Veldig viktig',
        Imported_rich_text_edit_warning: 'Denne teksten ble importert fra det gamle undersøkelsesverktøyet. Når du lagrer, fjernes all formatering og rikt tekstinnhold (for eksempel bilder).',
        Introduction: 'Introduksjon',
        Link_copied_to_clipboard: 'Lenke kopiert til utklippstavle',
        Link_to_survey: 'Lenke til undersøkelse',
        Matrix_question: 'Matrisespørsmål',
        Monday: 'Mandag',
        Move_element_instructions: 'For å flytte dette elementet, trykk mellomrom og bruk pil opp eller pil ned. Trykk på mellomrom igjen for å fullføre.',
        Moving_element_to_position_x_of_y: 'Flytter element til posisjon {0} av {1}',
        Multiple_choice_question: 'Flervalgsspørsmål',
        Next: 'Neste',
        No: 'Nei',
        No_respondents: 'Ingen respondenter',
        Not_anonymous: 'Ikke anonym',
        Not_possible_to_edit_questions_message: 'Du kan ikke lenger legge til, redigere eller slette spørsmål, fordi noen har begynt å ta denne undersøkelsen.',
        Note: 'Notat',
        Number_of_questions: 'Antall spørsmål',
        Number_of_respondents_x: 'Antall respondenter: {0}',
        Number_responded_x: 'Antall svar: {0}',
        Numbers: 'Tall',
        Ok: 'OK',
        Open_answer_heading: 'Svar',
        Open_question: 'Åpent spørsmål',
        Personal_data_warning: 'Ikke oppgi personlig eller opphavsrettsbeskyttet informasjon. Dine innspill sendes fra itslearning utenfor EU for behandling. Om du trenger mer informasjon, kan du lese «Hvordan fungerer dette».',
        Preview_survey: 'Forhåndsvis undersøkelse',
        Previous: 'Forrige',
        Print: 'Skriv ut',
        QR_code: 'QR-kode',
        QR_code_copied_to_clipboard: 'QR-kodebilde kopiert til utklippstavlen',
        Quality: 'Kvalitet',
        Quality_Excellent: 'Utmerket',
        Quality_Fair: 'Nokså bra',
        Quality_Good: 'Bra',
        Quality_Poor: 'Dårlig',
        Quality_Very_Poor: 'Svært dårlig',
        Question: 'Spørsmål',
        Question_has_been_saved: 'Spørsmålet er lagret.',
        Question_number_header: 'Spørsmålsnummer',
        Question_type: 'Spørsmålstype',
        Question_type_short: 'Type',
        Question_x: 'Spørsmål {0}',
        Question_x_of_y: 'Spørsmål {0} av {1}',
        Questions: 'Spørsmål',
        QuestionType_MultipleChoice_short: 'Flervalg',
        QuestionType_YesNo_short: 'Ja/nei',
        Remember_visible: 'Husk at undersøkelsen må være synlig for respondentene.',
        Remember_visible_and_deadline: 'Husk at undersøkelsen må være synlig for respondentene, og at fristen må være i fremtiden.',
        Remove_alternative_x: 'Fjern alternativ {0}',
        Remove_statement_x: 'Fjern utsagn {0}',
        Respondent: 'Svarperson',
        Responses: 'Svar',
        Responses_summary: 'Sammendrag',
        Responses_x: 'Svar: {0}',
        Satisfaction: 'Tilfredshet',
        Satisfaction_Completely_Satisfied: 'Helt fornøyd',
        Satisfaction_Moderately_Satisfied: 'Middels fornøyd',
        Satisfaction_Not_At_All_Satisfied: 'Slett ikke fornøyd',
        Satisfaction_Slightly_Satisfied: 'Litt fornøyd',
        Satisfaction_Very_Satisfied: 'Veldig fornøyd',
        Saturday: 'Lørdag',
        Save: 'Lagre',
        Save_and_new: 'Lagre og ny',
        Search: 'Søk',
        Search_for_respondents: 'Søk etter respondenter',
        Select_a_response_to_delete: 'Velg et svar du vil slette',
        Select_all_questions: 'Velg alle spørsmål',
        Select_at_least_one_question_to_delete: 'Velg minst ett spørsmål som skal slettes',
        Select_question_x: 'Velg spørsmål {0}',
        Share: 'Del',
        Share_survey: 'Del undersøkelse',
        Show_more: 'Vis mer',
        Show_response: 'Vis svaret ditt',
        Showing_x_responses_of_total_y_responses: 'Viser {0} svar av totalt {1} svar',
        Start_moving_element_x: 'Begynn å flytte element: {0}',
        Started: 'Startet',
        Statement_x: 'Utsagn {0}',
        Statements_rows: 'Utsagn (rader)',
        Student_satisfaction_cafeteria: 'studenttilfredshet med menyalternativene i kantina',
        Submit_answer: 'Lever besvarelse',
        Submitted: 'Levert',
        Submitted_after_deadline: 'Levert etter tidsfrist',
        Sunday: 'Søndag',
        Survey: 'Undersøkelse',
        Survey_inactive_message: 'Denne undersøkelsen er ikke lenger tilgjengelig. Du kan fortsette senere hvis den blir tilgjengelig igjen.',
        Survey_start_page: 'Startsiden for undersøkelsen',
        Survey_title: 'Undersøkelse',
        Survey_type: 'Type undersøkelse',
        Take_survey: 'Ta undersøkelse',
        Thanks_for_taking_the_survey: 'Takk for at du tok undersøkelsen!',
        The_survey_is_about: 'Undersøkelsen handler om',
        Thursday: 'Torsdag',
        Tips_and_examples: 'Tips og eksempler',
        Tips_and_examples_info: 'Bruk korte og konsise inndata for få nyttige utdata fra KI-tjenesten. Ikke skriv «Dette er en undersøkelse om ...», da denne informasjonen allerede ligger i teksten vi sender. Eksempler på inndata kan være:',
        Tuesday: 'Tirsdag',
        Unknown_error: 'Noe gikk galt. Mulige årsaker kan være problemer med tjenesten vår, at noen redigerer undersøkelsen eller at nettverket ditt er ustabilt. Hvis tilkoblingen er OK og du fortsatt ser denne meldingen, må du kontakte administrator.',
        View_question_x_of_y: 'Vis spørsmål {0} av {1}',
        Wednesday: 'Onsdag',
        Yes: 'Ja',
        Yes_no_question: 'Ja/nei-spørsmål',
        Your_response_will_not_be_saved: 'Svaret ditt blir ikke lagret.',
    },
    'nl-NL': {
        Add_alternative: 'Alternatief toevoegen',
        Add_question: 'Vraag toevoegen',
        Add_question_x: 'Vraag {0} toevoegen',
        Add_statement: 'Verklaring toevoegen',
        Agreement: 'Overeenkomst',
        Agreement_Agree: 'Eens',
        Agreement_Disagree: 'Oneens',
        Agreement_Neither_Agree_Nor_Disagree: 'Niet eens en niet oneens',
        Agreement_Strongly_Agree: 'Helemaal eens',
        Agreement_Strongly_Disagree: 'Helemaal oneens',
        Allow_respondents_to_select_more_than_one_alternative: 'Respondenten toestaan meer dan één alternatief te selecteren',
        Alternative_x: 'Alternatief {0}',
        Alternatives: 'Alternatieven',
        Alternatives_columns: 'Alternatieven (kolommen)',
        Anonymous: 'Anoniem',
        Anonymous_responses: 'Anoniem',
        Answer_type: 'Type antwoord',
        Answer_was_cleared: 'Antwoord is gewist',
        Ask_our_AI_info_message: 'Vraag onze kunstmatige intelligentie (AI)-robot om de enquête voor u te genereren. Standaard krijgt u een introductie en meerkeuzevragen. U kunt de enquête bekijken en bewerken zodra deze is gegenereerd. Zie onderstaande tips voor meer informatie.',
        Autoloading: 'Automatisch laden',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Terug naar de lijst met vragen',
        Back_to_responses: 'Terug naar reacties',
        Back_to_survey_details: 'Terug naar enquêtegegevens',
        Cancel: 'Annuleren',
        Clear_answer: 'Antwoord wissen',
        Close: 'Sluiten',
        Continue_survey: 'Doorgaan met enquête',
        Copy_public_link: 'Openbare koppeling kopiëren',
        Copy_QR_code: 'QR-code kopiëren',
        Create_survey: 'Enquête maken',
        Create_survey_with_AI: 'Enquête maken met AI',
        Custom: 'Aangepast',
        DateFormat_just_now: 'Zojuist',
        DateFormat_one_hour_ago: '1 uur geleden',
        DateFormat_one_minute_ago: '1 minuut geleden',
        DateFormat_weekday_x_at_y: '{0} om {1}',
        DateFormat_x_days_ago: '{0} dagen geleden',
        DateFormat_x_hours_ago: '{0} uur geleden',
        DateFormat_x_minutes_ago: '{0} minuten geleden',
        DateFormat_yesterday_at_x: 'Gisteren om {0}',
        Deadline_has_passed_message: 'De deadline is verstreken en u mag geen antwoord meer inleveren. U kunt later doorgaan als de deadline wordt verlengd.',
        Delete: 'Verwijderen',
        Delete_questions_modal_title: 'Geselecteerde vragen verwijderen?',
        Delete_responses: 'Antwoorden verwijderen?',
        Download_responses: 'Antwoorden downloaden (Excel)',
        Edit_question: 'Vraag bewerken',
        Edit_question_x_of_y: 'Vraag {0} van {1} bewerken',
        Edit_settings_info: 'Het is niet mogelijk om de anonieme instellingen te bewerken nadat iemand de enquête heeft gestart.',
        Edit_survey: 'Enquête bewerken',
        Element_has_been_moved_to_position_x_of_y: 'Element is verplaatst naar positie {0} van {1}',
        Emojis: 'Emoji\'s',
        Empty_state_no_responses_heading: 'Nog geen antwoorden',
        Empty_state_no_responses_text: 'Antwoorden worden hier weergegeven zodra iemand begint met het invullen van de enquête.',
        Empty_survey_input_message: 'U moet schrijven waar de enquête over gaat.',
        Evaluation_of_the_teaching: 'evaluatie van de lesmethoden in de wetenschapsles',
        Exit_preview: 'Voorbeeld afsluiten',
        Exit_survey: 'Enquête afsluiten?',
        Exit_survey_button: 'Enquête afsluiten',
        External_and_anonymous: 'Extern en anoniem. Iedereen met een koppeling kan reageren.',
        External_survey: 'Extern - iedereen met de koppeling kan reageren',
        Frequency: 'Frequentie',
        Frequency_Always: 'Altijd',
        Frequency_Never: 'Nooit',
        Frequency_Often: 'Vaak',
        Frequency_Rarely: 'Zelden',
        Frequency_Sometimes: 'Soms',
        Friday: 'Vrijdag',
        Generate_survey: 'Enquête genereren',
        Grid_no_questions_heading: 'Geen vragen',
        Grid_no_questions_text: 'U hebt nog geen vragen gemaakt.',
        Homework_habits: 'huiswerkgewoontes',
        How_does_this_work: 'Hoe werkt dit?',
        How_does_this_work_info_part1: 'Uw invoer wordt gebruikt als onderdeel van de prompt die we verzenden voor verwerking. Op basis van de respons genereren we een enquête met een inleiding en meerkeuzevragen met 5 antwoordalternatieven (van \'sterk mee eens\' tot \'sterk mee oneens\'). U kunt alle inhoud bewerken en aanpassen voordat u de enquête distribueert.',
        How_does_this_work_info_part2: 'itslearning is niet verantwoordelijk voor de inhoud van de gegenereerde enquête. We modereren de reactie van de AI-service niet, die onnauwkeurige informatie over mensen, plaatsen of feiten kan opleveren. De service waarmee we verbinding maken, wordt geleverd door OpenAI, met behulp van het GPT-3.5-turbo-chatmodel.',
        Importance: 'Belang',
        Importance_Extremely_Important: 'Uiterst belangrijk',
        Importance_Moderately_Important: 'Matig belangrijk',
        Importance_Not_At_All_Important: 'Helemaal niet belangrijk',
        Importance_Slightly_Important: 'Enigszins belangrijk',
        Importance_Very_Important: 'Heel belangrijk',
        Imported_rich_text_edit_warning: 'Deze tekst is geïmporteerd uit de oude enquêtetool. Wanneer u opslaat, worden alle opmaak en RTF-inhoud (bijvoorbeeld afbeeldingen) verwijderd.',
        Introduction: 'Introductie',
        Link_copied_to_clipboard: 'Koppeling naar klembord gekopieerd',
        Link_to_survey: 'Koppeling naar enquête',
        Matrix_question: 'Matrixvraag',
        Monday: 'Maandag',
        Move_element_instructions: 'Als u dit element wilt verplaatsen, drukt u op de spatiebalk en gebruikt u pijl-omhoog of pijl-omlaag. Druk nogmaals op de spatiebalk om te voltooien.',
        Moving_element_to_position_x_of_y: 'Element wordt verplaatst naar positie {0} van {1}',
        Multiple_choice_question: 'Meerkeuzevraag',
        Next: 'Volgende',
        No: 'Nee',
        No_respondents: 'Geen respondenten',
        Not_anonymous: 'Niet anoniem',
        Not_possible_to_edit_questions_message: 'U kunt geen vragen meer toevoegen, bewerken of verwijderen omdat iemand is begonnen met het invullen van deze enquête.',
        Note: 'Notitie',
        Number_of_questions: 'Aantal vragen',
        Number_of_respondents_x: 'Aantal respondenten: {0}',
        Number_responded_x: 'Aantal beantwoord: {0}',
        Numbers: 'Getallen',
        Ok: 'OK',
        Open_answer_heading: 'Antwoord',
        Open_question: 'Open vraag',
        Personal_data_warning: 'Voer geen persoonlijke of auteursrechtelijk beschermde informatie in. Uw invoer wordt vanuit itslearning buiten de EU verzonden voor verwerking. Zie "Hoe werkt dit" voor meer informatie.',
        Preview_survey: 'Voorbeeld van enquête',
        Previous: 'Vorige',
        Print: 'Afdrukken',
        QR_code: 'QR-code',
        QR_code_copied_to_clipboard: 'QR-codeafbeelding gekopieerd naar klembord',
        Quality: 'Kwaliteit',
        Quality_Excellent: 'Uitstekend',
        Quality_Fair: 'Voldoende',
        Quality_Good: 'Goed',
        Quality_Poor: 'Slecht',
        Quality_Very_Poor: 'Zeer slecht',
        Question: 'Vraag',
        Question_has_been_saved: 'Vraag is opgeslagen',
        Question_number_header: 'Vraagnummer',
        Question_type: 'Type vraag',
        Question_type_short: 'Type',
        Question_x: 'Vraag {0}',
        Question_x_of_y: 'Vraag {0} van {1}',
        Questions: 'Vragen',
        QuestionType_MultipleChoice_short: 'Meerkeuze',
        QuestionType_YesNo_short: 'Ja/Nee',
        Remember_visible: 'Vergeet niet dat de enquête zichtbaar moet zijn voor respondenten.',
        Remember_visible_and_deadline: 'Vergeet niet dat de enquête zichtbaar moet zijn voor respondenten en dat de deadline in de toekomst moet liggen.',
        Remove_alternative_x: 'Alternatief {0} verwijderen',
        Remove_statement_x: 'Verklaring {0} verwijderen',
        Respondent: 'Geantwoord',
        Responses: 'Antwoorden',
        Responses_summary: 'Samenvatting',
        Responses_x: 'Antwoorden: {0}',
        Satisfaction: 'Tevredenheid',
        Satisfaction_Completely_Satisfied: 'Helemaal tevreden',
        Satisfaction_Moderately_Satisfied: 'Matig tevreden',
        Satisfaction_Not_At_All_Satisfied: 'Helemaal niet tevreden',
        Satisfaction_Slightly_Satisfied: 'Enigszins tevreden',
        Satisfaction_Very_Satisfied: 'Zeer tevreden',
        Saturday: 'Zaterdag',
        Save: 'Opslaan',
        Save_and_new: 'Opslaan en nieuwe',
        Search: 'Zoeken',
        Search_for_respondents: 'Zoeken naar respondenten',
        Select_a_response_to_delete: 'Selecteer een antwoord dat u wilt verwijderen',
        Select_all_questions: 'Alle vragen selecteren',
        Select_at_least_one_question_to_delete: 'Selecteer ten minste één vraag om te verwijderen',
        Select_question_x: 'Vraag {0} selecteren',
        Share: 'Delen',
        Share_survey: 'Enquête delen',
        Show_more: 'Meer weergeven',
        Show_response: 'Uw antwoord weergeven',
        Showing_x_responses_of_total_y_responses: 'Er worden {0} antwoorden van in totaal {1} antwoorden weergegeven',
        Start_moving_element_x: 'Begin met het verplaatsen van element: {0}',
        Started: 'Gestart',
        Statement_x: 'Verklaring {0}',
        Statements_rows: 'Verklaringen (rijen)',
        Student_satisfaction_cafeteria: 'tevredenheid van leerlingen over de menu-opties in de kantine',
        Submit_answer: 'Antwoord inleveren',
        Submitted: 'Ingeleverd',
        Submitted_after_deadline: 'Ingeleverd na de deadline',
        Sunday: 'Zondag',
        Survey: 'Enquête',
        Survey_inactive_message: 'Deze enquête is niet meer beschikbaar. U kunt later doorgaan als hij weer beschikbaar komt.',
        Survey_start_page: 'Startpagina enquête',
        Survey_title: 'Enquête',
        Survey_type: 'Type enquête',
        Take_survey: 'Enquête invullen',
        Thanks_for_taking_the_survey: 'Bedankt voor het invullen van de enquête!',
        The_survey_is_about: 'De enquête gaat over',
        Thursday: 'Donderdag',
        Tips_and_examples: 'Tips en voorbeelden',
        Tips_and_examples_info: 'Om nuttige output van de AI-service te krijgen, houdt u de invoer kort en bondig. Schrijf niet "Dit is een enquête over..." want dat staat al in de tekst die we toesturen. Voorbeelden van input kunnen zijn:',
        Tuesday: 'Dinsdag',
        Unknown_error: 'Er is iets fout gegaan. Mogelijke redenen kunnen problemen met onze service zijn, dat iemand de enquête bewerkt of dat uw netwerk onstabiel is. Als uw verbinding in orde is en u dit bericht blijft zien, neemt u contact op met uw beheerder.',
        View_question_x_of_y: 'Vraag {0} van {1} weergeven',
        Wednesday: 'Woensdag',
        Yes: 'Ja',
        Yes_no_question: 'Ja/nee-vraag',
        Your_response_will_not_be_saved: 'Uw antwoord wordt niet opgeslagen.',
    },
    'nn-NO': {
        Add_alternative: 'Legg til alternativ',
        Add_question: 'Legg til spørsmål',
        Add_question_x: 'Legg til pørsmål {0}',
        Add_statement: 'Legg til utsegn',
        Agreement: 'Semje',
        Agreement_Agree: 'Samd',
        Agreement_Disagree: 'Usamd',
        Agreement_Neither_Agree_Nor_Disagree: 'Verken samd eller usamd',
        Agreement_Strongly_Agree: 'Sterkt samd',
        Agreement_Strongly_Disagree: 'Sterkt usamd',
        Allow_respondents_to_select_more_than_one_alternative: 'Tillat at respondentane kan velje fleire enn eitt alternativ',
        Alternative_x: 'Alternativ {0}',
        Alternatives: 'Alternativ',
        Alternatives_columns: 'Alternativer (kolonnar)',
        Anonymous: 'Anonym',
        Anonymous_responses: 'Anonym',
        Answer_type: 'Svartype',
        Answer_was_cleared: 'Svaret blei fjerna',
        Ask_our_AI_info_message: 'Her kan du bruke kunstig intelligens (KI) til å lage undersøkinga for deg. Som standard vil du få ein introduksjon og fleirvalsoppgåver. Du kan sjå gjennom og redigere undersøkinga når ho er oppretta. Sjå tipsa nedanfor om du treng meir informasjon.',
        Autoloading: 'Autolasting',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Tilbake til spørsmålslista',
        Back_to_responses: 'Tilbake til svara',
        Back_to_survey_details: 'Tilbake til detaljar om undersøkinga',
        Cancel: 'Avbryt',
        Clear_answer: 'Fjern svar',
        Close: 'Lukk',
        Continue_survey: 'Fortsett undersøkinga',
        Copy_public_link: 'Kopier offentleg lenke',
        Copy_QR_code: 'Kopier QR-kode',
        Create_survey: 'Opprett undersøking',
        Create_survey_with_AI: 'Opprett undersøking med KI',
        Custom: 'Eigendefinert',
        DateFormat_just_now: 'Akkurat no',
        DateFormat_one_hour_ago: '1 time sidan',
        DateFormat_one_minute_ago: '1 minutt sidan',
        DateFormat_weekday_x_at_y: '{0} kl. {1}',
        DateFormat_x_days_ago: 'For {0} dagar sidan',
        DateFormat_x_hours_ago: '{0} timar sidan',
        DateFormat_x_minutes_ago: '{0} minutt sidan',
        DateFormat_yesterday_at_x: 'I går kl. {0}',
        Deadline_has_passed_message: 'Fristen er utgått, og du har ikkje lenger lov til å sende inn svar. Du kan fortsette seinare viss fristen blir forlenga.',
        Delete: 'Slett',
        Delete_questions_modal_title: 'Slett valde spørsmål',
        Delete_responses: 'Slette svar?',
        Download_responses: 'Last ned svar (Excel)',
        Edit_question: 'Rediger spørsmål',
        Edit_question_x_of_y: 'Rediger spørsmål {0} av {1}',
        Edit_settings_info: 'Det er ikkje mogleg å endre type undersøking etter at nokon har starta undersøkinga.',
        Edit_survey: 'Rediger undersøking',
        Element_has_been_moved_to_position_x_of_y: 'Elementet er flytta til posisjon {0} av {1}',
        Emojis: 'Emojiar',
        Empty_state_no_responses_heading: 'Ingen svar enno',
        Empty_state_no_responses_text: 'Svara blir viste her når nokon startar undersøkinga.',
        Empty_survey_input_message: 'Du må skrive kva undersøkinga handlar om.',
        Evaluation_of_the_teaching: 'evaluering av undervisingsmetodar i naturfagklassa',
        Exit_preview: 'Avslutt førehandsvising',
        Exit_survey: 'Avslutte undersøkinga?',
        Exit_survey_button: 'Avslutt undersøkinga',
        External_and_anonymous: 'Ekstern og anonym. Alle med ei lenke kan svare.',
        External_survey: 'Ekstern – alle som har lenka kan svare.',
        Frequency: 'Frekvens',
        Frequency_Always: 'Alltid',
        Frequency_Never: 'Aldri',
        Frequency_Often: 'Ofte',
        Frequency_Rarely: 'Sjeldan',
        Frequency_Sometimes: 'Nokre gonger',
        Friday: 'Fredag',
        Generate_survey: 'Generer undersøking',
        Grid_no_questions_heading: 'Ingen spørsmål',
        Grid_no_questions_text: 'Du har ikkje oppretta spørsmål enno.',
        Homework_habits: 'leksevanar',
        How_does_this_work: 'Korleis fungerer dette?',
        How_does_this_work_info_part1: 'Dine inndata blir brukte som ein del av meldinga vi sender til behandling. Basert på svaret genererer vi ei undersøking med ein introduksjon og fleirvalsoppgåver med 5 svaralternativ (frå «heilt samd» til «heilt usamd»). Du vil kunne redigere og justere alt innhaldet før du distribuerer undersøkinga.',
        How_does_this_work_info_part2: 'itslearning er ikkje ansvarleg for innhaldet i den genererte undersøkinga. Vi modererer ikkje responsen frå KI-tenesta, som kan gi unøyaktig informasjon om menneske, stader eller fakta. Tenesta vi koplar til er levert av OpenAI, via GPT-3.5-turbo chat-modellen.',
        Importance: 'Betyding',
        Importance_Extremely_Important: 'Ekstremt viktig',
        Importance_Moderately_Important: 'Middels viktig',
        Importance_Not_At_All_Important: 'Slett ikkje viktig',
        Importance_Slightly_Important: 'Litt viktig',
        Importance_Very_Important: 'Svært viktig',
        Imported_rich_text_edit_warning: 'Denne teksten blei importert frå det gamle undersøkingsverktøyet. Når du lagrar, blir all formatering og rikt tekstinnhald fjerna (for eksempel bilete).',
        Introduction: 'Introduksjon',
        Link_copied_to_clipboard: 'Lenke kopiert til utklippstavla',
        Link_to_survey: 'Lenke til undersøking',
        Matrix_question: 'Matrisespørsmål',
        Monday: 'Måndag',
        Move_element_instructions: 'For å flytte dette elementet, trykk mellomrom og bruk pil opp eller pil ned. Trykk mellomrom på nytt for å fullføre.',
        Moving_element_to_position_x_of_y: 'Flyttar elementet til posisjon {0} av {1}',
        Multiple_choice_question: 'Fleirvalsspørsmål',
        Next: 'Neste',
        No: 'Nei',
        No_respondents: 'Ingen respondentar',
        Not_anonymous: 'Ikkje anonym',
        Not_possible_to_edit_questions_message: 'Du kan ikkje lenger legge til, redigere eller slette spørsmål, fordi nokon har byrja å ta denne undersøkinga.',
        Note: 'Notat',
        Number_of_questions: 'Antal spørsmål',
        Number_of_respondents_x: 'Antal respondentar: {0}',
        Number_responded_x: 'Antal svar: {0}',
        Numbers: 'Tal',
        Ok: 'OK',
        Open_answer_heading: 'Svar',
        Open_question: 'Ope spørsmål',
        Personal_data_warning: 'Ikkje oppgi personleg eller opphavsrettsbeskytta informasjon. Dine inndata blir sende frå itslearning utanfor EU til behandling. Om du treng meir informasjon, kan du lese «Korleis fungerer dette».',
        Preview_survey: 'Førehandsvis undersøking',
        Previous: 'Førre',
        Print: 'Skriv ut',
        QR_code: 'QR-kode',
        QR_code_copied_to_clipboard: 'QR-kodebilete kopiert til utklippstavla',
        Quality: 'Kvalitet',
        Quality_Excellent: 'Framifrå',
        Quality_Fair: 'Nokså bra',
        Quality_Good: 'Bra',
        Quality_Poor: 'Dårleg',
        Quality_Very_Poor: 'Svært dårleg',
        Question: 'Spørsmål',
        Question_has_been_saved: 'Spørsmålet er lagra.',
        Question_number_header: 'Spørsmålsnummer',
        Question_type: 'Spørsmålstype',
        Question_type_short: 'Type',
        Question_x: 'Spørsmål {0}',
        Question_x_of_y: 'Spørsmål {0} av {1}',
        Questions: 'Spørsmål',
        QuestionType_MultipleChoice_short: 'Fleirval',
        QuestionType_YesNo_short: 'Ja/nei',
        Remember_visible: 'Hugs at undersøkinga må vere synleg for respondentane.',
        Remember_visible_and_deadline: 'Hugs at undersøkinga må vere synleg for respondentane, og at fristen må vere i framtida.',
        Remove_alternative_x: 'Fjern alternativ {0}',
        Remove_statement_x: 'Fjern utsegn {0}',
        Respondent: 'Svarperson',
        Responses: 'Svar',
        Responses_summary: 'Samandrag',
        Responses_x: 'Svar: {0}',
        Satisfaction: 'Tilfredsheit',
        Satisfaction_Completely_Satisfied: 'Heilt nøgd',
        Satisfaction_Moderately_Satisfied: 'Middels nøgd',
        Satisfaction_Not_At_All_Satisfied: 'Slett ikkje nøgd',
        Satisfaction_Slightly_Satisfied: 'Litt nøgd',
        Satisfaction_Very_Satisfied: 'Svært nøgd',
        Saturday: 'Laurdag',
        Save: 'Lagre',
        Save_and_new: 'Lagre og ny',
        Search: 'Søk',
        Search_for_respondents: 'Søk etter respondentar',
        Select_a_response_to_delete: 'Vel eit svar du vil slette',
        Select_all_questions: 'Vel alle spørsmåla',
        Select_at_least_one_question_to_delete: 'Vel minst eit spørsmål å slette.',
        Select_question_x: 'Vel spørsmål {0}',
        Share: 'Del',
        Share_survey: 'Del undersøking',
        Show_more: 'Vis meir',
        Show_response: 'Vis svaret ditt',
        Showing_x_responses_of_total_y_responses: 'Viser {0} svar av total {1} svar',
        Start_moving_element_x: 'Begynn å flytte element: {0}',
        Started: 'Starta',
        Statement_x: 'Utsegn {0}',
        Statements_rows: 'Utsegner (rader)',
        Student_satisfaction_cafeteria: 'studenttilfredsheit med menyalternativa i kantina',
        Submit_answer: 'Lever svar',
        Submitted: 'Levert',
        Submitted_after_deadline: 'Levert etter tidsfristen',
        Sunday: 'Søndag',
        Survey: 'Undersøking',
        Survey_inactive_message: 'Denne undersøkinga er ikkje lenger tilgjengeleg. Du kan fortsette seinare viss ho blir tilgjengeleg igjen.',
        Survey_start_page: 'Startsida for undersøkinga',
        Survey_title: 'Undersøking',
        Survey_type: 'Type undersøking',
        Take_survey: 'Ta undersøkinga',
        Thanks_for_taking_the_survey: 'Takk for at du tok undersøkinga!',
        The_survey_is_about: 'Undersøkinga handlar om',
        Thursday: 'Torsdag',
        Tips_and_examples: 'Tips og døme',
        Tips_and_examples_info: 'Bruk korte og konsise inndata for å få nyttige utdata frå KI-tenesta. Ikkje skriv «Dette er ei undersøking om ...», då denne informasjonen allereie ligg i teksten vi sender. Døme på inndata kan vere:',
        Tuesday: 'Tysdag',
        Unknown_error: 'Noko gjekk gale. Moglege grunnar kan vere problem med tenesta vår, at nokon redigerer undersøkinga eller at nettverket du brukar er ustabilt. Viss tilkoplinga di er OK og du framleis får denne meldinga, ta kontakt med administratoren din.',
        View_question_x_of_y: 'Vis spørsmål {0} av {1}',
        Wednesday: 'Onsdag',
        Yes: 'Ja',
        Yes_no_question: 'Ja/nei-spørsmål',
        Your_response_will_not_be_saved: 'Svaret ditt blir ikkje lagra.',
    },
    'pl-PL': {
        Add_alternative: 'Dodaj opcję do wyboru',
        Add_question: 'Dodaj pytanie',
        Add_question_x: 'Dodaj pytanie {0}',
        Add_statement: 'Dodaj wypowiedź',
        Agreement: 'Zgoda',
        Agreement_Agree: 'Zgadzam się',
        Agreement_Disagree: 'Nie zgadzam się',
        Agreement_Neither_Agree_Nor_Disagree: 'Nie mam zdania',
        Agreement_Strongly_Agree: 'Zdecydowanie się zgadzam',
        Agreement_Strongly_Disagree: 'Zdecydowanie się nie zgadzam',
        Allow_respondents_to_select_more_than_one_alternative: 'Zezwalaj respondentom na wybór więcej niż jednej opcji',
        Alternative_x: 'Alternatywa {0}',
        Alternatives: 'Opcje do wyboru',
        Alternatives_columns: 'Alternatywy (kolumny)',
        Anonymous: 'Anonimowy',
        Anonymous_responses: 'Anonimowa',
        Answer_type: 'Typ odpowiedzi',
        Answer_was_cleared: 'Odpowiedź została usunięta',
        Ask_our_AI_info_message: 'Poproś naszego robota sztucznej inteligencji (AI) o wygenerowanie ankiety dla Ciebie. Domyślnie otrzymasz wprowadzenie i pytania wielokrotnego wyboru. Możesz przeglądać i edytować ankietę po jej wygenerowaniu. Zobacz wskazówki poniżej, aby uzyskać więcej informacji.',
        Autoloading: 'Automatyczne ładowanie',
        Avatar: 'Awatar',
        Back_to_list_of_questions: 'Powrót do listy pytań',
        Back_to_responses: 'Powrót do odpowiedzi',
        Back_to_survey_details: 'Powrót do szczegółów ankiety',
        Cancel: 'Anuluj',
        Clear_answer: 'Wyczyść odpowiedź',
        Close: 'Zamknij',
        Continue_survey: 'Kontynuuj ankietę',
        Copy_public_link: 'Kopiuj link publiczny',
        Copy_QR_code: 'Skopiuj kod QR',
        Create_survey: 'Stwórz ankietę',
        Create_survey_with_AI: 'Stwórz ankietę za pomocą sztucznej inteligencji',
        Custom: 'Niestandardowe',
        DateFormat_just_now: 'Teraz',
        DateFormat_one_hour_ago: '1 godzinę temu',
        DateFormat_one_minute_ago: '1 minutę temu',
        DateFormat_weekday_x_at_y: '{0} o {1}',
        DateFormat_x_days_ago: 'Przed {0} dniami',
        DateFormat_x_hours_ago: '{0} godz. temu',
        DateFormat_x_minutes_ago: '{0} min temu',
        DateFormat_yesterday_at_x: 'Wczoraj o {0}',
        Deadline_has_passed_message: 'Termin minął i nie możesz już przesyłać odpowiedzi. Możesz kontynuować później, jeśli termin zostanie przedłużony.',
        Delete: 'Usuń',
        Delete_questions_modal_title: 'Usunąć zaznaczone pytania?',
        Delete_responses: 'Usunąć odpowiedzi?',
        Download_responses: 'Pobierz odpowiedzi (Excel)',
        Edit_question: 'Edytuj pytanie',
        Edit_question_x_of_y: 'Edytuj pytanie {0} z {1}',
        Edit_settings_info: 'Nie można edytować ustawień anonimowości po rozpoczęciu ankiety.',
        Edit_survey: 'Edytuj ankietę',
        Element_has_been_moved_to_position_x_of_y: 'Element został przesunięty na pozycję {0} z {1}',
        Emojis: 'Emotikony',
        Empty_state_no_responses_heading: 'Nie ma jeszcze odpowiedzi',
        Empty_state_no_responses_text: 'Odpowiedzi pojawią się tutaj, gdy ktoś zacznie wypełniać ankietę.',
        Empty_survey_input_message: 'Musisz napisać, czego dotyczy ankieta.',
        Evaluation_of_the_teaching: 'ocena metod nauczania w klasie przedmiotów ścisłych',
        Exit_preview: 'Opuść pogląd',
        Exit_survey: 'Wyjść z ankiety?',
        Exit_survey_button: 'Wyjdź z ankiety',
        External_and_anonymous: 'Zewnętrzny i anonimowy. Każdy, kto ma link, może odpowiedzieć.',
        External_survey: 'Zewnętrzna – każda osoba z linkiem może w niej odpowiadać',
        Frequency: 'Częstotliwość',
        Frequency_Always: 'Zawsze',
        Frequency_Never: 'Nigdy',
        Frequency_Often: 'Często',
        Frequency_Rarely: 'Rzadko',
        Frequency_Sometimes: 'Niekiedy',
        Friday: 'Piątek',
        Generate_survey: 'Wygeneruj ankietę',
        Grid_no_questions_heading: 'Brak pytań',
        Grid_no_questions_text: 'Nie utworzono jeszcze żadnych pytań.',
        Homework_habits: 'nawyki odrabiania lekcji',
        How_does_this_work: 'Jak to działa?',
        How_does_this_work_info_part1: 'Twoje dane wejściowe są wykorzystywane jako część prompta, który wysyłamy do przetworzenia. Na podstawie odpowiedzi generujemy ankietę z wprowadzeniem i pytaniami wielokrotnego wyboru z 5 wariantami odpowiedzi (od „zdecydowanie się zgadzam” do „zdecydowanie się nie zgadzam”). Będziesz w stanie edytować i dostosowywać całą zawartość przed dystrybucją ankiety.',
        How_does_this_work_info_part2: 'itslearning nie ponosi odpowiedzialności za treść wygenerowanej ankiety. Nie moderujemy odpowiedzi z usługi AI, która może generować niedokładne informacje o ludziach, miejscach lub faktach. Usługa, z którą się łączymy, jest dostarczana przez OpenAI, przy użyciu modelu czatu GPT-3.5-turbo.',
        Importance: 'Znaczenie',
        Importance_Extremely_Important: 'Niezwykle ważne',
        Importance_Moderately_Important: 'Umiarkowanie ważne',
        Importance_Not_At_All_Important: 'Wcale nie ważne',
        Importance_Slightly_Important: 'Trochę ważne',
        Importance_Very_Important: 'Bardzo ważne',
        Imported_rich_text_edit_warning: 'Ten tekst został zaimportowany ze starego narzędzia ankiety. Podczas zapisywania całe formatowanie i zawartość tekstu sformatowanego (na przykład obrazy) zostaną usunięte.',
        Introduction: 'Wprowadzenie',
        Link_copied_to_clipboard: 'Skopiowano link do schowka',
        Link_to_survey: 'Link do ankiety',
        Matrix_question: 'Pytanie macierzowe',
        Monday: 'Poniedziałek',
        Move_element_instructions: 'Aby przesunąć ten element, naciśnij spację i użyj strzałki w górę lub w dół. Naciśnij spację ponownie, aby zakończyć.',
        Moving_element_to_position_x_of_y: 'Przesuwanie elementu na pozycję {0} z {1}',
        Multiple_choice_question: 'Pytanie typu Wielokrotny wybór',
        Next: 'Dalej',
        No: 'Nie',
        No_respondents: 'Brak respondentów',
        Not_anonymous: 'Nieanonimowy',
        Not_possible_to_edit_questions_message: 'Nie można już dodawać, edytować ani usuwać pytań, ponieważ ktoś zaczął ją wypełniać.',
        Note: 'Adnotacja',
        Number_of_questions: 'Liczba pytań',
        Number_of_respondents_x: 'Liczba respondentów: {0}',
        Number_responded_x: 'Liczba osób, która odpowiedziała: {0}',
        Numbers: 'Liczby',
        Ok: 'OK',
        Open_answer_heading: 'Odpowiedź',
        Open_question: 'Pytanie otwarte',
        Personal_data_warning: 'Nie wprowadzaj żadnych danych osobowych ani informacji chronionych prawem autorskim. Twoje dane wejściowe są wysyłane z itslearning poza UE w celu ich przetworzenia. Więcej informacji można znaleźć w sekcji „Jak to działa”.',
        Preview_survey: 'Podgląd ankiety',
        Previous: 'Wstecz',
        Print: 'Drukuj',
        QR_code: 'Kod QR',
        QR_code_copied_to_clipboard: 'Skopiowano obraz kodu QR do schowka',
        Quality: 'Jakość',
        Quality_Excellent: 'Doskonałe',
        Quality_Fair: 'Średnia',
        Quality_Good: 'Dobra',
        Quality_Poor: 'Słaba',
        Quality_Very_Poor: 'Bardzo słaba',
        Question: 'Pytanie',
        Question_has_been_saved: 'Zapisano pytanie.',
        Question_number_header: 'Numer pytania',
        Question_type: 'Rodzaj pytania',
        Question_type_short: 'Rodzaj',
        Question_x: 'Pytanie {0}',
        Question_x_of_y: 'Pytanie {0} z {1}',
        Questions: 'Pytania',
        QuestionType_MultipleChoice_short: 'Wielokrotny wybór',
        QuestionType_YesNo_short: 'Tak/nie',
        Remember_visible: 'Pamiętaj, że ankieta musi być widoczna dla respondentów.',
        Remember_visible_and_deadline: 'Pamiętaj, że ankieta musi być widoczna dla respondentów, a termin musi przypadać w przyszłości.',
        Remove_alternative_x: 'Usuń alternatywę {0}',
        Remove_statement_x: 'Usuń wypowiedź {0}',
        Respondent: 'Respondent',
        Responses: 'Odpowiedzi',
        Responses_summary: 'Podsumowanie',
        Responses_x: 'Odpowiedzi: {0}',
        Satisfaction: 'Satysfakcja',
        Satisfaction_Completely_Satisfied: 'Całkowicie zadowolony/a',
        Satisfaction_Moderately_Satisfied: 'Umiarkowanie zadowolony/a',
        Satisfaction_Not_At_All_Satisfied: 'Wcale nie jestem zadowolony/a',
        Satisfaction_Slightly_Satisfied: 'Lekko zadowolony/a',
        Satisfaction_Very_Satisfied: 'Bardzo zadowolony/a',
        Saturday: 'Sobota',
        Save: 'Zapisz',
        Save_and_new: 'Zapisz i nowe',
        Search: 'Wyszukaj',
        Search_for_respondents: 'Wyszukiwanie respondentów',
        Select_a_response_to_delete: 'Wybierz odpowiedź do usunięcia',
        Select_all_questions: 'Wybierz wszystkie pytania',
        Select_at_least_one_question_to_delete: 'Zaznacz co najmniej jedno pytanie do usunięcia',
        Select_question_x: 'Wybierz pytanie {0}',
        Share: 'Udostępnij',
        Share_survey: 'Udostępnij ankietę',
        Show_more: 'Wyświetl więcej',
        Show_response: 'Pokaż swoją odpowiedź',
        Showing_x_responses_of_total_y_responses: 'Wyświetlono odpowiedzi ({0}) z całkowitej liczby odpowiedzi ({1})',
        Start_moving_element_x: 'Zacznij przesuwać element: {0}',
        Started: 'Rozpoczęto',
        Statement_x: 'Wypowiedź {0}',
        Statements_rows: 'Wypowiedzi (wiersze)',
        Student_satisfaction_cafeteria: 'zadowolenie uczniów z opcji menu w stołówce',
        Submit_answer: 'Prześlij odpowiedź',
        Submitted: 'Przesłano',
        Submitted_after_deadline: 'Przesłano po terminie ostatecznym.',
        Sunday: 'Niedziela',
        Survey: 'Ankieta',
        Survey_inactive_message: 'Ta ankieta nie jest już dostępna. Możesz kontynuować później, jeśli stanie się ponownie dostępna.',
        Survey_start_page: 'Strona startowa ankiety',
        Survey_title: 'Ankieta',
        Survey_type: 'Typ ankiety',
        Take_survey: 'Wypełnij ankietę',
        Thanks_for_taking_the_survey: 'Dziękujemy za wypełnienie ankiety!',
        The_survey_is_about: 'Ankieta dotyczy',
        Thursday: 'Czwartek',
        Tips_and_examples: 'Wskazówki i przykłady',
        Tips_and_examples_info: 'Aby uzyskać użyteczne wyniki z usługi AI, dane wejściowe powinny być krótkie i zwięzłe. Nie pisz „Ta ankieta dotyczy…”, ponieważ jest to już zawarte w wysyłanym przez nas tekście. Przykłady danych wejściowych mogą być następujące:',
        Tuesday: 'Wtorek',
        Unknown_error: 'Coś poszło nie tak. Możliwymi przyczynami mogą być problemy z naszą usługą, ktoś może edytować ankietę lub Twoje połączenie sieciowe jest niestabilne. Jeśli połączenie jest prawidłowe i ten komunikat nadal jest wyświetlany, skontaktuj się z administratorem.',
        View_question_x_of_y: 'Zobacz pytanie {0} z {1}',
        Wednesday: 'Środa',
        Yes: 'Tak',
        Yes_no_question: 'Pytanie typu Tak/Nie',
        Your_response_will_not_be_saved: 'Twoja odpowiedź nie zostanie zapisana.',
    },
    'pt-BR': {
        Add_alternative: 'Adicionar alternativa',
        Add_question: 'Adicionar pergunta',
        Add_question_x: 'Adicionar pergunta {0}',
        Add_statement: 'Adicionar instrução',
        Agreement: 'Acordo',
        Agreement_Agree: 'Concordo',
        Agreement_Disagree: 'Discordo',
        Agreement_Neither_Agree_Nor_Disagree: 'Nem concordo nem discordo',
        Agreement_Strongly_Agree: 'Concordo totalmente',
        Agreement_Strongly_Disagree: 'Discordo totalmente',
        Allow_respondents_to_select_more_than_one_alternative: 'Permitir que os entrevistados selecionem mais de uma alternativa',
        Alternative_x: 'Alternativa {0}',
        Alternatives: 'Alternativas',
        Alternatives_columns: 'Alternativas (colunas)',
        Anonymous: 'Anônimo',
        Anonymous_responses: 'Anônimo',
        Answer_type: 'Tipo de resposta',
        Answer_was_cleared: 'A resposta foi apagada',
        Ask_our_AI_info_message: 'Peça para nosso robô de inteligência artificial (IA) gerar a pesquisa para você. Por padrão, você receberá uma introdução e perguntas de múltipla escolha. Você pode revisar e editar a pesquisa assim que ela for gerada. Veja as dicas abaixo para mais detalhes.',
        Autoloading: 'Baixando automaticamente',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Voltar à lista de perguntas',
        Back_to_responses: 'Voltar para respostas',
        Back_to_survey_details: 'Voltar aos detalhes da pesquisa',
        Cancel: 'Cancelar',
        Clear_answer: 'Limpar resposta',
        Close: 'Fechar',
        Continue_survey: 'Continuar pesquisa',
        Copy_public_link: 'Copiar link público',
        Copy_QR_code: 'Copiar código QR',
        Create_survey: 'Criar pesquisa',
        Create_survey_with_AI: 'Criar uma pesquisa com IA',
        Custom: 'Personalizado',
        DateFormat_just_now: 'Agora mesmo',
        DateFormat_one_hour_ago: '1 hora atrás',
        DateFormat_one_minute_ago: '1 minuto atrás',
        DateFormat_weekday_x_at_y: '{0} na(o) {1}',
        DateFormat_x_days_ago: 'Há {0} dias',
        DateFormat_x_hours_ago: '{0} horas atrás',
        DateFormat_x_minutes_ago: '{0} minutos atrás',
        DateFormat_yesterday_at_x: 'Ontem às {0}',
        Deadline_has_passed_message: 'O prazo passou e você não tem mais autorização para enviar uma resposta. Você pode continuar mais tarde se o prazo for estendido.',
        Delete: 'Excluir',
        Delete_questions_modal_title: 'Excluir as perguntas selecionadas?',
        Delete_responses: 'Excluir respostas?',
        Download_responses: 'Baixar respostas (Excel)',
        Edit_question: 'Editar pergunta',
        Edit_question_x_of_y: 'Editar pergunta {0} de {1}',
        Edit_settings_info: 'Não é possível editar as configurações de anonimato depois que alguém houver iniciado a pesquisa.',
        Edit_survey: 'Editar pesquisa',
        Element_has_been_moved_to_position_x_of_y: 'O elemento foi movido para a posição {0} de {1}',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'Nenhuma resposta ainda',
        Empty_state_no_responses_text: 'As respostas aparecerão aqui assim que alguém começar a responder à pesquisa.',
        Empty_survey_input_message: 'Você precisa escrever sobre o que se trata a pesquisa.',
        Evaluation_of_the_teaching: 'avaliação dos métodos de ensino da aula de ciências',
        Exit_preview: 'Sair da visualização',
        Exit_survey: 'Sair da pesquisa?',
        Exit_survey_button: 'Sair da pesquisa',
        External_and_anonymous: 'Externo e anônimo. Qualquer pessoa com um link pode responder.',
        External_survey: 'Externo - qualquer pessoa com o link pode responder',
        Frequency: 'Frequência',
        Frequency_Always: 'Sempre',
        Frequency_Never: 'Nunca',
        Frequency_Often: 'Com frequência',
        Frequency_Rarely: 'Raramente',
        Frequency_Sometimes: 'Às vezes',
        Friday: 'Sexta-feira',
        Generate_survey: 'Gerar pesquisa',
        Grid_no_questions_heading: 'Nenhuma pergunta',
        Grid_no_questions_text: 'Você ainda não criou nenhuma pergunta.',
        Homework_habits: 'hábitos ao fazer lição de casa',
        How_does_this_work: 'Como isso funciona?',
        How_does_this_work_info_part1: 'A informação que envia é usada como parte da instrução que enviamos para processamento. Com base na resposta, geramos uma pesquisa com uma introdução e perguntas de múltipla escolha com 5 alternativas de resposta (de "concordo totalmente" a "discordo totalmente"). Você poderá editar e ajustar todo o conteúdo antes de distribuir a pesquisa.',
        How_does_this_work_info_part2: 'A ITSLEARNING não é responsável pelo conteúdo da pesquisa gerada. Não moderamos a resposta do serviço de IA, que pode produzir informações imprecisas sobre pessoas, lugares ou fatos. O serviço a que nos conectamos é fornecido pela OpenAI, usando o modelo de chat GPT-3.5-turbo.',
        Importance: 'Importância',
        Importance_Extremely_Important: 'Extremamente importante',
        Importance_Moderately_Important: 'Moderadamente importante',
        Importance_Not_At_All_Important: 'Nada importante',
        Importance_Slightly_Important: 'Um pouco importante',
        Importance_Very_Important: 'Muito importante',
        Imported_rich_text_edit_warning: 'Este texto foi importado da antiga ferramenta de pesquisa. Quando você salva, toda a formatação e conteúdo avançado (por exemplo, imagens) são removidos.',
        Introduction: 'Introdução',
        Link_copied_to_clipboard: 'Link copiado para a área de transferência',
        Link_to_survey: 'Link para pesquisa',
        Matrix_question: 'Pergunta de matriz',
        Monday: 'Segunda-feira',
        Move_element_instructions: 'Para mover esse elemento, pressione espaço e use a seta para cima ou para baixo. Pressione espaço novamente para concluir.',
        Moving_element_to_position_x_of_y: 'Movendo o elemento para a posição {0} de {1}',
        Multiple_choice_question: 'Pergunta de múltipla escolha',
        Next: 'Avançar',
        No: 'Não',
        No_respondents: 'Nenhum entrevistado',
        Not_anonymous: 'Não anônimo',
        Not_possible_to_edit_questions_message: 'Você não pode mais adicionar, editar ou excluir perguntas porque alguém começou a responder a esta pesquisa.',
        Note: 'Observação',
        Number_of_questions: 'Número de perguntas',
        Number_of_respondents_x: 'Número de entrevistados: {0}',
        Number_responded_x: 'Número respondido: {0}',
        Numbers: 'Números',
        Ok: 'Ok',
        Open_answer_heading: 'Resposta',
        Open_question: 'Pergunta aberta',
        Personal_data_warning: 'Não insira nenhuma informação pessoal ou protegida por direitos autorais. Suas instruções são enviadas do itslearning para processamento fora da UE. Consulte "Como isso funciona" para ver mais detalhes.',
        Preview_survey: 'Pré-visualização da pesquisa',
        Previous: 'Anterior',
        Print: 'Imprimir',
        QR_code: 'Código QR',
        QR_code_copied_to_clipboard: 'Imagem do código QR copiada para a área de transferência',
        Quality: 'Qualidade',
        Quality_Excellent: 'Excelente',
        Quality_Fair: 'Regular',
        Quality_Good: 'Bom',
        Quality_Poor: 'Ruim',
        Quality_Very_Poor: 'Muito ruim',
        Question: 'Pergunta',
        Question_has_been_saved: 'A pergunta foi salva.',
        Question_number_header: 'Número da pergunta',
        Question_type: 'Tipo de pergunta',
        Question_type_short: 'Tipo',
        Question_x: 'Pergunta {0}',
        Question_x_of_y: 'Pergunta {0} de {1}',
        Questions: 'Perguntas',
        QuestionType_MultipleChoice_short: 'Múltipla escolha',
        QuestionType_YesNo_short: 'Sim/não',
        Remember_visible: 'Lembre-se de que a pesquisa deve estar visível para os participantes.',
        Remember_visible_and_deadline: 'Lembre-se de que a pesquisa deve estar visível para os participantes e o prazo deve ser no futuro.',
        Remove_alternative_x: 'Remover alternativa {0}',
        Remove_statement_x: 'Remover instrução {0}',
        Respondent: 'Entrevistado',
        Responses: 'Respostas',
        Responses_summary: 'Resumo',
        Responses_x: 'Respostas: {0}',
        Satisfaction: 'Satisfação',
        Satisfaction_Completely_Satisfied: 'Totalmente satisfeito',
        Satisfaction_Moderately_Satisfied: 'Moderadamente satisfeito',
        Satisfaction_Not_At_All_Satisfied: 'Nada satisfeito',
        Satisfaction_Slightly_Satisfied: 'Um pouco satisfeito',
        Satisfaction_Very_Satisfied: 'Muito satisfeito',
        Saturday: 'Sábado',
        Save: 'Salvar',
        Save_and_new: 'Salvar e novo',
        Search: 'Pesquisar',
        Search_for_respondents: 'Busca de entrevistados',
        Select_a_response_to_delete: 'Selecione uma resposta para excluir',
        Select_all_questions: 'Selecionar todas as perguntas',
        Select_at_least_one_question_to_delete: 'Selecione pelo menos uma pergunta a ser excluída.',
        Select_question_x: 'Selecionar pergunta {0}',
        Share: 'Compartilhar',
        Share_survey: 'Compartilhar pesquisa',
        Show_more: 'Mostrar mais',
        Show_response: 'Mostrar sua resposta',
        Showing_x_responses_of_total_y_responses: 'Mostrando {0} respostas do total de {1} respostas',
        Start_moving_element_x: 'Começar a mover elemento: {0}',
        Started: 'Iniciado',
        Statement_x: 'Instrução {0}',
        Statements_rows: 'Instruções (linhas)',
        Student_satisfaction_cafeteria: 'satisfação dos alunos com as opções no cardápio do refeitório',
        Submit_answer: 'Enviar resposta',
        Submitted: 'Enviados',
        Submitted_after_deadline: 'Enviado após o prazo',
        Sunday: 'Domingo',
        Survey: 'Pesquisa',
        Survey_inactive_message: 'Esta pesquisa não está mais disponível. Você pode continuar mais tarde se ela ficar disponível novamente.',
        Survey_start_page: 'Página inicial da pesquisa',
        Survey_title: 'Pesquisa',
        Survey_type: 'Tipo de pesquisa',
        Take_survey: 'Fazer pesquisa',
        Thanks_for_taking_the_survey: 'Agradecemos sua participação na pesquisa!',
        The_survey_is_about: 'A pesquisa é sobre',
        Thursday: 'Quinta-feira',
        Tips_and_examples: 'Dicas e exemplos',
        Tips_and_examples_info: 'Para obter um resultado útil do serviço de IA, as instruções devem ser curtas e concisas. Não escreva "Esta é uma pesquisa sobre..." pois isso já está incluído no texto que enviamos. Veja alguns exemplos de instruções:',
        Tuesday: 'Terça-feira',
        Unknown_error: 'Ocorreu um erro. Os possíveis motivos são problemas com nosso serviço, alguém está editando a pesquisa ou sua rede está instável. Se sua conexão estiver funcionando bem e você continuar vendo essa mensagem, entre em contato com o administrador.',
        View_question_x_of_y: 'Ver pergunta {0} de {1}',
        Wednesday: 'Quarta-feira',
        Yes: 'Sim',
        Yes_no_question: 'Pergunta Sim/Não',
        Your_response_will_not_be_saved: 'Sua resposta não será salva.',
    },
    'ru-RU': {
        Add_alternative: 'Добавить вариант',
        Add_question: 'Добавить вопрос',
        Add_question_x: 'Добавить вопрос {0}',
        Add_statement: 'Добавить утверждение',
        Agreement: 'Принятие',
        Agreement_Agree: 'Принимаю',
        Agreement_Disagree: 'Не принимаю',
        Agreement_Neither_Agree_Nor_Disagree: 'Частично принимаю',
        Agreement_Strongly_Agree: 'Категорически принимаю',
        Agreement_Strongly_Disagree: 'Категорически не принимаю',
        Allow_respondents_to_select_more_than_one_alternative: 'Позволить респондентам выбирать несколько вариантов',
        Alternative_x: 'Вариант {0}',
        Alternatives: 'Варианты',
        Alternatives_columns: 'Варианты (столбцы)',
        Anonymous: 'Анонимный',
        Anonymous_responses: 'Анонимный',
        Answer_type: 'Тип ответа',
        Answer_was_cleared: 'Ответ удален',
        Ask_our_AI_info_message: 'Попросите нашего робота с искусственным интеллектом (ИИ) создать для вас опрос. По умолчанию вы получите введение и вопросы с несколькими вариантами ответов. Вы сможете просмотреть и отредактировать опрос после его создания. Более подробную информацию см. в приведенных ниже советах.',
        Autoloading: 'Автозагрузка',
        Avatar: 'Аватар',
        Back_to_list_of_questions: 'Вернуться к списку вопросов',
        Back_to_responses: 'Вернуться к ответам',
        Back_to_survey_details: 'Вернуться к деталям опроса',
        Cancel: 'Отмена',
        Clear_answer: 'Удалить ответ',
        Close: 'Закрыть',
        Continue_survey: 'Продолжить опрос',
        Copy_public_link: 'Копировать общедоступную ссылку',
        Copy_QR_code: 'Скопировать QR-код',
        Create_survey: 'Создать опрос',
        Create_survey_with_AI: 'Создание опроса с помощью ИИ',
        Custom: 'Пользовательский',
        DateFormat_just_now: 'Только что',
        DateFormat_one_hour_ago: '1 час назад',
        DateFormat_one_minute_ago: '1 минута назад',
        DateFormat_weekday_x_at_y: '{0} в {1}',
        DateFormat_x_days_ago: '{0} д назад',
        DateFormat_x_hours_ago: '{0} ч назад',
        DateFormat_x_minutes_ago: '{0} мин. назад',
        DateFormat_yesterday_at_x: 'Вчера в {0}',
        Deadline_has_passed_message: 'Срок завершения истек, поэтому вы не можете отправить ответы. Вы сможете продолжить, если срок завершения будет продлен.',
        Delete: 'Удалить',
        Delete_questions_modal_title: 'Удалить выбранные вопросы?',
        Delete_responses: 'Удалить ответы?',
        Download_responses: 'Скачать ответы (Excel)',
        Edit_question: 'Редактировать вопрос',
        Edit_question_x_of_y: 'Редактировать вопрос {0} из {1}',
        Edit_settings_info: 'Изменить настройки анонимности будет невозможно после того, как кто-то начнет проходить опрос.',
        Edit_survey: 'Редактировать опрос',
        Element_has_been_moved_to_position_x_of_y: 'Элемент перемещен в положение {0} из {1}',
        Emojis: 'Эмодзи',
        Empty_state_no_responses_heading: 'Пока нет ответов',
        Empty_state_no_responses_text: 'Здесь появятся ответы, как только кто-то начнет проходить опрос.',
        Empty_survey_input_message: 'Укажите тему опроса.',
        Evaluation_of_the_teaching: 'оценка методов преподавания на уроках естествознания',
        Exit_preview: 'Выйти из предварительного просмотра',
        Exit_survey: 'Выйти из опроса?',
        Exit_survey_button: 'Выйти из опроса',
        External_and_anonymous: 'Внешний и анонимный. Любой пользователь, у которого есть ссылка, может отвечать.',
        External_survey: 'Внешний — любой пользователь, у которого есть ссылка, может отвечать.',
        Frequency: 'Частота',
        Frequency_Always: 'Всегда',
        Frequency_Never: 'Никогда',
        Frequency_Often: 'Часто',
        Frequency_Rarely: 'Редко',
        Frequency_Sometimes: 'Иногда',
        Friday: 'Пятница',
        Generate_survey: 'Создать опрос',
        Grid_no_questions_heading: 'Нет вопросов',
        Grid_no_questions_text: 'Вы еще не создали ни одного вопроса.',
        Homework_habits: 'привычки при выполнении домашних заданий',
        How_does_this_work: 'Как это работает?',
        How_does_this_work_info_part1: 'Входные данные используются как часть запроса, который мы отправляем на обработку. На основе ответа мы создаем опрос с введением и вопросами с 5 вариантами ответов (от «Категорически принимаю» до «Категорически не принимаю»). Вы сможете отредактировать и изменить содержимое опроса перед его отправкой.',
        How_does_this_work_info_part2: 'Платформа itslearning не несет ответственности за содержание созданного опроса. Мы не изменяем ответ службы ИИ, которая может выдавать неточную информацию о людях, местах или фактах. Служба, к которой мы подключаемся, предоставлена OpenAI и имеет в основе модель чата GPT-3.5-turbo.',
        Importance: 'Важность',
        Importance_Extremely_Important: 'Чрезвычайно важно',
        Importance_Moderately_Important: 'Умеренно важно',
        Importance_Not_At_All_Important: 'Совсем не важно',
        Importance_Slightly_Important: 'Не очень важно',
        Importance_Very_Important: 'Очень важно',
        Imported_rich_text_edit_warning: 'Этот текст импортирован из старого инструмента опроса. При сохранении форматирование и содержимое с форматированным текстом (например, изображения) будут удалены.',
        Introduction: 'Введение',
        Link_copied_to_clipboard: 'Ссылка скопирована в буфер обмена',
        Link_to_survey: 'Ссылка на опрос',
        Matrix_question: 'Матричный вопрос',
        Monday: 'Понедельник',
        Move_element_instructions: 'Чтобы переместить этот элемент, нажмите пробел и воспользуйтесь клавишами со стрелками вверх или вниз. Для завершения нажмите пробел еще раз.',
        Moving_element_to_position_x_of_y: 'Перемещение элемента в положение {0} из {1}',
        Multiple_choice_question: 'Вопрос с несколькими вариантами выбора',
        Next: 'Далее',
        No: 'Нет',
        No_respondents: 'Нет респондентов',
        Not_anonymous: 'Не анонимный',
        Not_possible_to_edit_questions_message: 'Вы не можете добавлять, редактировать или удалять вопросы, поскольку кто-то уже начал проходить опрос.',
        Note: 'Заметка',
        Number_of_questions: 'Количество вопросов',
        Number_of_respondents_x: 'Количество респондентов: {0}',
        Number_responded_x: 'Количество ответивших: {0}',
        Numbers: 'Числа',
        Ok: 'Ok',
        Open_answer_heading: 'Ответ',
        Open_question: 'Открытый вопрос',
        Personal_data_warning: 'Не вводите личную информацию или информацию, защищенную авторским правом. Входные данные отправляются с платформы itslearning за пределы ЕС для обработки. Дополнительные сведения см. в разделе «Как это работает».',
        Preview_survey: 'Предварительный просмотр опроса',
        Previous: 'Предыдущие',
        Print: 'Печать',
        QR_code: 'QR-код',
        QR_code_copied_to_clipboard: 'QR-код скопирован в буфер обмена',
        Quality: 'Качество',
        Quality_Excellent: 'Отлично',
        Quality_Fair: 'Удовлетворительно',
        Quality_Good: 'Хорошо',
        Quality_Poor: 'Плохо',
        Quality_Very_Poor: 'Очень плохо',
        Question: 'Вопрос',
        Question_has_been_saved: 'Вопрос сохранен.',
        Question_number_header: 'Номер вопроса',
        Question_type: 'Тип вопроса',
        Question_type_short: 'Тип',
        Question_x: 'Вопрос {0}',
        Question_x_of_y: 'Вопрос {0} из {1}',
        Questions: 'Вопросы',
        QuestionType_MultipleChoice_short: 'Несколько вариантов ответа',
        QuestionType_YesNo_short: 'Да/нет',
        Remember_visible: 'Помните, что опрос должен быть виден респондентам.',
        Remember_visible_and_deadline: 'Помните, что опрос должен быть виден респондентам, а срок выполнения должен быть в будущем.',
        Remove_alternative_x: 'Удалить вариант {0}',
        Remove_statement_x: 'Удалить утверждение {0}',
        Respondent: 'Респондент',
        Responses: 'Ответы',
        Responses_summary: 'Сводка',
        Responses_x: 'Ответов: {0}',
        Satisfaction: 'Удовлетворение',
        Satisfaction_Completely_Satisfied: 'Полностью доволен (-льна)',
        Satisfaction_Moderately_Satisfied: 'Умеренно доволен (-льна)',
        Satisfaction_Not_At_All_Satisfied: 'Совсем не доволен (-льна)',
        Satisfaction_Slightly_Satisfied: 'Не очень доволен (-льна)',
        Satisfaction_Very_Satisfied: 'Очень доволен (-льна)',
        Saturday: 'Суббота',
        Save: 'Сохранить',
        Save_and_new: 'Сохранить и новое',
        Search: 'Поиск',
        Search_for_respondents: 'Поиск респондентов',
        Select_a_response_to_delete: 'Выберите ответ для удаления',
        Select_all_questions: 'Выбрать все вопросы',
        Select_at_least_one_question_to_delete: 'Выберите хотя бы один вопрос для удаления',
        Select_question_x: 'Выбрать вопрос {0}',
        Share: 'Поделиться',
        Share_survey: 'Поделиться опросом',
        Show_more: 'Показать больше',
        Show_response: 'Показать ваш ответ',
        Showing_x_responses_of_total_y_responses: 'Показано ответов: {0} из {1}',
        Start_moving_element_x: 'Начало перемещения элемента: {0}',
        Started: 'Начато',
        Statement_x: 'Утверждение {0}',
        Statements_rows: 'Утверждения (строки)',
        Student_satisfaction_cafeteria: 'удовлетворенность учеников меню в кафетерии',
        Submit_answer: 'Отправить ответ',
        Submitted: 'Отправлено',
        Submitted_after_deadline: 'Отправлено после установленного срока',
        Sunday: 'Воскресенье',
        Survey: 'Опрос',
        Survey_inactive_message: 'Этот опрос больше не доступен. Вы сможете пройти его позже, если он снова станет доступен.',
        Survey_start_page: 'Стартовая страница опроса',
        Survey_title: 'Опрос',
        Survey_type: 'Тип опроса',
        Take_survey: 'Пройти опрос',
        Thanks_for_taking_the_survey: 'Спасибо, что приняли участие в опросе!',
        The_survey_is_about: 'Тема опроса',
        Thursday: 'Четверг',
        Tips_and_examples: 'Советы и примеры',
        Tips_and_examples_info: 'Для оптимальных результатов работы службы ИИ входные данные должны быть короткими и лаконичным. Не пишите «Это опрос о...» — эта информация будет автоматически включена в отправляемый текст. Примеры входных данных:',
        Tuesday: 'Вторник',
        Unknown_error: 'Произошла ошибка. Возможно, возникли проблемы в работе нашей службы, кто-то редактирует опрос или ваше подключение к сети нестабильно. Если у вас стабильное подключение, но по-прежнему отображается это сообщение, свяжитесь со своим администратором.',
        View_question_x_of_y: 'Просмотреть вопрос {0} из {1}',
        Wednesday: 'Среда',
        Yes: 'Да',
        Yes_no_question: 'Вопрос с ответом «да/нет»',
        Your_response_will_not_be_saved: 'Ваш ответ не будет сохранен.',
    },
    'sv-SE': {
        Add_alternative: 'Lägg till alternativ',
        Add_question: 'Lägg till fråga',
        Add_question_x: 'Lägg till fråga {0}',
        Add_statement: 'Lägg till påstående',
        Agreement: 'Instämmande',
        Agreement_Agree: 'Instämmer',
        Agreement_Disagree: 'Instämmer inte',
        Agreement_Neither_Agree_Nor_Disagree: 'Neutral',
        Agreement_Strongly_Agree: 'Instämmer helt',
        Agreement_Strongly_Disagree: 'Instämmer inte alls',
        Allow_respondents_to_select_more_than_one_alternative: 'Tillåt svaranden att välja mer än ett alternativ',
        Alternative_x: 'Alternativ {0}',
        Alternatives: 'Alternativ',
        Alternatives_columns: 'Alternativ (kolumner)',
        Anonymous: 'Anonym',
        Anonymous_responses: 'Anonymt',
        Answer_type: 'Svarstyp',
        Answer_was_cleared: 'Svaret rensades',
        Ask_our_AI_info_message: 'Be vår robot med artificiell intelligens (AI) att generera undersökningen åt dig. Som standard får du en introduktion och flervalsfrågor. Du kan granska och redigera undersökningen efter att den har genererats. Se tipsen nedan för mer information.',
        Autoloading: 'Automatisk uppdatering',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Tillbaka till listan med frågor',
        Back_to_responses: 'Tillbaka till svaren',
        Back_to_survey_details: 'Tillbaka till detaljer för undersökningen',
        Cancel: 'Avbryt',
        Clear_answer: 'Rensa svar',
        Close: 'Stäng',
        Continue_survey: 'Fortsätt undersökningen',
        Copy_public_link: 'Kopiera allmän länk',
        Copy_QR_code: 'Kopiera QR-kod',
        Create_survey: 'Skapa undersökning',
        Create_survey_with_AI: 'Skapa undersökning med AI',
        Custom: 'Anpassat',
        DateFormat_just_now: 'Just nu',
        DateFormat_one_hour_ago: '1 timme sedan',
        DateFormat_one_minute_ago: '1 minut sedan',
        DateFormat_weekday_x_at_y: '{0} vid {1}',
        DateFormat_x_days_ago: '{0} dagar sedan',
        DateFormat_x_hours_ago: '{0} timmar sedan',
        DateFormat_x_minutes_ago: '{0} minuter sedan',
        DateFormat_yesterday_at_x: 'I går vid {0}',
        Deadline_has_passed_message: 'Tidsgränsen har gått ut och du går inte längre lämna in ett svar. Du kan fortsätta senare om tidsgränsen förlängs.',
        Delete: 'Ta bort',
        Delete_questions_modal_title: 'Ta bort de markerade frågorna?',
        Delete_responses: 'Ta bort svar?',
        Download_responses: 'Ladda ner svar (Excel)',
        Edit_question: 'Redigera fråga',
        Edit_question_x_of_y: 'Redigera fråga {0} av {1}',
        Edit_settings_info: 'Det går inte att redigera inställningarna för anonymitet efter att någon har startat undersökningen.',
        Edit_survey: 'Redigera undersökning',
        Element_has_been_moved_to_position_x_of_y: 'Elementet har flyttats till position {0} av {1}',
        Emojis: 'Emojis',
        Empty_state_no_responses_heading: 'Inga svar ännu',
        Empty_state_no_responses_text: 'Svaren visas här när någon börjar svara på undersökningen.',
        Empty_survey_input_message: 'Du måste ange vad undersökningen handlar om.',
        Evaluation_of_the_teaching: 'utvärdering av undervisningsmetoderna i matematik',
        Exit_preview: 'Avsluta förhandsgranskning',
        Exit_survey: 'Avsluta undersökningen?',
        Exit_survey_button: 'Avsluta undersökning',
        External_and_anonymous: 'Extern och anonym. Alla som har fått en länk kan svara.',
        External_survey: 'Extern - alla som har fått länken kan svara',
        Frequency: 'Frekvens',
        Frequency_Always: 'Alltid',
        Frequency_Never: 'Aldrig',
        Frequency_Often: 'Ofta',
        Frequency_Rarely: 'Sällan',
        Frequency_Sometimes: 'Ibland',
        Friday: 'Fredag',
        Generate_survey: 'Generera undersökning',
        Grid_no_questions_heading: 'Inga frågor',
        Grid_no_questions_text: 'Du har inte skapat några frågor än.',
        Homework_habits: 'läxrutiner',
        How_does_this_work: 'Hur fungerar detta?',
        How_does_this_work_info_part1: 'Din inmatning används som en del av informationen som skickas till bearbetning. Baserat på svaret genereras en undersökning med en introduktion och flervalsfrågor med fem svarsalternativ (från ”instämmer helt” till ”instämmer inte alls”). Du kommer att kunna redigera och justera allt innehåll innan du distribuerar undersökningen.',
        How_does_this_work_info_part2: 'itslearning ansvarar inte för innehållet i den genererade undersökningen, och modererar inte svaret från AI-tjänsten, som kan ge felaktig information om människor, platser eller fakta. Tjänsten itslearning ansluter till tillhandahålls av OpenAI, och den använder chattmodellen GPT-3.5-turbo.',
        Importance: 'Viktighet',
        Importance_Extremely_Important: 'Oerhört viktigt',
        Importance_Moderately_Important: 'Delvis viktigt',
        Importance_Not_At_All_Important: 'Inte alls viktigt',
        Importance_Slightly_Important: 'Mindre viktigt',
        Importance_Very_Important: 'Mycket viktigt',
        Imported_rich_text_edit_warning: 'Den här texten importerades från det gamla undersökningsverktyget. När du sparar tas all formatering och RTF-innehåll (till exempel bilder) bort.',
        Introduction: 'Introduktion',
        Link_copied_to_clipboard: 'Länk kopierad till Urklipp',
        Link_to_survey: 'Länk till undersökningen',
        Matrix_question: 'Matrisfråga',
        Monday: 'Måndag',
        Move_element_instructions: 'För att flytta detta element, tryck på mellanslag och använd upp- eller nedpilen. Tryck på mellanslag igen för att slutföra.',
        Moving_element_to_position_x_of_y: 'Flytta element till position {0} av {1}',
        Multiple_choice_question: 'Flervalsfråga',
        Next: 'Nästa',
        No: 'Nej',
        No_respondents: 'Inga svarande',
        Not_anonymous: 'Inte anonym',
        Not_possible_to_edit_questions_message: 'Du kan inte längre lägga till, redigera eller ta bort frågor eftersom någon har börjat svara på undersökningen.',
        Note: 'Anteckning',
        Number_of_questions: 'Antal frågor',
        Number_of_respondents_x: 'Antal svaranden: {0}',
        Number_responded_x: 'Antal som har svarat: {0}',
        Numbers: 'Siffror',
        Ok: 'OK',
        Open_answer_heading: 'Svar',
        Open_question: 'Öppen fråga',
        Personal_data_warning: 'Ange inte någon personlig eller upphovsrättsskyddad information. Din inmatning skickas från itslearning utanför EU för bearbetning. Se ”Hur fungerar detta” för mer information.',
        Preview_survey: 'Förhandsgranska undersökning',
        Previous: 'Föregående',
        Print: 'Skriv ut',
        QR_code: 'QR-kod',
        QR_code_copied_to_clipboard: 'QR-kodbild kopierad till Urklipp',
        Quality: 'Kvalitet',
        Quality_Excellent: 'Utmärkt',
        Quality_Fair: 'OK',
        Quality_Good: 'Bra',
        Quality_Poor: 'Dåligt',
        Quality_Very_Poor: 'Mycket dåligt',
        Question: 'Fråga',
        Question_has_been_saved: 'Frågan sparades',
        Question_number_header: 'Frågans nummer',
        Question_type: 'Frågetyp',
        Question_type_short: 'Typ',
        Question_x: 'Fråga {0}',
        Question_x_of_y: 'Fråga {0} av {1}',
        Questions: 'Frågor',
        QuestionType_MultipleChoice_short: 'Flervalsfråga',
        QuestionType_YesNo_short: 'Ja/nej',
        Remember_visible: 'Kom ihåg att undersökningen måste vara synlig för de svarande.',
        Remember_visible_and_deadline: 'Kom ihåg att undersökningen måste vara synlig för de svarande och att tidsgränsen måste vara i framtiden.',
        Remove_alternative_x: 'Ta bort alternativ {0}',
        Remove_statement_x: 'Ta bort påstående {0}',
        Respondent: 'Respondent',
        Responses: 'Svar',
        Responses_summary: 'Sammanfattning',
        Responses_x: 'Antal svar: {0}',
        Satisfaction: 'Nöjdhet',
        Satisfaction_Completely_Satisfied: 'Helt nöjd',
        Satisfaction_Moderately_Satisfied: 'Delvis nöjd',
        Satisfaction_Not_At_All_Satisfied: 'Inte alls nöjd',
        Satisfaction_Slightly_Satisfied: 'Mindre nöjd',
        Satisfaction_Very_Satisfied: 'Mycket nöjd',
        Saturday: 'Lördag',
        Save: 'Spara',
        Save_and_new: 'Spara och ny',
        Search: 'Sök',
        Search_for_respondents: 'Sök efter svaranden',
        Select_a_response_to_delete: 'Välj ett svar att ta bort',
        Select_all_questions: 'Välj alla frågor',
        Select_at_least_one_question_to_delete: 'Välj minst en fråga som ska tas bort.',
        Select_question_x: 'Välj fråga {0}',
        Share: 'Dela',
        Share_survey: 'Dela undersökning',
        Show_more: 'Visa mer',
        Show_response: 'Visa ditt svar',
        Showing_x_responses_of_total_y_responses: 'Visar {0} svar av totalt {1} svar',
        Start_moving_element_x: 'Börja flytta element: {0}',
        Started: 'Påbörjade',
        Statement_x: 'Påstående {0}',
        Statements_rows: 'Påståenden (rader)',
        Student_satisfaction_cafeteria: 'hur nöjda eleverna är med utbudet i cafeterian',
        Submit_answer: 'Lämna in svar',
        Submitted: 'Inlämnad',
        Submitted_after_deadline: 'Inlämnad efter tidsgräns',
        Sunday: 'Söndag',
        Survey: 'Undersökning',
        Survey_inactive_message: 'Denna undersökning är inte längre tillgänglig. Du kan fortsätta senare om den blir tillgänglig igen.',
        Survey_start_page: 'Startsida för undersökningen',
        Survey_title: 'Undersökning',
        Survey_type: 'Typ av undersökning',
        Take_survey: 'Delta i undersökningen',
        Thanks_for_taking_the_survey: 'Tack för att du deltog i undersökningen!',
        The_survey_is_about: 'Undersökningen handlar om',
        Thursday: 'Torsdag',
        Tips_and_examples: 'Tips och exempel',
        Tips_and_examples_info: 'För att få användbara resultat från AI-tjänsten bör du se till att inmatningen är kort och koncis. Skriv inte ”Det här är en undersökning om...”, eftersom det redan ingår i texten som skickas. Exempel på inmatning kan vara:',
        Tuesday: 'Tisdag',
        Unknown_error: 'Något gick fel. Möjliga orsaker kan vara problem med vår tjänst, att någon redigerar undersökningen eller att ditt nätverk är instabilt. Om anslutningen är OK och det här meddelandet fortfarande visas ska du kontakta din administratör.',
        View_question_x_of_y: 'Visa fråga {0} av {1}',
        Wednesday: 'Onsdag',
        Yes: 'Ja',
        Yes_no_question: 'Ja/nej-fråga',
        Your_response_will_not_be_saved: 'Ditt svar sparas inte.',
    },
    'tr-TR': {
        Add_alternative: 'Alternatif ekle',
        Add_question: 'Soru ekle',
        Add_question_x: 'Soru ekle {0}',
        Add_statement: 'İfade ekle',
        Agreement: 'Anlaşma',
        Agreement_Agree: 'Katılıyorum',
        Agreement_Disagree: 'Katılmıyorum',
        Agreement_Neither_Agree_Nor_Disagree: 'Ne katılıyorum ne de katılmıyorum',
        Agreement_Strongly_Agree: 'Kesinlikle katılıyorum',
        Agreement_Strongly_Disagree: 'Kesinlikle katılmıyorum',
        Allow_respondents_to_select_more_than_one_alternative: 'Yanıtlayanların birden fazla alternatif seçmelerine izin ver',
        Alternative_x: 'Alternatif {0}',
        Alternatives: 'Alternatifler',
        Alternatives_columns: 'Alternatifler (sütunlar)',
        Anonymous: 'Anonim',
        Anonymous_responses: 'Anonim',
        Answer_type: 'Yanıt türü',
        Answer_was_cleared: 'Cevap silindi',
        Ask_our_AI_info_message: 'Yapay zeka (AI) robotumuzdan sizin için anket oluşturmasını isteyin. Ekranınıza varsayılan bir giriş ile çoktan seçmeli sorular gelecek. Anket oluşturulduktan sonra anketi inceleyebilir ve düzenleyebilirsiniz. Daha fazla ayrıntı için aşağıdaki ipuçlarına bakın.',
        Autoloading: 'Otomatik yükleniyor',
        Avatar: 'Avatar',
        Back_to_list_of_questions: 'Soru listesine geri dön',
        Back_to_responses: 'Yanıtlara geri dön',
        Back_to_survey_details: 'Anket ayrıntılarına geri dön',
        Cancel: 'İptal',
        Clear_answer: 'Yanıtı temizle',
        Close: 'Kapat',
        Continue_survey: 'Ankete devam et',
        Copy_public_link: 'Genel bağlantıyı kopyala',
        Copy_QR_code: 'QR kodunu kopyala',
        Create_survey: 'Anket oluştur',
        Create_survey_with_AI: 'AI ile anket oluşturun',
        Custom: 'Özel',
        DateFormat_just_now: 'Az önce',
        DateFormat_one_hour_ago: '1 saat önce',
        DateFormat_one_minute_ago: '1 dakika önce',
        DateFormat_weekday_x_at_y: '{0}, {1}',
        DateFormat_x_days_ago: '{0} gün önce',
        DateFormat_x_hours_ago: '{0} saat önce',
        DateFormat_x_minutes_ago: '{0} dakika önce',
        DateFormat_yesterday_at_x: 'Dün saat: {0}',
        Deadline_has_passed_message: 'Son tarih geçti ve artık yanıt göndermenize izin verilmiyor. Son tarih uzatılırsa daha sonra devam edebilirsiniz.',
        Delete: 'Sil',
        Delete_questions_modal_title: 'Seçili sorular silinsin mi?',
        Delete_responses: 'Yanıtları silmek mi istiyorsunuz?',
        Download_responses: 'Yanıtları indir (Excel)',
        Edit_question: 'Soruyu düzenle',
        Edit_question_x_of_y: '{0} / {1} soruyu düzenle',
        Edit_settings_info: 'Birisi anketi başlattıktan sonra anonim ayarları düzenlemek mümkün değildir.',
        Edit_survey: 'Anketi düzenle',
        Element_has_been_moved_to_position_x_of_y: 'Öğe {0} / {1} konumuna taşındı',
        Emojis: 'Emojiler',
        Empty_state_no_responses_heading: 'Henüz yanıt yok',
        Empty_state_no_responses_text: 'Birisi anketi yanıtlamaya başladığında yanıtlar burada görünür.',
        Empty_survey_input_message: 'Anketin ne konuda olduğunu yazmalısınız.',
        Evaluation_of_the_teaching: 'fen bilgisi dersi öğretim yöntemlerinin değerlendirilmesi',
        Exit_preview: 'Ön izlemeden çık',
        Exit_survey: 'Anketten çıkmak mı istediniz?',
        Exit_survey_button: 'Anketten çık',
        External_and_anonymous: 'Harici ve anonim. Bağlantısı olan herkes yanıt verebilir.',
        External_survey: 'Harici - bağlantıya sahip olan herkes yanıt verebilir',
        Frequency: 'Sıklık',
        Frequency_Always: 'Her Zaman',
        Frequency_Never: 'Hiçbir zaman',
        Frequency_Often: 'Sık sık',
        Frequency_Rarely: 'Nadiren',
        Frequency_Sometimes: 'Bazen',
        Friday: 'Cuma',
        Generate_survey: 'Anket oluşturun',
        Grid_no_questions_heading: 'Soru yok',
        Grid_no_questions_text: 'Henüz herhangi bir soru oluşturmadınız.',
        Homework_habits: 'ödev alışkanlıkları',
        How_does_this_work: 'Nasıl çalışır?',
        How_does_this_work_info_part1: 'Girdiniz, işleme için gönderdiğimiz istemin bir parçası olarak kullanılır. Yanıtlara dayanarak bir giriş ve (\'kesinlikle katılıyorum\' ile \'kesinlikle katılmıyorum\' arasında) 5 cevap alternatifli çoktan seçmeli sorular içeren bir anket oluşturuyoruz. Anketi dağıtmadan önce tüm içeriği düzenleyebilecek ve ayarlayabileceksiniz.',
        How_does_this_work_info_part2: 'itslearning oluşturulan anketin içeriğinden sorumlu değildir. AI hizmetinden gelen yanıtı denetlemiyoruz. Bu da insanlar, yerler veya gerçeklere dair yanlış bilgiler oluşturulmasına sebep olabilir. Bağlandığımız hizmet OpenAI tarafından GPT-3.5-turbo sohbet modeli kullanılarak sağlanmaktadır.',
        Importance: 'Önem',
        Importance_Extremely_Important: 'Son derece önemli',
        Importance_Moderately_Important: 'Orta derecede önemli',
        Importance_Not_At_All_Important: 'Hiç önemli değil',
        Importance_Slightly_Important: 'Biraz önemli',
        Importance_Very_Important: 'Çok önemli',
        Imported_rich_text_edit_warning: 'Bu metin eski anket aracından içe aktarılmıştır. Kaydettiğinizde, tüm biçimlendirme ve zengin metin içeriği (örneğin resimler) kaldırılır.',
        Introduction: 'Giriş',
        Link_copied_to_clipboard: 'Bağlantı panoya kopyalandı',
        Link_to_survey: 'Ankete bağlantı',
        Matrix_question: 'Matris sorusu',
        Monday: 'Pazartesi',
        Move_element_instructions: 'Bu öğeyi taşımak için boşluk tuşuna basın ve yukarı veya aşağı okunu kullanın. Tamamlamak için boşluk tuşuna tekrar basın.',
        Moving_element_to_position_x_of_y: 'Elemanı {0} / {1} konumuna taşıma',
        Multiple_choice_question: 'Çoktan seçmeli soru',
        Next: 'Sonraki',
        No: 'Hayır',
        No_respondents: 'Yanıtlayan yok',
        Not_anonymous: 'Anonim olmayan',
        Not_possible_to_edit_questions_message: 'Birisi bu anketi yanıtlamaya başladığı için artık soru ekleyemez, düzenleyemez veya silemezsiniz.',
        Note: 'Not',
        Number_of_questions: 'Soru sayısı',
        Number_of_respondents_x: 'Yanıtlayanların sayısı: {0}',
        Number_responded_x: 'Yanıtlanan sayı: {0}',
        Numbers: 'Sayılar',
        Ok: 'Tamam',
        Open_answer_heading: 'Yanıt',
        Open_question: 'Soru aç',
        Personal_data_warning: 'Kişisel veya telif hakkıyla korunan bilgileri girmeyin. Girdileriniz işlenmek üzere itslearning\'den AB dışına gönderilir. Daha fazla ayrıntı için "Nasıl çalışır" bölümüne bakın.',
        Preview_survey: 'Anketi ön izleme',
        Previous: 'Önceki',
        Print: 'Yazdır',
        QR_code: 'QR kodu',
        QR_code_copied_to_clipboard: 'Panoya kopyalanan QR kodu görüntüsü',
        Quality: 'Kalite',
        Quality_Excellent: 'Mükemmel',
        Quality_Fair: 'İdare Eder',
        Quality_Good: 'İyi',
        Quality_Poor: 'Zayıf',
        Quality_Very_Poor: 'Çok zayıf',
        Question: 'Soru',
        Question_has_been_saved: 'Soru kaydedildi.',
        Question_number_header: 'Soru numarası',
        Question_type: 'Soru türü',
        Question_type_short: 'Tür',
        Question_x: 'Soru {0}',
        Question_x_of_y: 'Soru {0} / {1}',
        Questions: 'Sorular',
        QuestionType_MultipleChoice_short: 'Çoktan seçmeli',
        QuestionType_YesNo_short: 'Evet/hayır',
        Remember_visible: 'Anketin katılımcılar tarafından görülebilir olması gerektiğini unutmayın.',
        Remember_visible_and_deadline: 'Anketin katılımcılar tarafından görülebilir olması ve son teslim tarihinin gelecekte olması gerektiğini unutmayın.',
        Remove_alternative_x: '{0} alternatifini kaldır',
        Remove_statement_x: '{0} ifadesini kaldır',
        Respondent: 'Yanıtlayan',
        Responses: 'Yanıtlar',
        Responses_summary: 'Özet',
        Responses_x: 'Yanıtlar: {0}',
        Satisfaction: 'Memnuniyet',
        Satisfaction_Completely_Satisfied: 'Tamamen memnun kaldım',
        Satisfaction_Moderately_Satisfied: 'Orta derecede memnun',
        Satisfaction_Not_At_All_Satisfied: 'Hiç memnun değilim',
        Satisfaction_Slightly_Satisfied: 'Biraz memnun kaldım',
        Satisfaction_Very_Satisfied: 'Çok memnun kaldım',
        Saturday: 'Cumartesi',
        Save: 'Kaydet',
        Save_and_new: 'Kaydet ve yeni',
        Search: 'Ara',
        Search_for_respondents: 'Yanıtlayanları arama',
        Select_a_response_to_delete: 'Silmek için bir yanıt seçin',
        Select_all_questions: 'Tüm soruları seçin',
        Select_at_least_one_question_to_delete: 'Silinecek en az bir soru seçin',
        Select_question_x: 'Soru seçin {0}',
        Share: 'Paylaş',
        Share_survey: 'Anketi paylaş',
        Show_more: 'Daha fazla göster',
        Show_response: 'Yanıtınızı gösterin',
        Showing_x_responses_of_total_y_responses: 'Toplam {1} yanıttan {0} yanıt gösteriliyor',
        Start_moving_element_x: 'Öğeyi hareket ettirmeye başlayın: {0}',
        Started: 'Başlangıç',
        Statement_x: 'İfade {0}',
        Statements_rows: 'İfadeler (satırlar)',
        Student_satisfaction_cafeteria: 'öğrencilerin okul kantinindeki menü seçeneklerine yönelik memnuniyeti',
        Submit_answer: 'Yanıtı gönder',
        Submitted: 'Gönderildi',
        Submitted_after_deadline: 'Bitiş zamanından sonra gönderildi',
        Sunday: 'Pazar',
        Survey: 'Anket',
        Survey_inactive_message: 'Bu anket artık kullanılamamaktadır. Tekrar kullanılabilir hale gelirse daha sonra devam edebilirsiniz.',
        Survey_start_page: 'Anket başlangıç sayfası',
        Survey_title: 'Anket',
        Survey_type: 'Anket türü',
        Take_survey: 'Ankete katıl',
        Thanks_for_taking_the_survey: 'Ankete katıldığınız için teşekkür ederiz!',
        The_survey_is_about: 'Bu anket şunun hakkındadır',
        Thursday: 'Perşembe',
        Tips_and_examples: 'İpuçları ve örnekler',
        Tips_and_examples_info: 'AI hizmetinden faydalı sonuçlar elde etmek için girdiyi kısa ve öz tutun. "Bu anket şunun hakkındadır..." yazmayın, çünkü bu zaten gönderdiğimiz metinde yer almaktadır. Girdi örnekleri şu şekilde olabilir:',
        Tuesday: 'Salı',
        Unknown_error: 'Bir şeyler ters gitti. Bunun olası nedenleri hizmetimizle ilgili sorunlar, birisinin anketi düzenlemesi veya ağınızın dengesiz olması olabilir. Bağlantınız iyi ise ve bu mesajı görmeye devam ediyorsanız, lütfen yöneticinize başvurun.',
        View_question_x_of_y: '{0} / {1} soruyu görüntüle',
        Wednesday: 'Çarşamba',
        Yes: 'Evet',
        Yes_no_question: 'Evet/hayır sorusu',
        Your_response_will_not_be_saved: 'Yanıtınız kaydedilmeyecek.',
    },
    'uk-UA': {
        Add_alternative: 'Додати варіант',
        Add_question: 'Додати запитання',
        Add_question_x: 'Додати запитання {0}',
        Add_statement: 'Додати твердження',
        Agreement: 'Згода',
        Agreement_Agree: 'Погоджуюся',
        Agreement_Disagree: 'Не погоджуюся',
        Agreement_Neither_Agree_Nor_Disagree: 'Частково погоджуюся',
        Agreement_Strongly_Agree: 'Категорично погоджуюся',
        Agreement_Strongly_Disagree: 'Категорично не погоджуюся',
        Allow_respondents_to_select_more_than_one_alternative: 'Дозволяти респондентам вибирати більше одного варіанта',
        Alternative_x: 'Варіант {0}',
        Alternatives: 'Варіанти',
        Alternatives_columns: 'Варіанти (стовпці)',
        Anonymous: 'Анонімно',
        Anonymous_responses: 'Анонімно',
        Answer_type: 'Тип відповіді',
        Answer_was_cleared: 'Відповідь видалена',
        Ask_our_AI_info_message: 'Попросіть нашого робота зі штучним інтелектом (ШІ) створити опитування для вас. За замовчуванням ви отримаєте вступ і запитання з кількома варіантами відповідей. Після створення ви зможете переглянути й відредагувати опитування. Щоб дізнатися більше, перегляньте поради нижче.',
        Autoloading: 'Автозавантаження',
        Avatar: 'Аватар',
        Back_to_list_of_questions: 'Повернутися до списку питань',
        Back_to_responses: 'Повернутися до відповідей',
        Back_to_survey_details: 'Повернутися до відомостей щодо опитування',
        Cancel: 'Скасувати',
        Clear_answer: 'Очистити відповідь',
        Close: 'Закрити',
        Continue_survey: 'Продовжити опитування',
        Copy_public_link: 'Копіювати загальнодоступне посилання',
        Copy_QR_code: 'Скопіювати QR-код',
        Create_survey: 'Створити опитування',
        Create_survey_with_AI: 'Створення опитування за допомогою ШІ',
        Custom: 'Індивідуально',
        DateFormat_just_now: 'Щойно',
        DateFormat_one_hour_ago: '1 годину тому',
        DateFormat_one_minute_ago: '1 хвилину тому',
        DateFormat_weekday_x_at_y: '{0} о {1}',
        DateFormat_x_days_ago: '{0} дн. тому',
        DateFormat_x_hours_ago: '{0} год. тому',
        DateFormat_x_minutes_ago: '{0} хв. тому',
        DateFormat_yesterday_at_x: 'Учора о {0}',
        Deadline_has_passed_message: 'Термін завершення минув, тому ви не можете надсилати відповіді. Ви зможете знову надсилати відповіді, якщо термін завершення буде подовжено.',
        Delete: 'Видалити',
        Delete_questions_modal_title: 'Видалити вибрані запитання?',
        Delete_responses: 'Видалити відповіді?',
        Download_responses: 'Завантажити відповіді (Excel)',
        Edit_question: 'Редагувати запитання',
        Edit_question_x_of_y: 'Редагувати запитання {0} з {1}',
        Edit_settings_info: 'Неможливо змінити налаштування анонімності після того, як хтось почав проходити опитування.',
        Edit_survey: 'Редагувати опитування',
        Element_has_been_moved_to_position_x_of_y: 'Елемент переміщено в положення {0} з {1}',
        Emojis: 'Емодзі',
        Empty_state_no_responses_heading: 'Поки немає відповідей',
        Empty_state_no_responses_text: 'Відповіді почнуть з’являтися тут, коли хтось почне проходити опитування.',
        Empty_survey_input_message: 'Потрібно вказати тему опитування.',
        Evaluation_of_the_teaching: 'оцінка методики викладання на уроці науки',
        Exit_preview: 'Вийти з попереднього перегляду',
        Exit_survey: 'Вийти з опитування?',
        Exit_survey_button: 'Вийти з опитування',
        External_and_anonymous: 'Зовнішнє та анонімне. Будь-хто з посиланням може відповідати.',
        External_survey: 'Зовнішнє — будь-хто з посиланням може відповідати',
        Frequency: 'Частота',
        Frequency_Always: 'Завжди',
        Frequency_Never: 'Ніколи',
        Frequency_Often: 'Часто',
        Frequency_Rarely: 'Рідко',
        Frequency_Sometimes: 'Інколи',
        Friday: 'П’ятниця',
        Generate_survey: 'Створити опитування',
        Grid_no_questions_heading: 'Немає запитань',
        Grid_no_questions_text: 'Запитання ще не створено.',
        Homework_habits: 'звички щодо домашнього завдання',
        How_does_this_work: 'Як це працює?',
        How_does_this_work_info_part1: 'Уведені дані використовуватимуться як частина підказки, яку ми надсилаємо на обробку. На основі відповіді ми генеруємо опитування зі вступом і запитаннями з множинним вибором (5 варіантів) (від «Категорично погоджуюся» до «Категорично не погоджуюся»). Ви зможете відредагувати й змінити вміст опитування, перш ніж надсилати його.',
        How_does_this_work_info_part2: 'Платформа itslearning не несе відповідальності за зміст сформованого опитування. Ми не модеруємо відповіді служби штучного інтелекту. Відповіді можуть містити неточну інформацію про людей, місця чи факти. Служба, до якої ми підключаємося, надається компанією OpenAI і має за основу модель чата GPT-3.5-turbo.',
        Importance: 'Важливість',
        Importance_Extremely_Important: 'Надзвичайно важливо',
        Importance_Moderately_Important: 'Помірно важливо',
        Importance_Not_At_All_Important: 'Зовсім не важливо',
        Importance_Slightly_Important: 'Частково важливо',
        Importance_Very_Important: 'Дуже важливо',
        Imported_rich_text_edit_warning: 'Цей текст імпортовано зі старого інструмента для опитувань. Після збереження все форматування та форматований уміст, як-от зображення, буде видалено.',
        Introduction: 'Вступ',
        Link_copied_to_clipboard: 'Посилання скопійоване в буфер обміну',
        Link_to_survey: 'Посилання на опитування',
        Matrix_question: 'Запитання з матрицею',
        Monday: 'Понеділок',
        Move_element_instructions: 'Щоб перемістити цей елемент, натисніть пробіл і скористайтеся клавішами зі стрілками вгору й вниз. Для завершення натисніть пробіл ще раз.',
        Moving_element_to_position_x_of_y: 'Переміщення елемента в положення {0} з {1}',
        Multiple_choice_question: 'Запитання з однією правильною відповіддю з усіх можливих',
        Next: 'Далі',
        No: 'Ні',
        No_respondents: 'Немає респондентів',
        Not_anonymous: 'Не анонімно',
        Not_possible_to_edit_questions_message: 'Ви більше не можете додавати, редагувати або видаляти запитання, оскільки хтось почав проходити опитування.',
        Note: 'Примітка',
        Number_of_questions: 'Кількість запитань',
        Number_of_respondents_x: 'Кількість респондентів: {0}',
        Number_responded_x: 'Пройшло опитування: {0}',
        Numbers: 'Числа',
        Ok: 'OK',
        Open_answer_heading: 'Відповідь',
        Open_question: 'Відкрите запитання',
        Personal_data_warning: 'Не вводьте особисту інформацію або інформацію, захищену авторським правом. Вхідні дані надсилається з платформи itslearning за межі ЄС для обробки. Детальніше див. в розділі «Як це працює».',
        Preview_survey: 'Попередній перегляд опитування',
        Previous: 'Назад',
        Print: 'Друк',
        QR_code: 'QR-код',
        QR_code_copied_to_clipboard: 'QR-код скопійовано до буфера обміну',
        Quality: 'Якість',
        Quality_Excellent: 'Відмінно',
        Quality_Fair: 'Задовільно',
        Quality_Good: 'Добре',
        Quality_Poor: 'Погано',
        Quality_Very_Poor: 'Дуже погано',
        Question: 'Запитання',
        Question_has_been_saved: 'Запитання збережено.',
        Question_number_header: 'Кількість запитань',
        Question_type: 'Тип запитання',
        Question_type_short: 'Тип',
        Question_x: 'Запитання {0}',
        Question_x_of_y: 'Питання {0} з {1}',
        Questions: 'Запитання',
        QuestionType_MultipleChoice_short: 'Одна правильна відповідь з усіх можливих',
        QuestionType_YesNo_short: 'Так/ні',
        Remember_visible: 'Пам’ятайте, що опитування має бути видимим для респондентів.',
        Remember_visible_and_deadline: 'Пам’ятайте, що опитування має бути видимим для респондентів, а термін завершення має бути в майбутньому.',
        Remove_alternative_x: 'Видалити варіант {0}',
        Remove_statement_x: 'Видалити твердження {0}',
        Respondent: 'Респондент',
        Responses: 'Відповіді',
        Responses_summary: 'Зведення',
        Responses_x: 'Відповідей: {0}',
        Satisfaction: 'Задоволення',
        Satisfaction_Completely_Satisfied: 'Повністю задоволений (-на)',
        Satisfaction_Moderately_Satisfied: 'Помірно задоволений (-на)',
        Satisfaction_Not_At_All_Satisfied: 'Зовсім не задоволений (-на)',
        Satisfaction_Slightly_Satisfied: 'Злегка задоволений (-на)',
        Satisfaction_Very_Satisfied: 'Дуже задоволений (-на)',
        Saturday: 'Субота',
        Save: 'Зберегти',
        Save_and_new: 'Зберегти та створити',
        Search: 'Пошук',
        Search_for_respondents: 'Пошук респондентів',
        Select_a_response_to_delete: 'Виберіть відповідь для видалення',
        Select_all_questions: 'Вибрати всі запитання',
        Select_at_least_one_question_to_delete: 'Виберіть принаймні одне запитання для видалення',
        Select_question_x: 'Вибрати запитання {0}',
        Share: 'Поділитися',
        Share_survey: 'Доступ до опитування',
        Show_more: 'Показати більше',
        Show_response: 'Показати вашу відповідь',
        Showing_x_responses_of_total_y_responses: 'Відображається відповідей: {0} з {1}',
        Start_moving_element_x: 'Початок переміщення елемента: {0}',
        Started: 'Розпочато',
        Statement_x: 'Твердження {0}',
        Statements_rows: 'Твердження (рядки)',
        Student_satisfaction_cafeteria: 'задоволеність учнів стравами в меню їдальні',
        Submit_answer: 'Надіслати відповідь',
        Submitted: 'Надіслано',
        Submitted_after_deadline: 'Надіслано після кінцевого терміну',
        Sunday: 'Неділя',
        Survey: 'Опитування',
        Survey_inactive_message: 'Це опитування більше не доступне. Ви зможете продовжити з ним роботу пізніше, якщо воно знову стане доступним.',
        Survey_start_page: 'Стартова сторінка опитування',
        Survey_title: 'Опитування',
        Survey_type: 'Тип опитування',
        Take_survey: 'Пройти опитування',
        Thanks_for_taking_the_survey: 'Дякуємо, що взяли участь в опитуванні!',
        The_survey_is_about: 'Тема опитування',
        Thursday: 'Четвер',
        Tips_and_examples: 'Поради та приклади',
        Tips_and_examples_info: 'Для оптимальних результатів від служби штучного інтелекту вхідні дані мають бути лаконічними й короткими. Не пишіть «Це опитування про...» — надісланий нами текст міститиме цю інформацію. Приклади вхідних даних:',
        Tuesday: 'Вівторок',
        Unknown_error: 'Сталася помилка. Можливо, виникли проблеми з нашою службою, хтось редагує опитування або ваше підключення до мережі нестабільне. Якщо з підключенням усе гаразд, але це повідомлення зникає, зверніться до адміністратора.',
        View_question_x_of_y: 'Переглянути запитання {0} з {1}',
        Wednesday: 'Середа',
        Yes: 'Так',
        Yes_no_question: 'Запитання типу «Так/Ні»',
        Your_response_will_not_be_saved: 'Ваша відповідь не буде збережена.',
    },
    'zh-CN': {
        Add_alternative: '添加备选项',
        Add_question: '添加问题',
        Add_question_x: '添加问题 {0}',
        Add_statement: '添加陈述',
        Agreement: '协议',
        Agreement_Agree: '同意',
        Agreement_Disagree: '反对',
        Agreement_Neither_Agree_Nor_Disagree: '既不同意也不反对',
        Agreement_Strongly_Agree: '强烈同意',
        Agreement_Strongly_Disagree: '强烈反对',
        Allow_respondents_to_select_more_than_one_alternative: '允许答复者选择多个备选项',
        Alternative_x: '备选项 {0}',
        Alternatives: '备选项',
        Alternatives_columns: '备选项（列）',
        Anonymous: '匿名',
        Anonymous_responses: '匿名',
        Answer_type: '答案类型',
        Answer_was_cleared: '答案已清除',
        Ask_our_AI_info_message: '让我们的人工智能 (AI) 机器人为您生成调查问卷。默认情况下，您将获得介绍和多选题。生成调查问卷后，您可以查看和编辑调查问卷。有关更多详细信息，请参阅下面的提示。',
        Autoloading: '自动加载',
        Avatar: '头像',
        Back_to_list_of_questions: '返回到问题列表',
        Back_to_responses: '返回到答复',
        Back_to_survey_details: '返回至调查问卷详情',
        Cancel: '取消',
        Clear_answer: '清除答案',
        Close: '关闭',
        Continue_survey: '继续填写调查问卷',
        Copy_public_link: '复制公共链接',
        Copy_QR_code: '复制二维码',
        Create_survey: '创建调查问卷',
        Create_survey_with_AI: '使用 AI 创建调查问卷',
        Custom: '自定义',
        DateFormat_just_now: '刚才',
        DateFormat_one_hour_ago: '1 小时前',
        DateFormat_one_minute_ago: '1 分钟前',
        DateFormat_weekday_x_at_y: '{0} {1}',
        DateFormat_x_days_ago: '{0} 天前',
        DateFormat_x_hours_ago: '{0} 小时前',
        DateFormat_x_minutes_ago: '{0} 分钟前',
        DateFormat_yesterday_at_x: '昨天 {0}',
        Deadline_has_passed_message: '截止日期已过，您将无法再提交答复。稍后如果截止日期延长，您可以继续。',
        Delete: '删除',
        Delete_questions_modal_title: '删除选定的问题？',
        Delete_responses: '删除答复？',
        Download_responses: '下载答复 (Excel)',
        Edit_question: '编辑问题',
        Edit_question_x_of_y: '编辑第 {0} 个问题，共 {1} 个',
        Edit_settings_info: '有人开始填写调查问卷后，无法编辑匿名设置。',
        Edit_survey: '编辑调查问卷',
        Element_has_been_moved_to_position_x_of_y: '元素已移动到位置 {0}，共 {1} 个元素',
        Emojis: '表情符号',
        Empty_state_no_responses_heading: '尚无答复',
        Empty_state_no_responses_text: '有人开始填写调查问卷后，答复就会显示在此处。',
        Empty_survey_input_message: '您需要写下调查问卷的内容。',
        Evaluation_of_the_teaching: '科学课教学方法评价',
        Exit_preview: '退出预览',
        Exit_survey: '退出调查问卷？',
        Exit_survey_button: '退出调查问卷',
        External_and_anonymous: '外部和匿名。任何有链接的人都可以答复。',
        External_survey: '外部 - 任何知道链接的人都可以答复',
        Frequency: '频率',
        Frequency_Always: '总是',
        Frequency_Never: '从不',
        Frequency_Often: '经常',
        Frequency_Rarely: '很少',
        Frequency_Sometimes: '有时',
        Friday: '星期五',
        Generate_survey: '生成调查问卷',
        Grid_no_questions_heading: '没有问题',
        Grid_no_questions_text: '您尚未创建任何问题。',
        Homework_habits: '家庭作业习惯',
        How_does_this_work: '怎样进行的？',
        How_does_this_work_info_part1: '您输入的内容将用作提示，我们发出去后将进行进一步处理。根据回复，我们生成了一项包含介绍和多选题的调查问卷，其中包含 5 个答案选项（从“非常同意”到“非常不同意”）。在分发调查问卷之前，您将能够编辑和调整所有内容。',
        How_does_this_work_info_part2: 'itslearning 不对生成的调查问卷内容负责。我们不会审核 AI 服务的响应，因为 AI 服务可能会生成有关人员、地点或事实的不准确信息。我们连接的服务由 OpenAI 提供，使用 GPT-3.5-turbo 聊天模型。',
        Importance: '重要性',
        Importance_Extremely_Important: '极其重要',
        Importance_Moderately_Important: '中等重要',
        Importance_Not_At_All_Important: '一点也不重要',
        Importance_Slightly_Important: '有点重要',
        Importance_Very_Important: '非常重要',
        Imported_rich_text_edit_warning: '此文本是从旧调查问卷工具导入的。保存时，将移除所有格式和富文本内容（例如图像）。',
        Introduction: '介绍',
        Link_copied_to_clipboard: '链接已复制到剪贴板',
        Link_to_survey: '调查问卷链接',
        Matrix_question: '矩阵式问题',
        Monday: '星期一',
        Move_element_instructions: '要移动此元素，请按空格键并使用向上或向下箭头。再次按空格键完成。',
        Moving_element_to_position_x_of_y: '正在将元素移动到位置 {0}，共 {1} 个元素',
        Multiple_choice_question: '单选题',
        Next: '下一步',
        No: '否',
        No_respondents: '没有答复者',
        Not_anonymous: '非匿名',
        Not_possible_to_edit_questions_message: '您无法再添加、编辑或删除问题，因为有人已开始填写此调查问卷。',
        Note: '注解',
        Number_of_questions: '问题数',
        Number_of_respondents_x: '答复者数量：{0}',
        Number_responded_x: '答复数量：{0}',
        Numbers: '数字',
        Ok: '确定',
        Open_answer_heading: '答案',
        Open_question: '开放式问题',
        Personal_data_warning: '请勿输入任何个人或版权信息。您输入的内容将从欧盟以外的 itslearning 发出去进行处理。有关更多详细信息，请参阅“怎样进行的”部分。',
        Preview_survey: '预览调查问卷',
        Previous: '上一步',
        Print: '打印',
        QR_code: '二维码',
        QR_code_copied_to_clipboard: '二维码图像已复制到剪贴板',
        Quality: '质量',
        Quality_Excellent: '极好',
        Quality_Fair: '一般',
        Quality_Good: '好',
        Quality_Poor: '差',
        Quality_Very_Poor: '很差',
        Question: '问题',
        Question_has_been_saved: '问题已保存。',
        Question_number_header: '问题编号',
        Question_type: '问题类型',
        Question_type_short: '类型',
        Question_x: '问题 {0}',
        Question_x_of_y: '第 {0} 个问题，共 {1} 个',
        Questions: '问题',
        QuestionType_MultipleChoice_short: '多选题',
        QuestionType_YesNo_short: '是/否',
        Remember_visible: '请记住，调查问卷必须对受访者可见。',
        Remember_visible_and_deadline: '请记住，调查问卷必须对受访者可见，截止日期必须是将来时间。',
        Remove_alternative_x: '移除备选项 {0}',
        Remove_statement_x: '移除陈述 {0}',
        Respondent: '回应者',
        Responses: '答复',
        Responses_summary: '摘要',
        Responses_x: '答复：{0}',
        Satisfaction: '满意',
        Satisfaction_Completely_Satisfied: '完全满意',
        Satisfaction_Moderately_Satisfied: '中等满意',
        Satisfaction_Not_At_All_Satisfied: '一点也不满意',
        Satisfaction_Slightly_Satisfied: '略微满意',
        Satisfaction_Very_Satisfied: '非常满意',
        Saturday: '星期六',
        Save: '保存',
        Save_and_new: '保存和新建',
        Search: '搜索',
        Search_for_respondents: '搜索答复者',
        Select_a_response_to_delete: '选择要删除的答复',
        Select_all_questions: '选择所有问题',
        Select_at_least_one_question_to_delete: '至少选择一个要删除的问题',
        Select_question_x: '选择问题 {0}',
        Share: '共享',
        Share_survey: '分享调查问卷',
        Show_more: '显示更多',
        Show_response: '显示您的答复',
        Showing_x_responses_of_total_y_responses: '显示 {1} 个答复中的 {0} 个',
        Start_moving_element_x: '开始移动元素：{0}',
        Started: '已开始',
        Statement_x: '陈述 {0}',
        Statements_rows: '陈述（行）',
        Student_satisfaction_cafeteria: '学生对自助餐厅菜单选项的满意度',
        Submit_answer: '提交答案',
        Submitted: '已提交',
        Submitted_after_deadline: '截止日期之后提交',
        Sunday: '星期天',
        Survey: '调查问卷',
        Survey_inactive_message: '此调查问卷不再可用。稍后如果它再次可用，您可以继续。',
        Survey_start_page: '调查问卷起始页面',
        Survey_title: '调查问卷',
        Survey_type: '调查问卷类型',
        Take_survey: '填写调查问卷',
        Thanks_for_taking_the_survey: '感谢您填写调查问卷！',
        The_survey_is_about: '该调查问卷是关于',
        Thursday: '星期四',
        Tips_and_examples: '提示和示例',
        Tips_and_examples_info: '若要从 AI 服务获取有用的输出，请简要输入。不要写“这是一个关于......的调查问卷”，因为这已经包含在我们发送的文本中。输入示例如下：',
        Tuesday: '星期二',
        Unknown_error: '出了点问题。可能是我们的服务出现问题，有人正在编辑调查问卷或您的网络不稳定。如果您的连接正常，并且您仍看到此消息，请联系您的管理者。',
        View_question_x_of_y: '查看第 {0} 个问题，共 {1} 个',
        Wednesday: '星期三',
        Yes: '是',
        Yes_no_question: '是非题',
        Your_response_will_not_be_saved: '将不会保存您的答复。',
    },
};
